(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7394],{

/***/ 36539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mocules_PopupSharing; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(19238);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Modal/Modal.js + 2 modules
var Modal = __webpack_require__(96517);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/OutlinedInput/OutlinedInput.js + 1 modules
var OutlinedInput = __webpack_require__(74061);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Facebook.js
var Facebook = __webpack_require__(60802);
// EXTERNAL MODULE: ./src/clients/PromoClient.js
var PromoClient = __webpack_require__(46128);
// EXTERNAL MODULE: ./src/components-v2/mocules/Spinner/interface.ts
var Spinner_interface = __webpack_require__(92022);
// EXTERNAL MODULE: ./src/context/Auth/index.js + 4 modules
var Auth = __webpack_require__(95581);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/fb.js
var fb = __webpack_require__(33665);
;// CONCATENATED MODULE: ./src/utils/FacebookShare.js














var styleContainer = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "4px",
    backgroundColor: "#4b67b7",
    padding: "4px 6px",
    color: "#fff",
    fontFamily: "ggsm",
    borderRadius: "4px",
    maxWidth: "max-content"
};
var styleWrapper = {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    alignItems: "center",
    textAlign: "center",
    justifyContent: "space-between",
    position: "relative"
};
var styleFacebookIframe = {
    display: "flex",
    alignItems: "center",
    height: "100%",
    position: "relative"
};
// const domainTs = 'https://thuocsi.vn';
var currentTime = new Date().getTime();
var checkNextSymbol = function(link) {
    var regex = /[?]\w/g;
    if (regex.test(link)) {
        return "&";
    }
    return "?";
};
function FacebookShareButton(param) {
    var _luckyWheelCode = param.luckyWheelCode, luckyWheelCode = _luckyWheelCode === void 0 ? "" : _luckyWheelCode, _isSharePopup = param.isSharePopup, isSharePopup = _isSharePopup === void 0 ? false : _isSharePopup, gamificationDetailID = param.gamificationDetailID, _redirectLink = param.redirectLink, redirectLink = _redirectLink === void 0 ? "" : _redirectLink, setOpenConfirmSharing = param.setOpenConfirmSharing, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, reRenderMission = param.reRenderMission;
    var postInfo = {
        method: "feed",
        name: "Sharing post",
        link: redirectLink || domainTs
    };
    var router = (0,next_router.useRouter)();
    var pathname = router.pathname;
    var user = (0,Auth/* useAuth */.aC)().user;
    var ref = user || {}, accountID = ref.accountID, customerID = ref.customerID;
    var getEnvDomain = function() {
        if (sysconfig/* ENV */.Vi === "prd" || sysconfig/* ENV */.Vi === "uat") {
            return "https://thuocsi.vn";
        }
        return "https://web.v2-stg.thuocsi.vn";
    };
    var domainTs = getEnvDomain() + "/lucky-wheel";
    var completedMission = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            (0,PromoClient/* postGamificationScore */.Fk)((_tmp.type = Spinner_interface/* ENUM_CONDITION_TYPE.SHARE */.gP.SHARE, _tmp.customerID = customerID, _tmp.accountID = accountID, _tmp.action = "share facebook", _tmp.luckyWheelCode = luckyWheelCode, _tmp.gamificationDetailID = gamificationDetailID, _tmp.socialNetwork = Spinner_interface/* ENUM_POPUP_SHARING_ITEM.FACEBOOK */.Li.FACEBOOK, _tmp))
                        ];
                    case 1:
                        _state.sent();
                        _tmp1 = {};
                        return [
                            4,
                            (0,PromoClient/* postShareLog */._h)((_tmp1.customerID = customerID, _tmp1.accountID = accountID, _tmp1.source = isMobile ? "thuocsi-mobile" : "thuocsi-web", _tmp1.page = getEnvDomain() + pathname, _tmp1.screen = pathname.replace("/", ""), _tmp1.shareUrl = redirectLink || domainTs, _tmp1.platform = Spinner_interface/* ENUM_POPUP_SHARING_ITEM.FACEBOOK */.Li.FACEBOOK, _tmp1))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function completedMission() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        (0,fb/* initFBSharing */.$9)();
        return function() {
            (0,fb/* cleanup */.Eq)();
        };
    }, []);
    if (!user) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    if (isSharePopup) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
            item: true,
            xs: 3,
            md: 3,
            style: styleWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fb-share-button lucky-wheel-fb-share-btn",
                    style: styleFacebookIframe,
                    "data-href": redirectLink || domainTs,
                    "data-layout": "button",
                    "data-size": "large",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        target: "_blank",
                        href: "http://www.facebook.com/sharer.php?&u=".concat(encodeURIComponent(redirectLink || domainTs)),
                        onClick: completedMission,
                        className: "fb-xfbml-parse-ignore",
                        children: "."
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    children: "Facebook"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "fb-button-share",
                style: styleContainer,
                onClick: function() {
                    FBCheckLogin({
                        postInfo: postInfo,
                        user: user,
                        luckyWheelCode: luckyWheelCode,
                        gamificationDetailID: gamificationDetailID,
                        setOpenConfirmSharing: setOpenConfirmSharing,
                        reRenderMission: reRenderMission
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Facebook/* default */.Z, {}),
                    " Chia sẻ"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://connect.facebook.net/en_GB/all.js#xfbml=1&appId=".concat(sysconfig/* FACEBOOK_APP_ID */.lZ),
                strategy: "lazyOnload"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/constants/Images/index.js
var Images = __webpack_require__(13270);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./src/utils/ImageFallback.tsx
var ImageFallback = __webpack_require__(43931);
;// CONCATENATED MODULE: ./src/utils/zalo.js
/* eslint-disable prefer-arrow-callback */ /* eslint-disable func-names */ /* eslint-disable prefer-const */ /* eslint-disable no-undef */ /**
 *
 * @param {*} noInsertScript
 */ 
function init() {
    var zaloShareBtn = document.getElementById("zaloShareBtn");
    if (zaloShareBtn) {
        zaloShareBtn.setAttribute("data-oaid", sysconfig/* ZALO_APP_ID */.SS);
    }
    (function(d, s, id) {
        var js;
        var fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = "https://sp.zalo.me/plugins/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "zalo-jssdk");
}
/**
 * Cleanup Zalo SDK
 */ function cleanup() {
    (function(d, id) {
        var target = d.getElementById(id);
        if (target) {
            target.parentNode.removeChild(target);
        }
    })(document, "zalo-jssdk");
    delete window.ZALO;
}

// EXTERNAL MODULE: ./src/utils/ZaloShare/styles.module.css
var styles_module = __webpack_require__(55920);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/utils/ZaloShare/index.js



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

















var ZaloShareContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-97dd1fc7-0"
})(_templateObject(), function() {
    return "\n    .zalo-share-button {\n      // width: 60px!important;\n      // height: 60px!important;\n      // display: flex !important;\n      // justify-content: center\n    }\n  ";
});
var ZaloShare_styleWrapper = {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    alignItems: "center",
    textAlign: "center",
    minWidth: 60,
    justifyContent: "space-between"
};
// const domainTs = 'https://thuocsi.vn';
var ZaloShare_currentTime = new Date().getTime();
function ZaloShareButton(param) {
    var _redirectLink = param.redirectLink, redirectLink = _redirectLink === void 0 ? "" : _redirectLink, _isSharePopup = param.isSharePopup, isSharePopup = _isSharePopup === void 0 ? false : _isSharePopup, _luckyWheelCode = param.luckyWheelCode, luckyWheelCode = _luckyWheelCode === void 0 ? "" : _luckyWheelCode, gamificationDetailID = param.gamificationDetailID, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var user = (0,Auth/* useAuth */.aC)().user;
    var ref = user || {}, customerID = ref.customerID, accountID = ref.accountID;
    var router = (0,next_router.useRouter)();
    var pathname = router.pathname;
    var ref1 = (0,react.useState)(true), isAllowCheckActive = ref1[0], setAllowCheckActive = ref1[1];
    var allowCheckActiveRef = (0,react.useRef)(isAllowCheckActive);
    var getEnvDomain = function() {
        if (sysconfig/* ENV */.Vi === "prd" || sysconfig/* ENV */.Vi === "uat") {
            return "https://thuocsi.vn";
        }
        return "https://web.v2-stg.thuocsi.vn";
    };
    var domainTs = getEnvDomain() + "/lucky-wheel";
    var completedMission = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var platform, _tmp, _tmp1;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        platform = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : Spinner_interface/* ENUM_POPUP_SHARING_ITEM.ZALO */.Li.ZALO;
                        _tmp = {};
                        return [
                            4,
                            (0,PromoClient/* postGamificationScore */.Fk)((_tmp.type = Spinner_interface/* ENUM_CONDITION_TYPE.SHARE */.gP.SHARE, _tmp.customerID = customerID, _tmp.accountID = accountID, _tmp.action = platform === Spinner_interface/* ENUM_POPUP_SHARING_ITEM.ZALO */.Li.ZALO ? "share zalo" : "share facebook", _tmp.luckyWheelCode = luckyWheelCode, _tmp.gamificationDetailID = gamificationDetailID, _tmp.socialNetwork = platform, _tmp))
                        ];
                    case 1:
                        _state.sent();
                        _tmp1 = {};
                        return [
                            4,
                            (0,PromoClient/* postShareLog */._h)((_tmp1.customerID = customerID, _tmp1.accountID = accountID, _tmp1.source = isMobile ? "thuocsi-mobile" : "thuocsi-web", _tmp1.page = getEnvDomain() + pathname, _tmp1.screen = pathname.replace("/", ""), _tmp1.shareUrl = redirectLink || domainTs, _tmp1.platform = platform, _tmp1))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function completedMission() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        init(redirectLink);
        var receiveMessage = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    // Check open popup Sharing zalo in case logged
                    if (event.origin === "https://button-share.zalo.me") {
                        if (event.data.cmd === "zsdk_open_share") {
                            setAllowCheckActive(false);
                        }
                        if (event.data.cmd === "zsdk_close_share") {
                            if (luckyWheelCode) {
                                completedMission(Spinner_interface/* ENUM_POPUP_SHARING_ITEM.ZALO */.Li.ZALO);
                                setAllowCheckActive(true);
                            }
                        }
                    }
                    return [
                        2
                    ];
                });
            });
            return function receiveMessage(event) {
                return _ref.apply(this, arguments);
            };
        }();
        window.addEventListener("message", receiveMessage, false);
        var intervalCheckIframe = setInterval(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var callBackPopupSharing, iframeFb, iframeZalo;
            return (0,tslib_es6.__generator)(this, function(_state) {
                callBackPopupSharing = function(platform) {
                    completedMission(platform);
                    document.activeElement.blur();
                };
                iframeFb = document.querySelector(".fb-share-button iframe");
                iframeZalo = document.querySelector("#zaloShareBtn iframe");
                if (allowCheckActiveRef.current) {
                    // listener iframe clicked on case not login
                    if (document.activeElement && document.activeElement === iframeFb) {
                        callBackPopupSharing(Spinner_interface/* ENUM_POPUP_SHARING_ITEM.FACEBOOK */.Li.FACEBOOK);
                    }
                    if (document.activeElement && document.activeElement === iframeZalo) {
                        callBackPopupSharing(Spinner_interface/* ENUM_POPUP_SHARING_ITEM.ZALO */.Li.ZALO);
                    }
                }
                return [
                    2
                ];
            });
        }), 1000);
        return function() {
            cleanup();
            window.removeEventListener("message", receiveMessage);
            clearInterval(intervalCheckIframe);
        };
    }, []);
    (0,react.useEffect)(function() {
        allowCheckActiveRef.current = isAllowCheckActive;
    }, [
        isAllowCheckActive
    ]);
    if (!user) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    if (isSharePopup) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
            item: true,
            xs: 3,
            md: 3,
            style: ZaloShare_styleWrapper,
            children: [
                isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "zaloshareext://shareext?url=".concat(encodeURIComponent(redirectLink || domainTs), "&type=8&version=1"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        target: "_blank",
                        href: "zaloshareext://shareext?url=".concat(encodeURIComponent(redirectLink || domainTs), "&type=8&version=1"),
                        rel: "noreferrer",
                        onClick: function() {
                            return completedMission(Spinner_interface/* ENUM_POPUP_SHARING_ITEM.ZALO */.Li.ZALO);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                            src: Images/* LUCKYWHEEL_SHARE_ZALO_ICON */.n18,
                            alt: "zalo Logo",
                            width: 40,
                            height: 40
                        })
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ZaloShareContainer, {
                    id: "BtnShareContainer",
                    className: (0,clsx/* default */.Z)((styles_module_default()).butonShare_container),
                    dangerouslySetInnerHTML: {
                        __html: '<div\n                id="zaloShareBtn"\n                class="zalo-share-button"\n                data-href='.concat(redirectLink || domainTs, "\n                data-layout=", 4, '\n                data-color="blue"\n                data-customize=', false, "\n              />")
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    style: {
                        color: "#000"
                    },
                    children: "Zalo"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: '<div\n          id="zaloShareBtn"\n          class="zalo-share-button"\n          style={styleContainer}\n          data-href={redirectLink || domainTs}\n          data-layout="4"\n          data-color="blue"\n          data-customize="false"\n        />'
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "zalo-jssdk",
                src: "https://sp.zalo.me/plugins/sdk.js",
                strategy: "lazyOnload"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/LinkedIn.js
var LinkedIn = __webpack_require__(20551);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Telegram.js
var Telegram = __webpack_require__(28341);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Twitter.js
var Twitter = __webpack_require__(44704);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/WifiCalling.js
var WifiCalling = __webpack_require__(91689);
// EXTERNAL MODULE: ./src/components-v2/mocules/SocialSharing/styles.module.css
var SocialSharing_styles_module = __webpack_require__(51055);
var SocialSharing_styles_module_default = /*#__PURE__*/__webpack_require__.n(SocialSharing_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/SocialSharing/index.tsx

















// const domainTs = 'https://thuocsi.vn';
var SocialSharing_currentTime = new Date().getTime();
var SocialSharing = function(param) {
    var socialPlatform = param.socialPlatform, _title = param.title, title = _title === void 0 ? "" : _title, _redirectLink = param.redirectLink, redirectLink = _redirectLink === void 0 ? "" : _redirectLink, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var router = (0,next_router.useRouter)();
    var pathname = router.pathname;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var user = (0,Auth/* useAuth */.aC)().user;
    var ref = user || {}, accountID = ref.accountID, customerID = ref.customerID;
    var getEnvDomain = function() {
        if (sysconfig/* ENV */.Vi === "prd" || sysconfig/* ENV */.Vi === "uat") {
            return "https://thuocsi.vn";
        }
        return "https://web.v2-stg.thuocsi.vn";
    };
    var domainTs = getEnvDomain() + "/lucky-wheel";
    var logShared = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(platform) {
            var _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            (0,PromoClient/* postShareLog */._h)((_tmp.customerID = customerID, _tmp.accountID = accountID, _tmp.source = isMobile ? "thuocsi-mobile" : "thuocsi-web", _tmp.page = getEnvDomain() + "/" + pathname, _tmp.screen = pathname.replace("/", ""), _tmp.shareUrl = redirectLink || domainTs, _tmp.platform = platform, _tmp))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function logShared(platform) {
            return _ref.apply(this, arguments);
        };
    }();
    switch(socialPlatform){
        case "TELEGRAM":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    item: true,
                    xs: 3,
                    md: 3,
                    className: (SocialSharing_styles_module_default()).itemSharing_wrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            className: (SocialSharing_styles_module_default()).itemSharing_block,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "https://t.me/share/url?url=".concat(encodeURIComponent(redirectLink || domainTs), "&text=").concat(title),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    target: "_blank",
                                    href: "https://t.me/share/url?url=".concat(encodeURIComponent(redirectLink || domainTs), "&text=").concat(title),
                                    rel: "noreferrer",
                                    onClick: function() {
                                        return logShared(Spinner_interface/* ENUM_POPUP_SHARING_ITEM.TELEGRAM */.Li.TELEGRAM);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Telegram/* default */.Z, {
                                        style: {
                                            color: "#54a9eb",
                                            width: 40,
                                            height: 40
                                        }
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            children: "Telegram"
                        })
                    ]
                });
            }
        case "TWITTER":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    item: true,
                    xs: 3,
                    md: 3,
                    className: (SocialSharing_styles_module_default()).itemSharing_wrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            className: (SocialSharing_styles_module_default()).itemSharing_block,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "https://twitter.com/intent/tweet?text=".concat(title, "&url=").concat(encodeURIComponent(redirectLink || domainTs)),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    target: "_blank",
                                    href: "https://twitter.com/intent/tweet?text=".concat(title, "&url=").concat(encodeURIComponent(redirectLink || domainTs)),
                                    rel: "noreferrer",
                                    onClick: function() {
                                        return logShared(Spinner_interface/* ENUM_POPUP_SHARING_ITEM.TWITTER */.Li.TWITTER);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Twitter/* default */.Z, {
                                        style: {
                                            color: "#379cec",
                                            width: 40,
                                            height: 40
                                        }
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            children: "Twitter"
                        })
                    ]
                });
            }
        case "VIBER":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    item: true,
                    xs: 3,
                    md: 3,
                    className: (SocialSharing_styles_module_default()).itemSharing_wrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            className: (SocialSharing_styles_module_default()).itemSharing_block,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "viber://forward?text=".concat(encodeURIComponent(title + " " + (redirectLink || domainTs))),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    target: "_blank",
                                    href: "viber://forward?text=".concat(encodeURIComponent(title + " " + (redirectLink || domainTs))),
                                    rel: "noreferrer",
                                    onClick: function() {
                                        return logShared(Spinner_interface/* ENUM_POPUP_SHARING_ITEM.VIBER */.Li.VIBER);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WifiCalling/* default */.Z, {
                                        style: {
                                            color: "#793aaa",
                                            width: 40,
                                            height: 40
                                        }
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            children: "Viber"
                        })
                    ]
                });
            }
        case "LINKEDIN":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    item: true,
                    xs: 3,
                    md: 3,
                    className: (SocialSharing_styles_module_default()).itemSharing_wrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "https://www.linkedin.com/sharing/share-offsite/?url=".concat(encodeURIComponent(redirectLink || domainTs)),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                target: "_blank",
                                href: " https://www.linkedin.com/sharing/share-offsite/?url=".concat(encodeURIComponent(redirectLink || domainTs)),
                                rel: "noreferrer",
                                onClick: function() {
                                    return logShared(Spinner_interface/* ENUM_POPUP_SHARING_ITEM.LINKEDIN */.Li.LINKEDIN);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedIn/* default */.Z, {
                                    style: {
                                        color: "#2563bc",
                                        width: 40,
                                        height: 40
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            children: "Linkedin"
                        })
                    ]
                });
            }
        default:
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
            }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var mocules_SocialSharing = (SocialSharing);

// EXTERNAL MODULE: ./src/components-v2/mocules/PopupSharing/styles.module.css
var PopupSharing_styles_module = __webpack_require__(24908);
var PopupSharing_styles_module_default = /*#__PURE__*/__webpack_require__.n(PopupSharing_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/PopupSharing/index.tsx



















var timer = 3000;
var styleSharing = {
    position: "absolute",
    top: "55%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "#fff",
    borderRadius: "8px",
    boxShadow: 24,
    p: "12px 16px",
    color: "#000",
    display: "flex",
    flexDirection: "column",
    gap: 12
};
var styleMobileSharing = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    bgcolor: "#fff",
    borderRadius: "8px",
    boxShadow: 24,
    p: "12px 16px",
    color: "#000",
    display: "flex",
    flexDirection: "column",
    gap: 12
};
var PopupSharing = function(param) {
    var open = param.open, handleClose = param.handleClose, listItem = param.listItem, _isCopyLink = param.isCopyLink, isCopyLink = _isCopyLink === void 0 ? false : _isCopyLink, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, luckyWheelCode = param.luckyWheelCode, gamificationDetailID = param.gamificationDetailID, _redirectLink = param.redirectLink, redirectLink = _redirectLink === void 0 ? "" : _redirectLink, setOpenConfirmSharing = param.setOpenConfirmSharing, reRenderMission = param.reRenderMission;
    var ref = (0,react.useState)(false), isCopied = ref[0], setCopied = ref[1];
    var handleSaveToClipboard = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var copyText, textArea;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        copyText = document.getElementById("sharingForm_input");
                        // Select the text field
                        if (copyText) {
                            copyText.select();
                            copyText.setSelectionRange(0, 99999); // For mobile devices
                        }
                        if (!(navigator.clipboard && window.isSecureContext)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            navigator.clipboard.writeText(copyText.value)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        textArea = document.createElement("textarea");
                        textArea.value = copyText.value;
                        // Move textarea out of the viewport so it's not visible
                        textArea.style.position = "absolute";
                        textArea.style.left = "-999999px";
                        document.body.prepend(textArea);
                        textArea.select();
                        try {
                            document.execCommand("copy");
                            // Alert the copied text
                            setCopied(true);
                        } catch (error) {
                            console.error(error);
                        } finally{
                            textArea.remove();
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSaveToClipboard() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (isCopied) {
            setTimeout(function() {
                setCopied(false);
            }, timer);
        }
    }, [
        isCopied
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        open: open,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            sx: isMobile ? styleMobileSharing : styleSharing,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    style: {
                        display: "flex",
                        justifyContent: "space-between"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h6",
                            component: "h2",
                            style: {
                                fontFamily: "ggsm"
                            },
                            children: "Chia sẻ"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            onClick: handleClose,
                            style: {
                                padding: 0,
                                width: "32px",
                                height: "32px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                style: {
                                    stroke: "#c0c0c0",
                                    strokeWidth: 1
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    className: (0,clsx/* default */.Z)((PopupSharing_styles_module_default()).sharingContent_wrapper, isMobile && (PopupSharing_styles_module_default()).mobileSharingContent_wrapper),
                    spacing: 2,
                    children: [
                        listItem && (listItem === null || listItem === void 0 ? void 0 : listItem.indexOf(Spinner_interface/* ENUM_POPUP_SHARING_ITEM.FACEBOOK */.Li.FACEBOOK)) >= 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookShareButton, {
                            luckyWheelCode: luckyWheelCode,
                            isSharePopup: true,
                            gamificationDetailID: gamificationDetailID,
                            redirectLink: redirectLink,
                            setOpenConfirmSharing: setOpenConfirmSharing,
                            isMobile: isMobile,
                            reRenderMission: reRenderMission
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_SocialSharing, {
                            title: "Chia sẻ b\xe0i viết tr\xean Telegram",
                            socialPlatform: "TELEGRAM",
                            redirectLink: redirectLink,
                            isMobile: isMobile
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_SocialSharing, {
                            title: "Chia sẻ b\xe0i viết tr\xean Twitter",
                            socialPlatform: "TWITTER",
                            redirectLink: redirectLink,
                            isMobile: isMobile
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_SocialSharing, {
                            title: "Chia sẻ b\xe0i viết tr\xean Linkedin",
                            socialPlatform: "LINKEDIN",
                            redirectLink: redirectLink,
                            isMobile: isMobile
                        }),
                        listItem && (listItem === null || listItem === void 0 ? void 0 : listItem.indexOf(Spinner_interface/* ENUM_POPUP_SHARING_ITEM.ZALO */.Li.ZALO)) >= 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ZaloShareButton, {
                            isSharePopup: true,
                            redirectLink: redirectLink,
                            luckyWheelCode: luckyWheelCode,
                            gamificationDetailID: gamificationDetailID,
                            isMobile: isMobile
                        }),
                        isCopyLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            style: {
                                width: "100%",
                                position: "relative",
                                height: 52
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                                variant: "outlined",
                                className: (PopupSharing_styles_module_default()).sharingContent_formControl,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OutlinedInput/* default */.Z, {
                                    id: "sharingForm_input",
                                    value: "".concat(window.location.host, "/lucky-wheel"),
                                    className: (PopupSharing_styles_module_default()).sharingContent_input,
                                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        style: {
                                            maxWidth: "max-content",
                                            color: "#fff",
                                            whiteSpace: "nowrap",
                                            top: 0,
                                            right: 0,
                                            backgroundColor: "#0fba69",
                                            borderRadius: 30,
                                            textTransform: "unset",
                                            padding: "4px 16px"
                                        },
                                        onClick: handleSaveToClipboard,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                padding: "2px 8px"
                                            },
                                            children: isCopied ? "Đ\xe3 sao ch\xe9p" : "Sao ch\xe9p"
                                        })
                                    }),
                                    classes: {
                                        focused: (PopupSharing_styles_module_default()).sharingContent_inputFocused,
                                        root: (PopupSharing_styles_module_default()).sharingContent_inputFocused
                                    },
                                    readOnly: true
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var mocules_PopupSharing = (PopupSharing);


/***/ }),

/***/ 22806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Spinner; },
  "W": function() { return /* binding */ spinContainer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(19238);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/LinearProgress/LinearProgress.js
var LinearProgress = __webpack_require__(33681);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Modal/Modal.js + 2 modules
var Modal = __webpack_require__(96517);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/NoSsr/NoSsr.js
var NoSsr = __webpack_require__(58769);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CheckCircleOutline.js
var CheckCircleOutline = __webpack_require__(18037);
// EXTERNAL MODULE: ./node_modules/@mui/material/LinearProgress/linearProgressClasses.js
var linearProgressClasses = __webpack_require__(28962);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 1 modules
var styled = __webpack_require__(14745);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/tooltipClasses.js
var tooltipClasses = __webpack_require__(48999);
// EXTERNAL MODULE: ./src/clients/Clients.js + 1 modules
var Clients = __webpack_require__(38307);
// EXTERNAL MODULE: ./src/clients/PromoClient.js
var PromoClient = __webpack_require__(46128);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./src/constants/Images/index.js
var Images = __webpack_require__(13270);
// EXTERNAL MODULE: ./src/context/Auth/index.js + 4 modules
var Auth = __webpack_require__(95581);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./node_modules/events/events.js
var events = __webpack_require__(17187);
var events_default = /*#__PURE__*/__webpack_require__.n(events);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/FormatNumber.js
var FormatNumber = __webpack_require__(44097);
// EXTERNAL MODULE: ./src/utils/ImageFallback.tsx
var ImageFallback = __webpack_require__(43931);
// EXTERNAL MODULE: ./src/utils/ImageUtils.tsx
var ImageUtils = __webpack_require__(81989);
// EXTERNAL MODULE: ./src/utils/NotifyUtils.js
var NotifyUtils = __webpack_require__(25872);
// EXTERNAL MODULE: ./src/components-v2/mocules/PopupSharing/index.tsx + 4 modules
var PopupSharing = __webpack_require__(36539);
// EXTERNAL MODULE: ./src/components-v2/mocules/Spinner/ArrowAnimation/styles.module.css
var styles_module = __webpack_require__(34124);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/Spinner/ArrowAnimation/index.js



var ArrowAnimation = function(param) {
    var _isWhite = param.isWhite, isWhite = _isWhite === void 0 ? false : _isWhite, _classes = param.classes, classes = _classes === void 0 ? "" : _classes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: (0,clsx/* default */.Z)((styles_module_default()).drawArrow, classes),
        width: "138",
        height: "81",
        viewBox: "0 0 138 81",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            id: "Vector 12",
            d: "M3 78.0003C24.3689 71.3566 60 58 67 46.5C74 35 65.7998 29.0198 58.2678 27.0922C54 26 47.5722 27.8723 43.0826 32.2366C34.6385 40.4452 31.8999 57.4484 47.3752 62.0848C64.2223 67.1322 79.7736 60.7288 97.5851 40.5963C115.397 20.4638 121.718 11.3579 128.909 6.99799C133.682 4.10377 129.023 5.06886 125.475 5.06886C120.428 5.06886 118.417 5.33075 119.948 5.06886C124.422 4.30345 129.45 4.35547 133.523 3.19332C137.878 1.95083 131.279 7.06735 130.626 8.01616C128.567 11.0074 126.226 15.8442 126.226 19.5375",
            stroke: isWhite ? "#fff" : "#000",
            strokeWidth: "5",
            strokeLinecap: "round"
        })
    });
};
/* harmony default export */ var Spinner_ArrowAnimation = (ArrowAnimation);

// EXTERNAL MODULE: ./src/components-v2/mocules/Spinner/interface.ts
var Spinner_interface = __webpack_require__(92022);
// EXTERNAL MODULE: ./src/components-v2/mocules/Spinner/styles.module.css
var Spinner_styles_module = __webpack_require__(98174);
var Spinner_styles_module_default = /*#__PURE__*/__webpack_require__.n(Spinner_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/Spinner/index.tsx









































var spinContainer = new (events_default()).EventEmitter();
function getRandomInt(min, max) {
    return Math.random() * (max - min) + min;
}
// const DEG_TO_RAD = Math.PI / 180;
var RAD_TO_DEG = 180 / Math.PI;
var subTitleOOT = "Bạn đ\xe3 hết lượt quay, h\xe3y l\xe0m nhiệm vụ để nhận th\xeam lượt quay nh\xe9.";
var PAGE_DEFAULT = 1;
var LoaderContainer = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
    className: (0,clsx/* default */.Z)((Spinner_styles_module_default()).historyReward_loading),
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
        size: "32px",
        color: "primary"
    })
});
var BorderLinearProgress = (0,styled/* default */.ZP)(LinearProgress/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        height: 20,
        borderRadius: 10
    }, (0,_define_property/* default */.Z)(_obj, "&.".concat(linearProgressClasses/* default.colorPrimary */.Z.colorPrimary), {
        backgroundColor: theme.palette.grey[theme.palette.mode === "light" ? 200 : 800]
    }), (0,_define_property/* default */.Z)(_obj, "& .".concat(linearProgressClasses/* default.bar */.Z.bar), {
        borderRadius: 0,
        backgroundColor: theme.palette.mode === "light" ? "#F29763" : "#F29763"
    }), _obj;
});
var domainTs = "https://thuocsi.vn";
var defaultvalueSpinnerLog = {
    data: [],
    total: 0
};
var LuckyWheelPrizeTooltip = (0,styled/* default */.ZP)(function(_param) // eslint-disable-next-line react/no-children-prop
/*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
        classes: {
            popper: className
        },
        children: props.children,
        title: props.title
    });
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({}, "& .".concat(tooltipClasses/* default.tooltip */.Z.tooltip), {
        backgroundColor: theme.palette.common.white,
        boxShadow: "0px 4px 4px 0px #0000001F;"
    });
});
var drawReward = function(ctx, PI, sweep, img, itemW, itemH, itemX, itemY, text, cx, cy, radius, angle, arcsweep, color) {
    ctx.save();
    // Reward
    ctx.translate(cx * 2, cy * 2);
    ctx.rotate(angle);
    ctx.beginPath();
    // Stroke
    ctx.lineWidth = 5;
    ctx.lineJoin = "round";
    ctx.lineCap = "round";
    ctx.lineTo(0, 0);
    ctx.arc(0, 0, radius, 0, arcsweep);
    ctx.closePath();
    ctx.strokeStyle = "transparent";
    ctx.stroke();
    // Background
    ctx.fillStyle = color !== null && color !== void 0 ? color : "#fff"; // color bg
    ctx.fill();
    // Item
    ctx.rotate(PI / 2 + sweep / 2);
    ctx.drawImage(img, itemX, itemY, itemW, itemH);
    // restore the context to its original state
    ctx.restore();
};
var SpinnerReward = function(param) {
    var isMobile = param.isMobile, source = param.source, propWheelCode = param.propWheelCode;
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var user = (0,Auth/* useAuth */.aC)().user;
    var ref3 = user || {}, accountID = ref3.accountID, customerID = ref3.customerID;
    var ref4 = (0,react.useState)({
        rewards: [],
        luckyWheelCode: "",
        radius: 340,
        rotate: 0,
        easeOut: 0,
        angle: 0,
        top: null,
        offset: null,
        net: null,
        result: null,
        spinning: false,
        isStop: true,
        turns: 0,
        description: "",
        isAcceptFreeTurn: false,
        nextFreeTime: "",
        backgroundWeb: "",
        imageTitleWeb: ""
    }), spinnerInfo = ref4[0], setSpinnerInfo = ref4[1];
    var ref5 = (0,react.useState)(defaultvalueSpinnerLog), spinnerLog = ref5[0], setSpinnerLog = ref5[1];
    var ref6 = (0,react.useState)(Spinner_interface/* ENUM_HISTORY_BOARD_TAB.MISSION */.s9.MISSION), historyBoardTab = ref6[0], setHistoryBoardTab = ref6[1];
    var ref7 = (0,react.useState)(new Map()), rewardIdxMap = ref7[0], setRewardIdxMap = ref7[1];
    var ref8 = (0,react.useState)({
        outOfTurn: false,
        outOfReward: false,
        notFound: false,
        gotPrize: false
    }), isOpenPopup = ref8[0], setOpenPopup = ref8[1];
    var ref9 = (0,react.useState)(0), triggerFetchTurn = ref9[0], setTriggerFetchTurn = ref9[1];
    var ref10 = (0,react.useState)({
        isFetching: false,
        isHasMore: true,
        isLoading: false
    }), historyReward = ref10[0], setHistoryReward = ref10[1];
    var ref11 = (0,react.useState)(PAGE_DEFAULT), pageScroll = ref11[0], setPageScroll = ref11[1];
    var ref12 = (0,react.useState)([]), spinnerMission = ref12[0], setSpinnerMission = ref12[1];
    var ref13 = (0,react.useState)(false), isNextFreeSpin = ref13[0], setNextFreeSpin = ref13[1];
    var ref14 = (0,react.useState)(false), shouldScroll = ref14[0], setShouldScroll = ref14[1];
    var ref15 = (0,react.useState)(), gamificationDetailID = ref15[0], setGamificationDetailID = ref15[1];
    var ref16 = (0,react.useState)(false), isEffectOOT = ref16[0], setEffectOOT = ref16[1];
    var ref17 = (0,react.useState)(false), isShowSharing = ref17[0], setShowSharing = ref17[1];
    var ref18 = (0,react.useState)(domainTs), redirectLink = ref18[0], setRedirectLink = ref18[1];
    var ref19 = (0,react.useState)(true), isLoadingWheel = ref19[0], setLoadingWheel = ref19[1];
    var ref20 = (0,react.useState)([]), mapRewardPosition = ref20[0], setMapRewardPosition = ref20[1];
    var btnSpinRef = (0,react.useRef)(null);
    var btnSpinHeadRef = (0,react.useRef)(null);
    var didMountRef = (0,react.useRef)(false);
    var spinnerInfoRef = (0,react.useRef)(spinnerInfo);
    var renderWheel = function() {
        // determine number/size of sectors that need to created
        var numOptions = spinnerInfo.rewards.length || 0;
        var centralAngle = 360 * (1 / numOptions) * (Math.PI / 180);
        setSpinnerInfo(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                angle: centralAngle
            });
        });
        // get index of starting position of selector
        topPosition(numOptions, centralAngle);
        // dynamically generate sectors from state list
        for(var i = 0; i < numOptions; i += 1){
            renderSector();
        }
    };
    var renderBorder = function() {
        var canvas = document.getElementById("border-wheel");
        if (canvas) {
            var ctx = canvas.getContext("2d");
            var cw = canvas.width;
            var ch = canvas.height;
            var backgroundWheel = new Image();
            backgroundWheel.src = Images/* LUCKYWHEEL_BORDER */.Tng;
            if (ctx) {
                backgroundWheel.onload = function() {
                    ctx.clearRect(0, 0, cw, ch);
                    if (!isMobile) {
                        ctx.drawImage(backgroundWheel, cw - 397.5, ch - 395, cw - 5, ch - 10);
                    } else {
                        ctx.drawImage(backgroundWheel, cw - 290, ch - 290, cw - 20, ch - 20);
                    }
                };
            }
        }
    };
    var renderSelector = function() {
        var canvas = document.getElementById("selector-wheel");
        if (canvas) {
            var ctx = canvas.getContext("2d");
            var cw = canvas.width;
            var ch = canvas.height;
            var selectorWheel = new Image();
            selectorWheel.src = Images/* LUCKYWHEEL_ARROW_SELECTOR */.PzX;
            if (ctx) {
                selectorWheel.onload = function() {
                    ctx.clearRect(0, 0, cw, ch);
                    if (!isMobile) {
                        ctx.drawImage(selectorWheel, cw / 2 - 14, 0, 30, 87);
                    } else {
                        ctx.drawImage(selectorWheel, cw / 2 - 10, 0, 22, 65);
                    }
                };
            }
        }
    };
    var renderCenterWheel = function() {
        var canvas = document.getElementById("center-wheel");
        if (canvas) {
            var ctx = canvas.getContext("2d");
            var cw = canvas.width;
            var ch = canvas.height;
            var backgroundWheel = new Image();
            backgroundWheel.src = Images/* LUCKYWHEEL_CENTER */.gxg;
            if (ctx) {
                backgroundWheel.onload = function() {
                    ctx.clearRect(0, 0, cw, ch);
                    ctx.shadowColor = "black";
                    ctx.shadowBlur = 22;
                    if (!isMobile) {
                        ctx.drawImage(backgroundWheel, cw / 2 - 25, ch / 2 - 25, cw / 8, ch / 8); // 400
                    } else {
                        ctx.drawImage(backgroundWheel, cw / 2 - 17.5, ch / 2 - 17.5, cw / 8, ch / 8);
                    }
                };
            }
        }
    };
    var renderSector = function() {
        var canvas = document.getElementById("wheel");
        if (canvas) {
            var ctx = canvas.getContext("2d");
            var cw = canvas.width * 2;
            var ch = canvas.height * 2;
            var PI = Math.PI;
            var PI2 = PI * 2;
            var rewardCount = spinnerInfo.rewards.length;
            var sweep = PI2 / rewardCount;
            var cx = cw / 8;
            var cy = ch / 8;
            var radius = spinnerInfo.radius;
            if (ctx) {
                initDrawReward(ctx, PI, sweep, cx, cy, radius);
            }
        }
    };
    var topPosition = function(num, angle) {
        // find position of arrow selector
        // set starting index and angle offset based on list length
        // works upto 12 options
        var topSpot = null;
        var degreesOff = null;
        if (num <= 3) {
            if (num === 2) {
                // with set 90deg wheel
                topSpot = num;
                degreesOff = Math.PI / 2;
            }
            if (num === 3) {
                // with set 90deg wheel
                topSpot = num;
                degreesOff = 2 * Math.PI / 3;
            }
        } else {
            topSpot = num;
            degreesOff = 0;
        }
        setSpinnerInfo(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                top: topSpot,
                offset: degreesOff
            });
        });
    };
    var loadImage = function(image) {
        return new Promise(function(resolve, reject) {
            // eslint-disable-next-line no-param-reassign
            image.onload = function() {
                return resolve(image);
            };
            // eslint-disable-next-line no-param-reassign
            image.onerror = function(err) {
                return reject(err);
            };
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var initDrawReward = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(ctx, PI, sweep, cx, cy, radius) {
            var _loop, rewardCount, arrRewardPosition, i;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _loop = function(i) {
                            var _i, name, imageUrl, tmp, bgc, image, err, imageItemW, imageItemH, imageItemX, imageItemY, calcPosition, ref, ref1, ref2, ref3, _tmp;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _i = spinnerInfo.rewards[i], name = _i.itemName, imageUrl = _i.itemUrl, tmp = _i.backgroundColor, bgc = tmp === void 0 ? "#fff" : tmp;
                                        image = new Image();
                                        image.src = (0,ImageUtils/* getLinkCDNImage */.wr)(imageUrl);
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        // eslint-disable-next-line no-await-in-loop
                                        return [
                                            4,
                                            loadImage(image)
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            4
                                        ];
                                    case 3:
                                        err = _state.sent();
                                        console.error("Image loading faild", err);
                                        return [
                                            3,
                                            4
                                        ];
                                    case 4:
                                        imageItemW = 0;
                                        imageItemH = 0;
                                        imageItemX = 0;
                                        imageItemY = 0;
                                        // item is square
                                        if (image.naturalWidth === image.naturalHeight) {
                                            if (rewardCount > 9) {
                                                // item wheelPrizes more than 9, width & height of prize is 116
                                                imageItemW = isMobile ? 116 : 116;
                                                imageItemH = isMobile ? 116 : 116;
                                                imageItemX = isMobile ? -radius + 280 : -radius + 280; // center position between x & y of a piece prize
                                                imageItemY = -radius + 10; // distance from center of wheel
                                            } else {
                                                // item wheelPrizes less than 9, width & height of prize is 128
                                                imageItemW = isMobile ? 128 : 128;
                                                imageItemH = isMobile ? 128 : 128;
                                                imageItemX = isMobile ? -radius + 280 : -radius + 280; // center position between x & y of a piece prize
                                                imageItemY = -radius + 15; // distance from center of wheel
                                            }
                                        }
                                        // case imagePrize upload not is square
                                        if (image.naturalWidth !== image.naturalHeight) {
                                            if (rewardCount >= 10) {
                                                // item wheelPrizes more than 9, width is 128, height is 64
                                                imageItemW = isMobile ? 124 : 128;
                                                imageItemH = isMobile ? 62 : 64;
                                                imageItemX = isMobile ? -radius + 275 : -radius + 275; // center position between x & y of a piece prize
                                                imageItemY = -radius + 20; // distance from center of wheel
                                            } else if (rewardCount > 6 && rewardCount < 10) {
                                                // item wheelPrizes between 6 and 10, make image bigger when prize have fewer prize, width is 148, height is 84
                                                imageItemW = isMobile ? 148 : 148;
                                                imageItemH = isMobile ? 84 : 84;
                                                imageItemX = isMobile ? -radius + 265 : -radius + 265; // center position between x & y of a piece prize
                                                imageItemY = -radius + 20; // distance from center of wheel
                                            } else {
                                                // item wheelPrizes less than 6, make image bigger when prize have fewer prize, width is 204, height is 102
                                                imageItemW = isMobile ? 204 : 204;
                                                imageItemH = isMobile ? 102 : 102;
                                                imageItemX = isMobile ? -radius + 240 : -radius + 240; // center position between x & y of a piece prize
                                                imageItemY = -radius + 20; // distance from center of wheel
                                            }
                                        }
                                        calcPosition = function(image, imageItemW, imageItemH) {
                                            if (image.naturalWidth === image.naturalHeight) {
                                                if (rewardCount >= 10) {
                                                    // case have more than 10 prize, x & y will count from fist base half of circle +- n, make circle all item is around center wheel
                                                    // then mutiply by angle of each prize, Math.cos for x and Math.sin for y
                                                    // plus with w & h of prize then plus error rate
                                                    return {
                                                        x: (265 / 2 + 1) * Math.cos(sweep * i) + imageItemW + 25,
                                                        y: (265 / 2 + 1) * Math.sin(sweep * i) + imageItemH + 25
                                                    };
                                                }
                                                // in case less than 10 items, w & h of prize is bigger, So need adjust a base  and eror rate
                                                return {
                                                    x: (250 / 2 + 3) * Math.cos(sweep * i) + imageItemW + 10,
                                                    y: (250 / 2 + 3) * Math.sin(sweep * i) + imageItemH + 10
                                                };
                                            }
                                            return {
                                                x: 0,
                                                y: 0
                                            };
                                        };
                                        _tmp = {};
                                        if (image) {
                                            ;
                                            ;
                                            arrRewardPosition.push((_tmp.itemX = (ref2 = (ref = calcPosition(image, imageItemW, imageItemH)) === null || ref === void 0 ? void 0 : ref.x) !== null && ref2 !== void 0 ? ref2 : 0, _tmp.itemY = (ref3 = (ref1 = calcPosition(image, imageItemW, imageItemH)) === null || ref1 === void 0 ? void 0 : ref1.y) !== null && ref3 !== void 0 ? ref3 : 0, _tmp.itemW = imageItemW / 2, _tmp.itemH = imageItemH / 2, _tmp.i = i, _tmp.itemName = name, _tmp.itemUrl = imageUrl, _tmp));
                                        }
                                        drawReward(ctx, PI, sweep, image, imageItemW, imageItemH, imageItemX, imageItemY, name, cx, cy, radius, sweep * i, sweep, bgc);
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        rewardCount = spinnerInfo.rewards.length;
                        arrRewardPosition = [];
                        i = 0;
                        _state.label = 1;
                    case 1:
                        if (!(i < rewardCount)) return [
                            3,
                            4
                        ];
                        return [
                            5,
                            (0,tslib_es6.__values)(_loop(i))
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        i++;
                        return [
                            3,
                            1
                        ];
                    case 4:
                        setMapRewardPosition(arrRewardPosition);
                        return [
                            2
                        ];
                }
            });
        });
        return function initDrawReward(ctx, PI, sweep, cx, cy, radius) {
            return _ref.apply(this, arguments);
        };
    }();
    var spin = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, resSpin, currentDate, nextTimeDate, isFreeSpin, ref1, index, itemCode, idx, ref2, specifySpin, fullRots, arcLength, rotMax, rotMin;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // TODO: Get detail reward
                        if (!spinnerInfo.luckyWheelCode) {
                            NotifyUtils/* default.error */.Z.error("Kh\xf4ng t\xecm thấy th\xf4ng tin v\xf2ng quay, vui l\xf2ng thử lại !");
                            return [
                                2
                            ];
                        }
                        currentDate = new Date();
                        if (spinnerInfo.nextFreeTime) {
                            nextTimeDate = new Date(spinnerInfo === null || spinnerInfo === void 0 ? void 0 : spinnerInfo.nextFreeTime);
                        }
                        isFreeSpin = currentDate.getTime() > ((ref = nextTimeDate) === null || ref === void 0 ? void 0 : ref.getTime());
                        if (!(spinnerInfo.isAcceptFreeTurn && isFreeSpin)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,PromoClient/* postSpinLuckyWheel */.PW)(spinnerInfo.luckyWheelCode, "FREE")
                        ];
                    case 1:
                        // free spin
                        resSpin = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            (0,PromoClient/* postSpinLuckyWheel */.PW)(spinnerInfo.luckyWheelCode)
                        ];
                    case 3:
                        resSpin = _state.sent();
                        _state.label = 4;
                    case 4:
                        if ((0,Clients/* isValid */.JY)(resSpin)) {
                            activeButtonSpin();
                            ref1 = (0,Clients/* getFirst */.Xi)(resSpin), index = ref1.index, itemCode = ref1.itemCode;
                            ;
                            if (rewardIdxMap.get(itemCode)) {
                                ;
                                idx = spinnerInfo.top - ((ref2 = rewardIdxMap.get(itemCode)) !== null && ref2 !== void 0 ? ref2 : index); // idx will start at 0
                            } else {
                                // keep allow rotate, accept wrong place spin on, but make sure display correct reward
                                idx = null;
                            }
                            specifySpin = 0;
                            fullRots = Math.floor(Math.random() * 5) + 5; // Full spins the wheel should turn (min = 5, max = 10)
                            if (idx === null) {
                                specifySpin = fullRots * 360;
                            } else {
                                arcLength = 2 * Math.PI / spinnerInfo.rewards.length;
                                rotMax = arcLength * idx + arcLength - arcLength / 5; // reduce 20% width replace for wrong rate
                                rotMin = arcLength * (idx + 1) - arcLength + arcLength / 5; // add 20% width replace for wrong rate
                                specifySpin = fullRots * 360 + getRandomInt(rotMin, rotMax) * RAD_TO_DEG;
                            }
                            setSpinnerInfo(function(prev) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                    rotate: specifySpin,
                                    easeOut: 4,
                                    spinning: true,
                                    isStop: false,
                                    turns: isFreeSpin ? prev.turns : prev.turns - 1
                                });
                            });
                            // calcalute result after wheel stops spinning
                            setTimeout(function() {
                                var formatData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,Clients/* getFirst */.Xi)(resSpin)), {
                                    message: resSpin.message
                                });
                                getResult(formatData);
                            }, 4000);
                        } else {
                            // empty turn wheel
                            switch(resSpin.errorCode){
                                case "NOT_ENOUGH_ITEM":
                                    {
                                        setOpenPopup(function(prev) {
                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                outOfReward: true
                                            });
                                        });
                                        break;
                                    }
                                case "NOT_FOUND":
                                    {
                                        setOpenPopup(function(prev) {
                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                notFound: true
                                            });
                                        });
                                        break;
                                    }
                                default:
                                    {
                                        // remove popup only show effect and change tab
                                        setHistoryBoardTab(Spinner_interface/* ENUM_HISTORY_BOARD_TAB.MISSION */.s9.MISSION);
                                        setEffectOOT(true);
                                        break;
                                    }
                            }
                            inActiveBtnSpin();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function spin() {
            return _ref.apply(this, arguments);
        };
    }();
    var getResult = function(reward) {
        // set state variable to display result
        setSpinnerInfo(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                result: reward,
                isStop: true
            });
        });
        setTriggerFetchTurn(function(prev) {
            return prev + 1;
        });
        setOpenPopup(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                gotPrize: true
            });
        });
    };
    var reset = function() {
        // reset wheel and result
        setSpinnerInfo(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                rotate: 0,
                easeOut: 0,
                result: null,
                spinning: false
            });
        });
    };
    var handleResetPopupPrize = function() {
        // reset wheel and result
        setSpinnerInfo(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                rotate: 0,
                easeOut: 0,
                result: null,
                spinning: false
            });
        });
        inActiveBtnSpin();
        setOpenPopup(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                gotPrize: false
            });
        });
    };
    var handleClosePopup = function() {
        setOpenPopup({
            gotPrize: false,
            outOfReward: false,
            outOfTurn: false,
            notFound: false
        });
    };
    var handleReloadPage = function() {
        router.reload();
    };
    var handlePopupSharing = function() {
        if (router.pathname === "/khuyenmai") {
            setRedirectLink("https://thuocsi.vn/lucky-wheel");
        } else {
            setRedirectLink("https://thuocsi.vn".concat(router.pathname));
        }
        setShowSharing(!isShowSharing);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var handleScrollToBottom = function(e) {
        var bottom = Math.abs(e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight) <= 10;
        if (bottom) {
            if (spinnerLog && (!(spinnerLog === null || spinnerLog === void 0 ? void 0 : spinnerLog.data) || spinnerLog.total <= 20 || (spinnerLog === null || spinnerLog === void 0 ? void 0 : spinnerLog.data.length) >= (spinnerLog === null || spinnerLog === void 0 ? void 0 : spinnerLog.total))) {
                setHistoryReward((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, historyReward), {
                    isHasMore: false
                }));
            }
            if (historyReward.isHasMore && !historyReward.isLoading) {
                setPageScroll(function(prev) {
                    return prev + 1;
                });
            }
        }
    };
    var activeButtonSpin = function() {
        if (btnSpinHeadRef && btnSpinHeadRef.current) {
            var ref;
            btnSpinHeadRef === null || btnSpinHeadRef === void 0 ? void 0 : (ref = btnSpinHeadRef.current) === null || ref === void 0 ? void 0 : ref.classList.add((Spinner_styles_module_default()).btnSpin_active);
        }
    };
    var inActiveBtnSpin = function() {
        if (btnSpinHeadRef && btnSpinHeadRef.current) {
            var ref;
            btnSpinHeadRef === null || btnSpinHeadRef === void 0 ? void 0 : (ref = btnSpinHeadRef.current) === null || ref === void 0 ? void 0 : ref.classList.remove((Spinner_styles_module_default()).btnSpin_active);
        }
    };
    var reRenderMission = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var selfWheelMissionRes, _tmp, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            (0,PromoClient/* getMissionSelfLuckyWheel */.Tj)((_tmp.luckyWheelCode = spinnerInfo.luckyWheelCode, _tmp))
                        ];
                    case 1:
                        selfWheelMissionRes = _state.sent();
                        if ((0,Clients/* isValid */.JY)(selfWheelMissionRes)) {
                            data = selfWheelMissionRes.data;
                            if (data) {
                                setSpinnerMission(data.filter(function(item) {
                                    return item.isActive;
                                }));
                            }
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function reRenderMission() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleFindMoreTurn = function() {
        setHistoryBoardTab(Spinner_interface/* ENUM_HISTORY_BOARD_TAB.MISSION */.s9.MISSION);
        setEffectOOT(true);
        setOpenPopup({
            gotPrize: false,
            outOfReward: false,
            outOfTurn: false,
            notFound: false
        });
    };
    (0,react.useEffect)(function() {
        // get wheel and wheel's log
        (0,_async_to_generator/* default */.Z)(function() {
            var selfWheelRes, ref, ref1, code, items, turns, description, nextFreeTime, isAcceptFreeTurn, isEnableShare, imageTitleWeb, backgroundWeb, selfLogRes, _tmp, selfWheelMissionRes, _tmp1, currentDate, wheelNextFreeTime, checkNextFreeTime, newSpinnerIdxMap, data, total, data1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!propWheelCode) {
                            setLoadingWheel(false);
                            return [
                                2,
                                false
                            ];
                        }
                        return [
                            4,
                            (0,PromoClient/* getSelfLuckyWheelRewards */.ji)(propWheelCode)
                        ];
                    case 1:
                        selfWheelRes = _state.sent();
                        if (!(0,Clients/* isValid */.JY)(selfWheelRes)) return [
                            3,
                            4
                        ];
                        ref1 = (0,Clients/* getFirst */.Xi)(selfWheelRes), code = ref1.code, items = ref1.items, turns = ref1.turns, description = ref1.description, nextFreeTime = ref1.nextFreeTime, isAcceptFreeTurn = ref1.isAcceptFreeTurn, isEnableShare = ref1.isEnableShare, imageTitleWeb = ref1.imageTitleWeb, backgroundWeb = ref1.backgroundWeb;
                        _tmp = {};
                        return [
                            4,
                            (0,PromoClient/* getLogSelfLuckyWheel */.Om)((_tmp.luckyWheelCode = code, _tmp.limit = PAGE_DEFAULT * 20, _tmp))
                        ];
                    case 2:
                        selfLogRes = _state.sent();
                        _tmp1 = {};
                        return [
                            4,
                            (0,PromoClient/* getMissionSelfLuckyWheel */.Tj)((_tmp1.luckyWheelCode = code, _tmp1))
                        ];
                    case 3:
                        selfWheelMissionRes = _state.sent();
                        if (!items || items.length === 0) {
                            setLoadingWheel(false);
                            return [
                                2
                            ];
                        }
                        currentDate = new Date();
                        wheelNextFreeTime = new Date(nextFreeTime);
                        checkNextFreeTime = currentDate.getTime() >= wheelNextFreeTime.getTime();
                        setSpinnerInfo(function(prev) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                luckyWheelCode: code,
                                turns: checkNextFreeTime ? turns + 1 : turns,
                                rewards: (items === null || items === void 0 ? void 0 : items.filter(function(item) {
                                    return item.isActive;
                                }).sort(function(a, b) {
                                    return a.index - b.index;
                                })) || [],
                                description: description,
                                nextFreeTime: nextFreeTime,
                                isAcceptFreeTurn: isAcceptFreeTurn,
                                isEnableShare: isEnableShare,
                                imageTitleWeb: (0,ImageUtils/* getLinkCDNImage */.wr)(imageTitleWeb) || Images/* LUCKYWHEEL_TITLE */.WLR,
                                backgroundWeb: (0,ImageUtils/* getLinkCDNImage */.wr)(backgroundWeb) || Images/* LUCKYWHEEL_DEFAULT_BACKGROUND */.XNs
                            });
                        });
                        newSpinnerIdxMap = new Map((ref = items === null || items === void 0 ? void 0 : items.filter(function(item) {
                            return item.isActive;
                        }).sort(function(a, b) {
                            return a.index - b.index;
                        })) === null || ref === void 0 ? void 0 : ref.map(function(child, idx) {
                            return [
                                child.itemCode,
                                idx + 1
                            ];
                        }));
                        setRewardIdxMap(newSpinnerIdxMap);
                        if ((0,Clients/* isValid */.JY)(selfLogRes)) {
                            data = selfLogRes.data, total = selfLogRes.total;
                            if (data && total && total > 0) {
                                setSpinnerLog(selfLogRes);
                            }
                        }
                        if ((0,Clients/* isValid */.JY)(selfWheelMissionRes)) {
                            data1 = selfWheelMissionRes.data;
                            if (data1) {
                                setSpinnerMission(data1.filter(function(item) {
                                    return item.isActive;
                                }));
                            }
                        }
                        _state.label = 4;
                    case 4:
                        setLoadingWheel(false);
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        triggerFetchTurn,
        isNextFreeSpin,
        propWheelCode
    ]);
    (0,react.useEffect)(function() {
        var ref;
        // render wheel part
        if ((spinnerInfo === null || spinnerInfo === void 0 ? void 0 : (ref = spinnerInfo.rewards) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            renderWheel();
            renderBorder();
            renderSelector();
            renderCenterWheel();
        }
    }, [
        spinnerInfo.rewards
    ]);
    (0,react.useEffect)(function() {
        // fetch more history log
        if (didMountRef.current) {
            (0,_async_to_generator/* default */.Z)(function() {
                var _tmp, _tmp1, selfLogRes, _tmp2, _tmp3, _tmp4, _tmp5, _tmp6;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(pageScroll !== 1)) return [
                                3,
                                2
                            ];
                            _tmp = {};
                            _tmp1 = {};
                            setHistoryReward((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp, historyReward), (_tmp1.isLoading = true, _tmp1)));
                            _tmp2 = {};
                            return [
                                4,
                                (0,PromoClient/* getLogSelfLuckyWheel */.Om)((_tmp2.luckyWheelCode = spinnerInfo.luckyWheelCode, _tmp2.limit = pageScroll * 20, _tmp2))
                            ];
                        case 1:
                            selfLogRes = _state.sent();
                            _tmp3 = {};
                            _tmp4 = {};
                            _tmp5 = {};
                            _tmp6 = {};
                            if (selfLogRes.status === "NOT_FOUND" || !historyReward.isHasMore) {
                                setHistoryReward((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp3, historyReward), (_tmp4.isHasMore = false, _tmp4.isLoading = false, _tmp4)));
                            } else if (historyReward.isHasMore) {
                                if (spinnerLog && spinnerLog.data) {
                                    setSpinnerLog(function(prev) {
                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                            data: (0,_to_consumable_array/* default */.Z)((0,Clients/* getData */.Yu)(selfLogRes)),
                                            total: selfLogRes.total
                                        });
                                    });
                                    setHistoryReward((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp5, historyReward), (_tmp6.isLoading = false, _tmp6)));
                                }
                            }
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            })();
        } else {
            didMountRef.current = true;
        }
        return function() {
            setHistoryReward({
                isFetching: false,
                isHasMore: true,
                isLoading: false
            });
        };
    }, [
        pageScroll
    ]);
    (0,react.useEffect)(function() {
        var intervalFreeSpin = setInterval(function() {
            var ref;
            var currentDate = new Date();
            if (currentDate.getTime() >= new Date(spinnerInfoRef === null || spinnerInfoRef === void 0 ? void 0 : (ref = spinnerInfoRef.current) === null || ref === void 0 ? void 0 : ref.nextFreeTime).getTime()) {
                setNextFreeSpin(true);
            } else {
                setNextFreeSpin(false);
            }
        }, 1000);
        return function() {
            clearInterval(intervalFreeSpin);
        };
    }, []);
    (0,react.useEffect)(function() {
        spinnerInfoRef.current = spinnerInfo;
    }, [
        spinnerInfo
    ]);
    (0,react.useEffect)(function() {
        spinContainer.on("misson", function() {
            setHistoryBoardTab(Spinner_interface/* ENUM_HISTORY_BOARD_TAB.MISSION */.s9.MISSION);
        });
        spinContainer.on("history", function() {
            setHistoryBoardTab(Spinner_interface/* ENUM_HISTORY_BOARD_TAB.HISTORY_REWARD */.s9.HISTORY_REWARD);
        });
        spinContainer.on("guideline", function() {
            setHistoryBoardTab(Spinner_interface/* ENUM_HISTORY_BOARD_TAB.GUILDLINE */.s9.GUILDLINE);
        });
    }, []);
    (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            setShouldScroll(true);
        }, 3000); // Adjust the delay time as needed
        return function() {
            return clearTimeout(timer);
        };
    }, []);
    (0,react.useEffect)(function() {
        var parentEle = document.getElementById("spinnerWrapper");
        if (parentEle) {
            parentEle.scrollLeft = 350;
        }
    }, [
        shouldScroll
    ]);
    (0,react.useEffect)(function() {
        if (isEffectOOT) {
            setTimeout(function() {
                setEffectOOT(false);
            }, 5000);
        }
    }, [
        isEffectOOT
    ]);
    var TitleTooltip = function(param) {
        var name = param.name, url = param.url;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            className: (Spinner_styles_module_default()).tooltipPrizeWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    className: (Spinner_styles_module_default()).tooltipImageWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* default */.ZP, {
                        src: url,
                        alt: name,
                        objectFit: "contain",
                        layout: "fill"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    className: (Spinner_styles_module_default()).tooltipPrizeText,
                    children: name
                })
            ]
        });
    };
    var TempPrizeElement = function(props) {
        var ref;
        var listItem = props.listItem;
        var containerDegree = function() {
            switch(listItem.length){
                case 12:
                    return -90 + 15;
                case 11:
                    return -90 + 16;
                case 10:
                    return -90 + 17;
                case 9:
                    return -90 + 20;
                case 8:
                    return -90 + 23;
                case 7:
                    return -90 + 26;
                case 6:
                    return -90 + 31;
                case 5:
                    return -90 + 37;
                case 4:
                    return -90 + 46;
                case 3:
                    return -90 + 61;
                case 1:
                    return -90 + 181;
                default:
                    return 0;
            }
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            style: {
                position: "absolute",
                height: spinnerInfo === null || spinnerInfo === void 0 ? void 0 : spinnerInfo.radius,
                width: spinnerInfo === null || spinnerInfo === void 0 ? void 0 : spinnerInfo.radius,
                translate: "-50% -50%",
                rotate: containerDegree() + "deg",
                top: "50%",
                left: "50%"
            },
            children: (ref = listItem === null || listItem === void 0 ? void 0 : listItem.sort(function(a, b) {
                return a.i - b.i;
            })) === null || ref === void 0 ? void 0 : ref.map(function(item, idx) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(LuckyWheelPrizeTooltip, {
                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTooltip, {
                        name: item.itemName,
                        url: item.itemUrl
                    }, item.i),
                    style: {
                        backgroundColor: "#fff"
                    },
                    arrow: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "tempPrizePostion_".concat(item.i),
                        style: {
                            width: item.itemW,
                            height: item.itemH,
                            top: item.itemY,
                            left: item.itemX,
                            rotate: "".concat(-90 + item.i * (360 / ((ref = spinnerInfo.rewards) === null || ref === void 0 ? void 0 : ref.length)), "deg"),
                            zIndex: 1
                        },
                        className: (Spinner_styles_module_default()).tempPrizePosition,
                        "data-name": item.itemName,
                        "data-url": item.itemUrl
                    })
                }, "prize_".concat(item.i));
            })
        });
    };
    if (!user || !propWheelCode) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    if (spinnerInfo && ((ref = spinnerInfo.rewards) === null || ref === void 0 ? void 0 : ref.length) === 0) {
        if (!isLoadingWheel) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                width: "100%",
                height: 200,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body1",
                    style: {
                        color: "#000",
                        fontFamily: "ggsr",
                        fontSize: 18,
                        textAlign: "center"
                    },
                    children: "V\xf2ng quay hiện tại chưa diễn ra. Vui l\xf2ng thử lại sau."
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    var _itemImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "spinnerWrapper",
        className: (Spinner_styles_module_default()).spinnerReward_wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
            container: true,
            className: (Spinner_styles_module_default()).luckyWheel_container,
            style: {
                backgroundImage: "url(".concat(spinnerInfo.backgroundWeb, ")")
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    item: true,
                    sm: 3,
                    md: 3,
                    className: (Spinner_styles_module_default()).sectionWheelTitle_container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Spinner_styles_module_default()).wheelTitle_imageWrapper,
                            style: {
                                backgroundImage: "url(".concat(spinnerInfo.imageTitleWeb, ")")
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CountDownLuckyUser, {
                            code: spinnerInfo.luckyWheelCode
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    item: true,
                    sm: 5,
                    md: 5,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        style: {
                            position: "relative",
                            width: "400px",
                            borderRadius: "12px",
                            margin: "0 auto"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                className: (Spinner_styles_module_default()).drawCanvas_container,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: "spin_1",
                                        className: (Spinner_styles_module_default()).luckyWheel_central
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Spinner_styles_module_default()).luckyWheel_borderWheel
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Spinner_styles_module_default()).luckyWheel_selector
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("canvas", {
                                        className: (Spinner_styles_module_default()).canvasContainer,
                                        id: "wheel",
                                        width: "800",
                                        height: "800",
                                        style: {
                                            WebkitTransform: "rotate(".concat(spinnerInfo.rotate - 90, "deg)"),
                                            WebkitTransition: "-webkit-transform ".concat(spinnerInfo.easeOut, "s ease-out"),
                                            zIndex: 0,
                                            width: "100%"
                                        }
                                    }),
                                    isEffectOOT && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner_ArrowAnimation, {
                                        isWhite: true,
                                        classes: (Spinner_styles_module_default()).positionArrowEffect
                                    }),
                                    !spinnerInfo.spinning ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TempPrizeElement, {
                                        listItem: mapRewardPosition
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSpin, {
                                spin: spin,
                                reset: reset,
                                btnSpinHeadRef: btnSpinHeadRef,
                                btnSpinRef: btnSpinRef,
                                isSpinning: spinnerInfo.spinning,
                                isStop: spinnerInfo.isStop,
                                turns: spinnerInfo.turns
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    className: (Spinner_styles_module_default()).boxHistoryReward,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        style: {
                            position: "relative",
                            height: "100%",
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                            item: true,
                            sm: 4,
                            md: 4,
                            className: (Spinner_styles_module_default()).historyBoard,
                            id: "spin_4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                    container: true,
                                    className: (Spinner_styles_module_default()).boardTab,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                            item: true,
                                            sm: 4,
                                            md: 4,
                                            className: (0,clsx/* default */.Z)((Spinner_styles_module_default()).missionTab, historyBoardTab === Spinner_interface/* ENUM_HISTORY_BOARD_TAB.MISSION */.s9.MISSION && (Spinner_styles_module_default()).active),
                                            onClick: function() {
                                                return setHistoryBoardTab(Spinner_interface/* ENUM_HISTORY_BOARD_TAB.MISSION */.s9.MISSION);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                                    src: Images/* LUCKYWHEEL_MISSION_ICON */.B1H,
                                                    alt: "mission icon",
                                                    width: 29,
                                                    height: 40,
                                                    style: {
                                                        userSelect: "none",
                                                        pointerEvents: "none"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    style: {
                                                        textAlign: "center",
                                                        fontFamily: "ggsm"
                                                    },
                                                    children: "Nhiệm vụ"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                            item: true,
                                            sm: 4,
                                            md: 4,
                                            className: (0,clsx/* default */.Z)((Spinner_styles_module_default()).historyReward, historyBoardTab === Spinner_interface/* ENUM_HISTORY_BOARD_TAB.HISTORY_REWARD */.s9.HISTORY_REWARD && (Spinner_styles_module_default()).active),
                                            onClick: function() {
                                                return setHistoryBoardTab(Spinner_interface/* ENUM_HISTORY_BOARD_TAB.HISTORY_REWARD */.s9.HISTORY_REWARD);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                                    src: Images/* LUCKYWHEEL_TIME_ICON */.hnG,
                                                    alt: "mission icon",
                                                    width: 32,
                                                    height: 40,
                                                    style: {
                                                        userSelect: "none",
                                                        pointerEvents: "none"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    style: {
                                                        textAlign: "center",
                                                        fontFamily: "ggsm"
                                                    },
                                                    children: "Lịch sử"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                            item: true,
                                            sm: 4,
                                            md: 4,
                                            className: (0,clsx/* default */.Z)((Spinner_styles_module_default()).guildLine, historyBoardTab === Spinner_interface/* ENUM_HISTORY_BOARD_TAB.GUILDLINE */.s9.GUILDLINE && (Spinner_styles_module_default()).active),
                                            onClick: function() {
                                                return setHistoryBoardTab(Spinner_interface/* ENUM_HISTORY_BOARD_TAB.GUILDLINE */.s9.GUILDLINE);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                                    src: Images/* LUCKYWHEEL_GUILDLINE_ICON */.uf0,
                                                    alt: "guidline icon",
                                                    width: 60,
                                                    height: 40,
                                                    style: {
                                                        userSelect: "none",
                                                        pointerEvents: "none"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    style: {
                                                        textAlign: "center",
                                                        fontFamily: "ggsm"
                                                    },
                                                    children: "Hướng dẫn"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                historyBoardTab === Spinner_interface/* ENUM_HISTORY_BOARD_TAB.HISTORY_REWARD */.s9.HISTORY_REWARD && spinnerLog && spinnerLog.total > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    className: (0,clsx/* default */.Z)((Spinner_styles_module_default()).boardContainer),
                                    children: [
                                        historyReward.isLoading && LoaderContainer,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            className: (Spinner_styles_module_default()).boardContainer_childList,
                                            onScroll: handleScrollToBottom,
                                            children: spinnerLog === null || spinnerLog === void 0 ? void 0 : (ref1 = spinnerLog.data) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                                                var ref;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                    container: true,
                                                    className: (Spinner_styles_module_default()).boardItem_container,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                            item: true,
                                                            md: 3,
                                                            className: (Spinner_styles_module_default()).boardItem_imageWrapper,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* default */.ZP, {
                                                                src: (_itemImage = item.itemImage) !== null && _itemImage !== void 0 ? _itemImage : "",
                                                                width: 80,
                                                                height: 40
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                            item: true,
                                                            md: 9,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                                    variant: "body2",
                                                                    className: (Spinner_styles_module_default()).boardItem_itemName,
                                                                    children: [
                                                                        " ",
                                                                        item === null || item === void 0 ? void 0 : (ref = item.message) === null || ref === void 0 ? void 0 : ref.replace("Nhận được", "").replace("từ v\xf2ng quay may mắn", "")
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: (Spinner_styles_module_default()).boardItem_created,
                                                                    children: (0,format/* default */.Z)(new Date(item.createdTime), "HH:mm dd/MM/yyyy")
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, item.itemCode);
                                            })
                                        })
                                    ]
                                }),
                                historyBoardTab === Spinner_interface/* ENUM_HISTORY_BOARD_TAB.GUILDLINE */.s9.GUILDLINE && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    className: (0,clsx/* default */.Z)((Spinner_styles_module_default()).boardGuildLine),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        className: (Spinner_styles_module_default()).historyBoard_guildContainer,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Spinner_styles_module_default()).historyBoard_guildLineText,
                                            dangerouslySetInnerHTML: {
                                                __html: spinnerInfo.description
                                            }
                                        })
                                    })
                                }),
                                historyBoardTab === Spinner_interface/* ENUM_HISTORY_BOARD_TAB.MISSION */.s9.MISSION && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    className: (0,clsx/* default */.Z)((Spinner_styles_module_default()).boardContainer, isEffectOOT && (Spinner_styles_module_default()).glowOnEffect),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        className: (Spinner_styles_module_default()).boardContainer_childList,
                                        children: (ref2 = spinnerMission === null || spinnerMission === void 0 ? void 0 : spinnerMission.filter(function(item) {
                                            return item.isActive;
                                        })) === null || ref2 === void 0 ? void 0 : ref2.map(function(item) {
                                            var ref, ref1, ref2, ref3, ref4;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                className: (Spinner_styles_module_default()).boardMissionItem_container,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                                variant: "body2",
                                                                className: (Spinner_styles_module_default()).boardMissionItem_itemName,
                                                                children: [
                                                                    " ",
                                                                    item.missionName
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (Spinner_styles_module_default()).boardItemMission_content,
                                                                dangerouslySetInnerHTML: {
                                                                    __html: (item === null || item === void 0 ? void 0 : (ref = item.condition) === null || ref === void 0 ? void 0 : ref.description) || ""
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                className: (0,clsx/* default */.Z)((item === null || item === void 0 ? void 0 : (ref1 = item.processInfos) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && (Spinner_styles_module_default()).processBar_container),
                                                                children: item.processInfos && ((ref2 = item.processInfos) === null || ref2 === void 0 ? void 0 : ref2.map(function(process) {
                                                                    return process.target > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                                        style: {
                                                                            display: "flex",
                                                                            flexDirection: "column",
                                                                            gap: 4
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                                style: {
                                                                                    color: "#000"
                                                                                },
                                                                                variant: "body2",
                                                                                children: process.unitName
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                                                sx: {
                                                                                    width: "100%",
                                                                                    mr: 1,
                                                                                    position: "relative"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BorderLinearProgress, {
                                                                                        variant: "determinate",
                                                                                        value: process.value / process.target > 1 ? 100 : process.value / process.target * 100
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        style: {
                                                                                            position: "absolute",
                                                                                            top: 0,
                                                                                            left: "50%",
                                                                                            transform: "translate(-50%, -5%)",
                                                                                            fontSize: "14px",
                                                                                            fontFamily: "ggsr",
                                                                                            lineHeight: "22px"
                                                                                        },
                                                                                        children: "".concat((0,FormatNumber/* formatNumber */.uf)(process.value), "/").concat((0,FormatNumber/* formatNumber */.uf)(process.target))
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    });
                                                                }))
                                                            })
                                                        ]
                                                    }),
                                                    (item === null || item === void 0 ? void 0 : item.processInfos) && ((ref3 = item === null || item === void 0 ? void 0 : item.processInfos.filter(function(item) {
                                                        return item.isCompleted;
                                                    })) === null || ref3 === void 0 ? void 0 : ref3.length) !== (item === null || item === void 0 ? void 0 : (ref4 = item.processInfos) === null || ref4 === void 0 ? void 0 : ref4.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        style: {
                                                            marginLeft: "auto"
                                                        },
                                                        children: (item === null || item === void 0 ? void 0 : item.condition.actionName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                            style: {
                                                                marginLeft: "auto"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                                    var ref, respScoreDiscover, _tmp, ref1, ref2, _tmp1, ref3, ref4, _tmp2;
                                                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                setGamificationDetailID(item.gamificationDetailID);
                                                                                if (!(item.condition.type === Spinner_interface/* ENUM_CONDITION_TYPE.SHARE */.gP.SHARE)) return [
                                                                                    3,
                                                                                    1
                                                                                ];
                                                                                // case sharing post
                                                                                setRedirectLink(item === null || item === void 0 ? void 0 : (ref = item.condition) === null || ref === void 0 ? void 0 : ref.actionLink);
                                                                                setShowSharing(true);
                                                                                return [
                                                                                    3,
                                                                                    4
                                                                                ];
                                                                            case 1:
                                                                                if (!(item.condition.type === Spinner_interface/* ENUM_CONDITION_TYPE.DISCOVER */.gP.DISCOVER)) return [
                                                                                    3,
                                                                                    3
                                                                                ];
                                                                                _tmp = {};
                                                                                return [
                                                                                    4,
                                                                                    (0,PromoClient/* postGamificationScore */.Fk)((_tmp.type = Spinner_interface/* ENUM_CONDITION_TYPE.DISCOVER */.gP.DISCOVER, _tmp.customerID = customerID, _tmp.accountID = accountID, _tmp.action = "discovery mission", _tmp.luckyWheelCode = spinnerInfo.luckyWheelCode, _tmp.gamificationDetailID = item.gamificationDetailID, _tmp))
                                                                                ];
                                                                            case 2:
                                                                                respScoreDiscover = _state.sent();
                                                                                _tmp1 = {};
                                                                                if (respScoreDiscover.status === "OK") {
                                                                                    if (source === "mobile_app") {
                                                                                        ;
                                                                                        window === null || window === void 0 ? void 0 : (ref1 = window.ReactNativeWebView) === null || ref1 === void 0 ? void 0 : ref1.postMessage(JSON.stringify((_tmp1.type = "deep_link", _tmp1.value = "".concat(item === null || item === void 0 ? void 0 : (ref2 = item.condition) === null || ref2 === void 0 ? void 0 : ref2.actionLink), _tmp1)));
                                                                                    } else {
                                                                                        router.push(item.condition.actionLink || "");
                                                                                    }
                                                                                }
                                                                                return [
                                                                                    3,
                                                                                    4
                                                                                ];
                                                                            case 3:
                                                                                _tmp2 = {};
                                                                                if (source === "mobile_app") {
                                                                                    ;
                                                                                    window === null || window === void 0 ? void 0 : (ref3 = window.ReactNativeWebView) === null || ref3 === void 0 ? void 0 : ref3.postMessage(JSON.stringify((_tmp2.type = "deep_link", _tmp2.value = "".concat(item === null || item === void 0 ? void 0 : (ref4 = item.condition) === null || ref4 === void 0 ? void 0 : ref4.actionLink), _tmp2)));
                                                                                } else {
                                                                                    router.push(item.condition.actionLink || "");
                                                                                }
                                                                                _state.label = 4;
                                                                            case 4:
                                                                                return [
                                                                                    2
                                                                                ];
                                                                        }
                                                                    });
                                                                }),
                                                                className: (0,clsx/* default */.Z)(item.isBlocked ? (Spinner_styles_module_default()).boardMission_disablesBtn : (Spinner_styles_module_default()).boardMissinItem_btn),
                                                                children: item.isBlocked ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    style: {
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: "8px"
                                                                    },
                                                                    children: [
                                                                        "Chưa mở kho\xe1 ",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            src: Images/* LUCKYWHEEL_BLOCKED_ICON */.OZM,
                                                                            width: 15,
                                                                            height: 20
                                                                        }),
                                                                        " "
                                                                    ]
                                                                }) : item.condition.actionName
                                                            })
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                        style: {
                                                            marginLeft: "auto",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            color: "#797979",
                                                            gap: 4
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircleOutline/* default */.Z, {}),
                                                            " Đ\xe3 ho\xe0n th\xe0nh"
                                                        ]
                                                    }),
                                                    (item === null || item === void 0 ? void 0 : item.isBlocked) && (item === null || item === void 0 ? void 0 : item.parentMissionName) !== "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                        style: {
                                                            color: "#D55D2A",
                                                            fontSize: 12
                                                        },
                                                        children: [
                                                            "Ho\xe0n th\xe0nh nhiệm vụ ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                style: {
                                                                    color: "#000"
                                                                },
                                                                children: item === null || item === void 0 ? void 0 : item.parentMissionName
                                                            }),
                                                            " để mở kho\xe1"
                                                        ]
                                                    })
                                                ]
                                            }, item.createdTime);
                                        })
                                    })
                                })
                            ]
                        })
                    })
                }),
                spinnerInfo.isEnableShare && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    className: (Spinner_styles_module_default()).sharingContainer,
                    onClick: function() {
                        return handlePopupSharing();
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            style: {
                                padding: "6px 0 0",
                                height: 40
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                src: Images/* LUCKYWHEEL_SHARE_ICON */.J7Q,
                                alt: "share icon",
                                width: 32,
                                height: 32
                            })
                        }),
                        "Chia sẻ"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupWarning, {
                    open: isOpenPopup.outOfTurn,
                    handleClose: handleClosePopup,
                    title: "Hết lượt quay",
                    subTitle: subTitleOOT,
                    buttonText: "T\xecm th\xeam lượt",
                    type: "turn",
                    handleFindMoreTurn: handleFindMoreTurn
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupWarning, {
                    open: isOpenPopup.outOfReward,
                    handleClose: handleClosePopup,
                    title: "Kh\xf4ng thể tin được !",
                    buttonText: "T\xf4i đ\xe3 hiểu",
                    type: "reward",
                    handleFindMoreTurn: handleFindMoreTurn
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupWarning, {
                    open: isOpenPopup.notFound,
                    handleClose: handleReloadPage,
                    title: "V\xf2ng quay kh\xf4ng khả dụng !",
                    buttonText: "Tải lại trang",
                    subTitle: "Vui l\xf2ng tải lại trang.",
                    type: "not_found",
                    handleFindMoreTurn: handleFindMoreTurn
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupGotPrize, {
                    open: isOpenPopup.gotPrize,
                    handleClose: handleResetPopupPrize,
                    reward: spinnerInfo === null || spinnerInfo === void 0 ? void 0 : spinnerInfo.result
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupSharing/* default */.Z, {
                    open: isShowSharing,
                    handleClose: handlePopupSharing,
                    listItem: [
                        Spinner_interface/* ENUM_POPUP_SHARING_ITEM.FACEBOOK */.Li.FACEBOOK,
                        Spinner_interface/* ENUM_POPUP_SHARING_ITEM.ZALO */.Li.ZALO
                    ],
                    luckyWheelCode: spinnerInfo.luckyWheelCode,
                    gamificationDetailID: gamificationDetailID,
                    redirectLink: redirectLink,
                    reRenderMission: reRenderMission
                })
            ]
        })
    });
};
var ButtonSpin = function(param) {
    var spin = param.spin, reset = param.reset, btnSpinRef = param.btnSpinRef, btnSpinHeadRef = param.btnSpinHeadRef, isSpinning = param.isSpinning, isStop = param.isStop, turns = param.turns;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: btnSpinRef,
        className: (0,clsx/* default */.Z)((Spinner_styles_module_default()).btnSpin_container, !isStop && (Spinner_styles_module_default()).btnSpin_containerDisabled),
        onClick: isSpinning ? reset : spin,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "spin_2",
            style: {
                position: "relative"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: btnSpinHeadRef,
                    className: (Spinner_styles_module_default()).btnSpin_head,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",
                            width: "100%",
                            color: "#fff",
                            fontFamily: "ggsm",
                            fontSize: turns === 0 ? "26px" : "32px",
                            textTransform: "uppercase",
                            userSelect: "none",
                            textShadow: "1px 3px #00000066"
                        },
                        children: turns === 0 ? "Th\xeam lượt" : "Quay"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Spinner_styles_module_default()).btnSpin_bottom,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            justifyContent: "center",
                            alignItems: "flex-end",
                            display: "flex",
                            width: "100%",
                            color: "#fff",
                            fontFamily: "ggsm",
                            position: "absolute",
                            bottom: "5px",
                            userSelect: "none"
                        },
                        children: !turns ? "C\xf2n 0 lượt" : "C\xf2n ".concat(turns || 0, " lượt")
                    })
                })
            ]
        })
    });
};
var style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: "8px",
    boxShadow: 24,
    p: "20px"
};
var PopupWarning = function(param) {
    var open = param.open, handleClose = param.handleClose, title = param.title, subTitle = param.subTitle, buttonText = param.buttonText, type = param.type, isMobile = param.isMobile, handleFindMoreTurn = param.handleFindMoreTurn;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        open: open,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            sx: style,
            style: {
                outline: 0
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    style: {
                        position: "absolute",
                        right: 8,
                        top: 8,
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        color: "#c0c0c0",
                        cursor: "pointer"
                    },
                    onClick: handleClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                        style: {
                            stroke: "#c0c0c0",
                            strokeWidth: 1
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                textAlign: "center",
                                gap: 4
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackStatic */.ez, {
                                    src: Images/* LUCKWHEEL_ICON_WARNING */.hT8,
                                    alt: "warning icon",
                                    width: 40,
                                    height: 40
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h6",
                                    style: {
                                        fontFamily: "ggsm",
                                        lineHeight: "26px"
                                    },
                                    children: title
                                })
                            ]
                        }),
                        type === "reward" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            className: (Spinner_styles_module_default()).popupWarning_subTitle,
                            variant: "body2",
                            children: [
                                "Bạn đ\xe3 sở hữu to\xe0n bộ phần thưởng! ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                " Mong bạn sẽ tiếp tục ủng hộ c\xe1c chương tr\xecnh tiếp theo đến từ thuocsi.vn"
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (Spinner_styles_module_default()).popupWarning_subTitle,
                            variant: "body2",
                            children: subTitle
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    style: {
                        textAlign: "center",
                        marginTop: "12px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: function() {
                            return type === "turn" ? handleFindMoreTurn() : handleClose();
                        },
                        className: (Spinner_styles_module_default()).btnClosePopup,
                        children: buttonText !== null && buttonText !== void 0 ? buttonText : "Đ\xf3ng"
                    })
                })
            ]
        })
    });
};
var PopupGotPrize = function(param) {
    var open = param.open, handleClose = param.handleClose, reward = param.reward;
    var ref;
    var router = (0,next_router.useRouter)();
    var RenderFireWork = function() {
        var numberFireWord = new Set([
            1,
            2,
            3
        ]);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            children: Array.from(numberFireWord, function(child) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Spinner_styles_module_default()).fireWork_effect
                }, child);
            })
        });
    };
    var highLightSplitText = function(text, start, end) {
        if (!text) return text;
        var startIndex = text.indexOf(start);
        var endIndex = text.lastIndexOf(end);
        if (startIndex === -1 || endIndex === -1) {
            return text;
        }
        startIndex += start.length;
        if (startIndex > endIndex) {
            return text;
        }
        return text.substring(startIndex, endIndex);
    };
    var ref1;
    var textHightLight = (ref1 = highLightSplitText(reward === null || reward === void 0 ? void 0 : reward.message, "<strong>", "</strong>")) !== null && ref1 !== void 0 ? ref1 : reward === null || reward === void 0 ? void 0 : reward.message;
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        open: open,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            sx: style,
            style: {
                outline: 0
            },
            children: [
                (reward === null || reward === void 0 ? void 0 : reward.reward) && reward.reward.length > 0 && RenderFireWork(),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    children: [
                        (reward === null || reward === void 0 ? void 0 : reward.itemUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            style: {
                                position: "relative",
                                width: "100%",
                                height: "50px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* default */.ZP, {
                                src: reward.itemUrl,
                                layout: "fill",
                                objectFit: "contain"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (Spinner_styles_module_default()).popupGotPrize_subTitle,
                            variant: "body2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    fontSize: "16px"
                                },
                                dangerouslySetInnerHTML: {
                                    __html: (ref2 = reward === null || reward === void 0 ? void 0 : (ref = reward.message) === null || ref === void 0 ? void 0 : ref.replace("<strong>".concat(textHightLight, "</strong>"), "<span style=\"color: var(--primary-color);font-family: 'ggsm'\">".concat(textHightLight, "</span>"))) !== null && ref2 !== void 0 ? ref2 : ""
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    style: {
                        textAlign: "center",
                        marginTop: "12px",
                        display: "flex",
                        gap: 12,
                        width: "100%",
                        justifyContent: "center"
                    },
                    children: [
                        (reward === null || reward === void 0 ? void 0 : reward.actionName) && (reward === null || reward === void 0 ? void 0 : reward.actionLink) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: function() {
                                return router.push(reward.actionLink || "");
                            },
                            className: (Spinner_styles_module_default()).btnPopupUsing,
                            children: reward.actionName || "Sử dụng ngay"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: handleClose,
                            className: (Spinner_styles_module_default()).btnPopupReset,
                            children: "Tiếp tục"
                        })
                    ]
                })
            ]
        })
    });
};
var CountDownLuckyUser = function(param) {
    var code = param.code;
    var ref = (0,react.useState)([]), luckyUserList = ref[0], setLuckyUserList = ref[1];
    var ref1 = (0,react.useState)(0), offset = ref1[0];
    var ref2 = (0,react.useState)(false), opacity = ref2[0], setOpacity = ref2[1];
    var ref3 = (0,react.useState)([]), currentLuckyUser = ref3[0], setCurrentLuckyUser = ref3[1]; // display 4 for web
    var ref4 = (0,react.useState)(0), currentIdx = ref4[0], setCurrentIdx = ref4[1];
    var luckyUserListRef = (0,react.useRef)(luckyUserList);
    var currentIdxRef = (0,react.useRef)(currentIdx);
    var offsetRef = (0,react.useRef)(offset);
    var filterLuckyUsers = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var luckyUserTarget, i;
            return (0,tslib_es6.__generator)(this, function(_state) {
                setOpacity(false);
                luckyUserTarget = [];
                if (currentIdxRef.current < luckyUserListRef.current.length) {
                    for(i = currentIdxRef.current; i < currentIdxRef.current + 4; i += 1){
                        luckyUserTarget.push(luckyUserListRef.current[i]);
                    }
                }
                setTimeout(function() {
                    if (currentIdxRef.current > luckyUserListRef.current.length) {
                        setOpacity(false);
                        setCurrentLuckyUser([]);
                    } else {
                        setOpacity(true);
                        setCurrentLuckyUser(luckyUserTarget);
                        setCurrentIdx(function(prev) {
                            return prev + 4;
                        }); // 4 user per time
                    }
                }, 500);
                return [
                    2
                ];
            });
        });
        return function filterLuckyUsers() {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchLuckyUser = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var selfLogOtherRes, _tmp, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            (0,PromoClient/* getLogSelfLuckyWheel */.Om)((_tmp.luckyWheelCode = code, _tmp.limit = 20, _tmp.offset = 0, _tmp.type = "OTHER", _tmp))
                        ];
                    case 1:
                        selfLogOtherRes = _state.sent();
                        if ((0,Clients/* isValid */.JY)(selfLogOtherRes)) {
                            data = selfLogOtherRes.data;
                            if (data) {
                                setLuckyUserList(data.map(function(item) {
                                    return item.messageHidden;
                                }));
                                filterLuckyUsers();
                            }
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchLuckyUser() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        fetchLuckyUser();
        var intervalFetchList = setInterval(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var luckyUserResp, _tmp, listMessage;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            (0,PromoClient/* getLogSelfLuckyWheel */.Om)((_tmp.luckyWheelCode = code, _tmp.limit = 20, _tmp.offset = offsetRef.current, _tmp.type = "OTHER", _tmp))
                        ];
                    case 1:
                        luckyUserResp = _state.sent();
                        if ((0,Clients/* isValid */.JY)(luckyUserResp)) {
                            listMessage = (0,Clients/* getData */.Yu)(luckyUserResp).map(function(item) {
                                return item.messageHidden;
                            });
                            setLuckyUserList(function(prev) {
                                return (0,_to_consumable_array/* default */.Z)(prev).concat((0,_to_consumable_array/* default */.Z)(listMessage));
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        }), 100 * 1000);
        var intervalFadeEffect = setInterval(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                filterLuckyUsers();
                return [
                    2
                ];
            });
        }), 25 * 1000);
        return function() {
            clearInterval(intervalFetchList);
            clearInterval(intervalFadeEffect);
        };
    }, []);
    (0,react.useEffect)(function() {
        // Using ref for updating value in interval
        luckyUserListRef.current = luckyUserList;
        currentIdxRef.current = currentIdx;
        offsetRef.current = offset;
    }, [
        luckyUserList,
        currentIdx,
        offset
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSsr/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            display: "flex",
            justifyContent: "center",
            style: {
                transition: "0.8s linear",
                overflow: "hidden"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (0,clsx/* default */.Z)((Spinner_styles_module_default()).luckyUser_container, currentLuckyUser.length === 0 && (Spinner_styles_module_default()).luckyUser_containerHidden),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    className: (0,clsx/* default */.Z)(opacity ? (Spinner_styles_module_default()).show : (Spinner_styles_module_default()).hide, (Spinner_styles_module_default()).luckyUser_messageContent),
                    children: currentLuckyUser === null || currentLuckyUser === void 0 ? void 0 : currentLuckyUser.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (Spinner_styles_module_default()).luckyUser_messageContent,
                            children: item
                        }, index);
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Spinner = (SpinnerReward);


/***/ }),

/***/ 92022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Li": function() { return /* binding */ ENUM_POPUP_SHARING_ITEM; },
/* harmony export */   "gP": function() { return /* binding */ ENUM_CONDITION_TYPE; },
/* harmony export */   "s9": function() { return /* binding */ ENUM_HISTORY_BOARD_TAB; }
/* harmony export */ });
/* unused harmony export ENUM_MOBILE_POPUP_TYPE */
var ENUM_MOBILE_POPUP_TYPE;
(function(ENUM_MOBILE_POPUP_TYPE) {
    ENUM_MOBILE_POPUP_TYPE["MISSON"] = "MISSION";
    ENUM_MOBILE_POPUP_TYPE["HISTORY"] = "HISTORY";
    ENUM_MOBILE_POPUP_TYPE["GUILDLINE"] = "GUILDLINE";
})(ENUM_MOBILE_POPUP_TYPE || (ENUM_MOBILE_POPUP_TYPE = {}));
var ENUM_HISTORY_BOARD_TAB;
(function(ENUM_HISTORY_BOARD_TAB) {
    ENUM_HISTORY_BOARD_TAB["HISTORY_REWARD"] = "REWARD";
    ENUM_HISTORY_BOARD_TAB["GUILDLINE"] = "GUILDLINE";
    ENUM_HISTORY_BOARD_TAB["MISSION"] = "MISSION";
})(ENUM_HISTORY_BOARD_TAB || (ENUM_HISTORY_BOARD_TAB = {}));
var ENUM_POPUP_SHARING_ITEM;
(function(ENUM_POPUP_SHARING_ITEM) {
    ENUM_POPUP_SHARING_ITEM["FACEBOOK"] = "FACEBOOK";
    ENUM_POPUP_SHARING_ITEM["ZALO"] = "ZALO";
    ENUM_POPUP_SHARING_ITEM["TELEGRAM"] = "TELEGRAM";
    ENUM_POPUP_SHARING_ITEM["LINKEDIN"] = "LINKEDIN";
    ENUM_POPUP_SHARING_ITEM["TWITTER"] = "TWITTER";
    ENUM_POPUP_SHARING_ITEM["VIBER"] = "VIBER";
})(ENUM_POPUP_SHARING_ITEM || (ENUM_POPUP_SHARING_ITEM = {}));
var ENUM_CONDITION_TYPE;
(function(ENUM_CONDITION_TYPE) {
    ENUM_CONDITION_TYPE["SHARE"] = "SHARE";
    ENUM_CONDITION_TYPE["DISCOVER"] = "DISCOVER";
})(ENUM_CONDITION_TYPE || (ENUM_CONDITION_TYPE = {}));


/***/ }),

/***/ 97394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Template; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Collapse/Collapse.js
var Collapse = __webpack_require__(66037);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Alert/Alert.js + 4 modules
var Alert = __webpack_require__(8936);
// EXTERNAL MODULE: ./src/constants/Paths/index.js
var Paths = __webpack_require__(199);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/transVersion.js
var transVersion = __webpack_require__(89388);
// EXTERNAL MODULE: ./src/zustand-lib/storeGlobal.js + 2 modules
var storeGlobal = __webpack_require__(31439);
// EXTERNAL MODULE: ./src/components-v2/atoms/AlertSection/styles.module.css
var styles_module = __webpack_require__(97504);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components-v2/atoms/AlertSection/index.js














var AlertSection = function(param) {
    var beta = param.beta, pathname = param.pathname, isMobile = param.isMobile, notifyWidth = param.notifyWidth, marginTopForHeader = param.marginTopForHeader, isAuthenticated = param.isAuthenticated, status = param.status, _isMobileProdPage = param.isMobileProdPage, isMobileProdPage = _isMobileProdPage === void 0 ? false : _isMobileProdPage, _isMobileV2 = param.isMobileV2, isMobileV2 = _isMobileV2 === void 0 ? false : _isMobileV2, _hasMissingLicenses = param.hasMissingLicenses, hasMissingLicenses = _hasMissingLicenses === void 0 ? false : _hasMissingLicenses;
    var KEY_COOKIES = "hasHidden";
    var offNotify = beta;
    var user = (0,storeGlobal/* useStore */.oR)(function(state) {
        return (state === null || state === void 0 ? void 0 : state.user) || {};
    });
    var hasHidden = js_cookie_default().get(KEY_COOKIES);
    var ref = (0,react.useState)(hasHidden !== "true"), open = ref[0], setOpen = ref[1];
    var showTrial = pathname === Paths/* HOME */.Sd || pathname === "/conversations";
    var hideNotifyInTop = [
        "/conversations"
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            !hideNotifyInTop.includes(pathname) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    minHeight: isMobile ? "none" : "".concat(notifyWidth, "px"),
                    marginTop: marginTopForHeader()
                },
                children: [
                    sysconfig/* NOTIFY_IN_TOP_BAR */.FO && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        maxWidth: "lg",
                        style: {
                            maxWidth: "1352px",
                            padding: isMobileProdPage && "7px 16px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                            in: open,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                                severity: "error",
                                action: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    "aria-label": "close",
                                    color: "inherit",
                                    size: "small",
                                    onClick: function() {
                                        js_cookie_default().set(KEY_COOKIES, false, {
                                            domain: sysconfig/* GENERAL_DOMAIN */.oC,
                                            expires: 90,
                                            sameSite: "Lax"
                                        });
                                        setOpen(false);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                        fontSize: "inherit"
                                    })
                                }),
                                style: {
                                    marginTop: "10px",
                                    marginBottom: "5px",
                                    borderRadius: "8px"
                                },
                                children: sysconfig/* NOTIFY_IN_TOP_BAR */.FO
                            })
                        })
                    }),
                    sysconfig/* NOTIFY_IN_TOP_BAR_UIV2 */.Q9 && (0,transVersion/* checkTrialSelected */.QG)(user) && isMobileV2 && showTrial && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        maxWidth: "lg",
                        style: {
                            maxWidth: "1352px",
                            padding: isMobileProdPage && "7px 16px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                            in: open,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                                severity: "info",
                                action: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    "aria-label": "close",
                                    color: "inherit",
                                    size: "small",
                                    onClick: function() {
                                        js_cookie_default().set(KEY_COOKIES, true, {
                                            domain: sysconfig/* GENERAL_DOMAIN */.oC,
                                            expires: 90,
                                            sameSite: "Lax"
                                        });
                                        setOpen(false);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                        fontSize: "inherit"
                                    })
                                }),
                                style: {
                                    marginBottom: "8px",
                                    borderRadius: "8px"
                                },
                                children: sysconfig/* NOTIFY_IN_TOP_BAR_UIV2 */.Q9
                            })
                        })
                    })
                ]
            }),
            isAuthenticated && !offNotify && hasMissingLicenses && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: "lg",
                style: {
                    maxWidth: "1180px"
                },
                disableGutters: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                    severity: "error",
                    style: {
                        marginTop: "16px",
                        marginBottom: "16px",
                        borderRadius: "8px",
                        display: "flex",
                        justifyContent: "center"
                    },
                    className: (styles_module_default()).containerToast,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        className: (styles_module_default()).textError,
                        children: [
                            "T\xe0i khoản của qu\xfd kh\xe1ch chưa đầy đủ giấy ph\xe9p, vui l\xf2ng cập nhật bổ sung giấy tờ. Để cập nhật qu\xfd kh\xe1ch vui l\xf2ng",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "/my-account?tab=3",
                                    children: "bấm v\xe0o đ\xe2y"
                                })
                            }),
                            "."
                        ]
                    })
                })
            }),
            isAuthenticated && !offNotify && !hasMissingLicenses && status !== "ACTIVE" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: "lg",
                style: {
                    maxWidth: "1352px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                    severity: "error",
                    style: {
                        marginTop: "10px",
                        marginBottom: "10px",
                        borderRadius: "8px",
                        display: "flex",
                        justifyContent: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        align: "center",
                        children: [
                            "Lưu \xfd: T\xe0i khoản của qu\xfd kh\xe1ch sẽ kh\xf4ng được k\xedch hoạt nếu qu\xfd kh\xe1ch kh\xf4ng cung cấp đủ c\xe1c th\xf4ng tin được y\xeau cầu. Để ho\xe0n tất qu\xe1 tr\xecnh đăng k\xfd v\xe0 k\xedch hoạt t\xe0i khoản, qu\xfd kh\xe1ch vui l\xf2ng",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                style: {
                                    color: "#0e1983"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "/my-account?tab=3",
                                    children: "bấm v\xe0o đ\xe2y"
                                })
                            }),
                            " ",
                            "v\xe0 cung cấp giấy ph\xe9p của qu\xfd kh\xe1ch hoặc",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                style: {
                                    color: "#0e1983"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://hotro.thuocsi.vn/huong-dan-kich-hoat-tai-khoan-thuocsi-vn/",
                                    children: "xem hướng dẫn tại đ\xe2y."
                                })
                            }),
                            " "
                        ]
                    })
                })
            }),
            (user === null || user === void 0 ? void 0 : user.customerID) && !(user === null || user === void 0 ? void 0 : user.isQuest) && (user === null || user === void 0 ? void 0 : user.isVerify) !== true && [
                Paths/* HOME */.Sd,
                Paths/* CART_URL */.fh
            ].includes(pathname) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: "lg",
                style: {
                    maxWidth: "1180px"
                },
                disableGutters: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                    severity: "error",
                    style: {
                        marginTop: "16px",
                        marginBottom: "16px",
                        borderRadius: "8px",
                        display: "flex",
                        justifyContent: "center"
                    },
                    className: (styles_module_default()).containerToast,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        className: (styles_module_default()).textError,
                        children: [
                            "T\xe0i khoản chưa được x\xe1c thực do thiếu th\xf4ng tin xuất ho\xe1 đơn, vui l\xf2ng cập nhật",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "".concat(Paths/* MY_ACCOUNT */.RX, "?tab=5"),
                                    children: "tại đ\xe2y"
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var atoms_AlertSection = (AlertSection);

// EXTERNAL MODULE: ./src/components-v2/layout/Header/index.js + 22 modules
var Header = __webpack_require__(30203);
// EXTERNAL MODULE: ./src/components-v2/mocules/NewSignInUpModalV2/ConstantsSignIn.ts
var ConstantsSignIn = __webpack_require__(7100);
// EXTERNAL MODULE: ./src/components/atoms/Button/index.js
var Button = __webpack_require__(23600);
// EXTERNAL MODULE: ./src/components/atoms/HeadPage/index.js
var HeadPage = __webpack_require__(57894);
// EXTERNAL MODULE: ./src/constants/Enums/index.js
var Enums = __webpack_require__(71569);
// EXTERNAL MODULE: ./src/context/Auth/index.js + 4 modules
var Auth = __webpack_require__(95581);
// EXTERNAL MODULE: ./src/context/Cart/CartContext.js + 2 modules
var CartContext = __webpack_require__(15012);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/components-v2/mocules/Spinner/index.tsx + 1 modules
var Spinner = __webpack_require__(22806);
// EXTERNAL MODULE: ./src/components-v2/atoms/Overlay/styles.module.css
var Overlay_styles_module = __webpack_require__(14337);
var Overlay_styles_module_default = /*#__PURE__*/__webpack_require__.n(Overlay_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/atoms/Overlay/index.tsx



function Overlay(param) {
    var className = param.className, children = param.children, overlayRef = param.overlayRef, style = param.style;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: style,
        ref: overlayRef,
        className: (0,clsx/* default */.Z)((Overlay_styles_module_default()).overlay, className),
        children: children
    });
}
/* harmony default export */ var atoms_Overlay = (Overlay);

// EXTERNAL MODULE: ./node_modules/events/events.js
var events = __webpack_require__(17187);
var events_default = /*#__PURE__*/__webpack_require__.n(events);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/ImageUtils.tsx
var ImageUtils = __webpack_require__(81989);
// EXTERNAL MODULE: ./src/utils/timer.ts
var timer = __webpack_require__(32394);
// EXTERNAL MODULE: ./src/utils/deviceUtils.js
var deviceUtils = __webpack_require__(97121);
// EXTERNAL MODULE: ./src/components-v2/mocules/TourGuidePopover/styles.module.css
var TourGuidePopover_styles_module = __webpack_require__(97159);
var TourGuidePopover_styles_module_default = /*#__PURE__*/__webpack_require__.n(TourGuidePopover_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/TourGuidePopover/Hole.tsx
/* eslint-disable no-param-reassign */ /* eslint-disable @typescript-eslint/no-non-null-assertion */ 





var Hole = function(param) {
    var category = param.category, style = param.style, hole = param.hole, holeRef = param.holeRef, overlayRef = param.overlayRef;
    if (category !== "spotlight") return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0,react.useEffect)(function() {
        if (!overlayRef.current) return;
        var isIOS = (0,deviceUtils/* checkIOS */.f)();
        if (!isIOS) {
            return;
        }
        overlayRef.current.style.mixBlendMode = null;
        setTimeout(function() {
            overlayRef.current.style.mixBlendMode = "hard-light";
        }, 10);
    }, [
        overlayRef.current
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: holeRef,
        id: "hole",
        style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
            top: hole.top,
            left: hole.left,
            width: hole.width,
            height: hole.height
        }),
        className: (TourGuidePopover_styles_module_default()).hole
    });
};
/* harmony default export */ var TourGuidePopover_Hole = (Hole);

;// CONCATENATED MODULE: ./src/components-v2/mocules/TourGuidePopover/TourGuidePopover.tsx











var containerEvents = new (events_default()).EventEmitter();
function TourGuidePopover(props) {
    var ref, ref1;
    var ref2 = (0,react.useState)(false), open = ref2[0], setOpen = ref2[1];
    var ref3 = (0,react.useState)({
        highlightId: "",
        content: "",
        currentId: "",
        currentStep: 0,
        totalSteps: 0,
        fixedTop: 0,
        x: 0,
        y: 0,
        subAction: undefined,
        direction: "bottom",
        index: 0,
        onNext: function(currentId, subAction) {
        //
        },
        onBack: function(currentId, subAction) {
        //
        },
        image: undefined,
        onClose: function() {
        //
        },
        canBack: false,
        isMobile: false,
        isArrow: true,
        canKnown: false,
        hole: undefined
    }), data = ref3[0], setData = ref3[1];
    var preId = (0,react.useRef)(undefined);
    var holeRef = (0,react.useRef)(null);
    var overlayRef = (0,react.useRef)(null);
    var calTop = function(id) {
        var element = document.getElementById(id);
        if (!element) return;
        var rect = element.getBoundingClientRect();
        var topXCoord = window.scrollX + rect.left + rect.width / 2; // Toạ độ x của giữa top
        var topYCoord = window.scrollY + rect.top; // Toạ độ y của top
        var fixedTop = rect.top;
        return {
            x: topXCoord,
            y: topYCoord,
            max: topYCoord,
            fixedTop: fixedTop,
            hold: {
                left: (window.scrollX || 0) + rect.left,
                width: rect.width,
                top: (window.scrollY || 0) + rect.top,
                height: rect.height
            }
        };
    };
    var calBottom = function(id) {
        var element = document.getElementById(id);
        if (!element) return;
        var rect = element.getBoundingClientRect();
        var bottomXCoord = window.scrollX + rect.left + rect.width / 2; // Toạ độ x của giữa bottom
        var bottomYCoord = window.scrollY + rect.top + rect.height; // Toạ độ y của bottom
        return {
            x: bottomXCoord,
            y: bottomYCoord,
            hold: {
                left: window.scrollX + rect.left,
                width: rect.width,
                top: window.scrollY + rect.top,
                height: rect.height
            }
        };
    };
    var calLeft = function(id) {
        var element = document.getElementById(id);
        if (!element) return;
        var rect = element.getBoundingClientRect();
        var leftXCoord = window.scrollX + rect.left; // Toạ độ x lề trái
        var leftYCoord = window.scrollY + rect.top + rect.height / 2; // Toạ độ y giữa lề trái
        return {
            x: leftXCoord,
            y: leftYCoord,
            hold: {
                left: window.scrollX + rect.left,
                width: rect.width,
                top: window.scrollY + rect.top,
                height: rect.height
            }
        };
    };
    var calRight = function(id) {
        var element = document.getElementById(id);
        if (!element) return;
        var rect = element.getBoundingClientRect();
        var rightXCoord = window.scrollX + rect.left + rect.width; // Toạ độ x lề phải
        var rightYCoord = window.scrollY + rect.top + rect.height / 2; // Toạ độ y giữa lề phải
        return {
            x: rightXCoord,
            y: rightYCoord,
            max: window.scrollX + window.innerWidth - (rect.left + rect.width),
            hold: {
                left: window.scrollX + rect.left,
                width: rect.width,
                top: window.scrollY + rect.top,
                height: rect.height
            }
        };
    };
    var handleClose = function() {
        setOpen(false);
        document.body.style.overflow = "auto"; // Mở lại scroll
    // const stickyTopElement = document.getElementById('sticky_top');
    // if (stickyTopElement) stickyTopElement.style.position = 'sticky';
    // data.onClose?.();
    };
    var handleNext = function(currentId) {
        data.onNext(currentId, data.subAction);
    };
    var handleKnowIt = function() {
        var // const stickyTopElement = document.getElementById('sticky_top');
        // if (stickyTopElement) stickyTopElement.style.position = 'sticky';
        ref;
        setOpen(false);
        document.body.style.overflow = "auto"; // Mở lại scroll
        (ref = data.onClose) === null || ref === void 0 ? void 0 : ref.call(data);
    };
    // useEffect(() => {
    //   return () => {
    //     if (open) {
    //       handleClose();
    //     }
    //   };
    // }, [open]);
    (0,react.useEffect)(function() {
        return function() {
            handleClose();
        };
    }, []);
    (0,react.useEffect)(function() {
        containerEvents.on("push", function(id, content, currentId, currentStep, totalSteps, onNext, onBack, subAction, image, onClose, index, canBack, isMobile, category, isArrow, canKnown, style, offsetVertical, delay, ignoreRecaculate, placement, isScroll) {
            (0,timer/* debounce */.D)(function() {
                // Lấy tọa độ của từng phần tử
                // Lấy tọa độ của từng phần tử
                var preElement = preId.current && document.getElementById(preId.current);
                // const preX = preElement ? window.scrollX + preElement.getBoundingClientRect().left : 0;
                var preY = preElement ? window.scrollY + preElement.getBoundingClientRect().top : 0;
                var element = document.getElementById(id);
                if (!element) return;
                var offset = {
                    x: 0,
                    y: 0,
                    max: 0,
                    direction: "bottom"
                };
                var caculatedOffset = function() {
                    switch(placement){
                        case "top":
                            {
                                var caled = calTop(id);
                                offset.x = (caled === null || caled === void 0 ? void 0 : caled.x) || 0;
                                offset.y = (caled === null || caled === void 0 ? void 0 : caled.y) || 0;
                                offset.max = caled.max;
                                offset.direction = "top";
                                offset.fixedTop = caled === null || caled === void 0 ? void 0 : caled.fixedTop;
                                offset.hole = caled === null || caled === void 0 ? void 0 : caled.hold;
                                break;
                            }
                        case "bottom":
                            {
                                var caled1 = calBottom(id);
                                offset.x = (caled1 === null || caled1 === void 0 ? void 0 : caled1.x) || 0;
                                offset.y = (caled1 === null || caled1 === void 0 ? void 0 : caled1.y) || 0;
                                offset.max = window.scrollX + window.innerHeight - caled1.y;
                                offset.hole = caled1 === null || caled1 === void 0 ? void 0 : caled1.hold;
                                break;
                            }
                        case "left":
                            {
                                var caled2 = calLeft(id);
                                offset.x = (caled2 === null || caled2 === void 0 ? void 0 : caled2.x) || 0;
                                offset.y = (caled2 === null || caled2 === void 0 ? void 0 : caled2.y) || 0;
                                offset.max = (caled2 === null || caled2 === void 0 ? void 0 : caled2.x) || 0;
                                offset.direction = "left";
                                offset.hole = caled2 === null || caled2 === void 0 ? void 0 : caled2.hold;
                                break;
                            }
                        case "right":
                            {
                                var caled3 = calRight(id);
                                offset.x = (caled3 === null || caled3 === void 0 ? void 0 : caled3.x) || 0;
                                offset.y = (caled3 === null || caled3 === void 0 ? void 0 : caled3.y) || 0;
                                offset.max = caled3.max;
                                offset.direction = "right";
                                offset.hole = caled3 === null || caled3 === void 0 ? void 0 : caled3.hold;
                                break;
                            }
                        default:
                            {
                                {
                                    var caled4 = calBottom(id);
                                    offset.x = (caled4 === null || caled4 === void 0 ? void 0 : caled4.x) || 0;
                                    offset.y = (caled4 === null || caled4 === void 0 ? void 0 : caled4.y) || 0;
                                    offset.max = window.scrollX + window.innerHeight - caled4.y;
                                    offset.hole = caled4 === null || caled4 === void 0 ? void 0 : caled4.hold;
                                }
                                {
                                    var caled5 = calRight(id);
                                    if (window.scrollX + window.innerWidth - (caled5.x > 0 ? caled5.x : 0) > offset.max) {
                                        offset.x = (caled5 === null || caled5 === void 0 ? void 0 : caled5.x) || 0;
                                        offset.y = (caled5 === null || caled5 === void 0 ? void 0 : caled5.y) || 0;
                                        offset.max = caled5.max;
                                        offset.direction = "right";
                                        offset.hole = caled5 === null || caled5 === void 0 ? void 0 : caled5.hold;
                                    }
                                }
                                {
                                    var caled6 = calTop(id);
                                    if ((caled6.max > 0 ? caled6.max : 0) > offset.max) {
                                        offset.x = (caled6 === null || caled6 === void 0 ? void 0 : caled6.x) || 0;
                                        offset.y = (caled6 === null || caled6 === void 0 ? void 0 : caled6.y) || 0;
                                        offset.max = caled6.max;
                                        offset.direction = "top";
                                        offset.fixedTop = caled6 === null || caled6 === void 0 ? void 0 : caled6.fixedTop;
                                        offset.hole = caled6 === null || caled6 === void 0 ? void 0 : caled6.hold;
                                    }
                                }
                                {
                                    var caled7 = calLeft(id);
                                    if (((caled7 === null || caled7 === void 0 ? void 0 : caled7.x) || 0) > offset.max) {
                                        offset.x = (caled7 === null || caled7 === void 0 ? void 0 : caled7.x) || 0;
                                        offset.y = (caled7 === null || caled7 === void 0 ? void 0 : caled7.y) || 0;
                                        offset.max = (caled7 === null || caled7 === void 0 ? void 0 : caled7.x) || 0;
                                        offset.direction = "left";
                                        offset.hole = caled7 === null || caled7 === void 0 ? void 0 : caled7.hold;
                                    }
                                }
                                break;
                            }
                    }
                };
                caculatedOffset();
                var data = {
                    highlightId: id,
                    content: content,
                    currentId: currentId,
                    currentStep: currentStep,
                    totalSteps: totalSteps,
                    onNext: onNext,
                    onBack: onBack,
                    subAction: subAction,
                    image: image,
                    onClose: onClose,
                    canBack: canBack || false,
                    index: index || 0,
                    isMobile: isMobile || false,
                    category: category || "spotlight",
                    direction: offset.direction,
                    x: offset.x || 0,
                    y: offset.y || 0,
                    fixedTop: offset.fixedTop,
                    offsetVertical: offsetVertical,
                    hole: offset.hole,
                    canKnown: canKnown,
                    style: style,
                    isArrow: isArrow === undefined ? true : isArrow
                };
                setData(data);
                preId.current = currentId;
                var scrollToElement = function(currentElement) {
                    var elementRect = currentElement.getBoundingClientRect();
                    var offsetFromCenter = window.innerHeight / 2 - elementRect.height / 2 + (offsetVertical || 0);
                    window.scrollTo({
                        top: elementRect.top + window.scrollY - offsetFromCenter,
                        behavior: "smooth"
                    });
                };
                {
                    var currentElement = document.getElementById(currentId);
                    if (!currentElement) return;
                    // const currentX = currentElement ? window.scrollX + currentElement.getBoundingClientRect().left : 0;
                    var currentY = currentElement ? window.scrollY + currentElement.getBoundingClientRect().top : 0;
                    if (Math.abs(currentY - preY) > 200) {
                        if (currentElement) {
                            if (isScroll) scrollToElement(currentElement);
                            if (!ignoreRecaculate) {
                                setTimeout(function() {
                                    if (holeRef.current) {
                                        caculatedOffset();
                                        setData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                                            direction: offset.direction,
                                            x: offset.x || 0,
                                            y: offset.y || 0,
                                            fixedTop: offset.fixedTop,
                                            offsetVertical: offsetVertical,
                                            hole: offset.hole
                                        }));
                                    // Kiểm tra thành công, xóa interval
                                    }
                                }, 400);
                            }
                        }
                    }
                }
            }, delay || 0)();
        });
        containerEvents.on("open", (0,timer/* throttleLeading */.z)(function() {
            document.body.style.overflow = "hidden";
            // const stickyTopElement = document.getElementById('sticky_top');
            // if (stickyTopElement) stickyTopElement.style.position = 'unset';
            setOpen(true);
        }, 300));
        containerEvents.on("close", function() {
            handleClose();
        });
    }, []);
    if (!open) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (TourGuidePopover_styles_module_default()).container,
        children: open && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_Overlay, {
                    style: {
                        mixBlendMode: "hard-light"
                    },
                    overlayRef: overlayRef,
                    className: (TourGuidePopover_styles_module_default()).overlay,
                    children: data.category && data.hole && /*#__PURE__*/ (0,jsx_runtime.jsx)(TourGuidePopover_Hole, {
                        style: data.style,
                        overlayRef: overlayRef,
                        holeRef: holeRef,
                        category: data.category,
                        hole: data.hole
                    })
                }),
                data.category && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip, {
                    top: data.y,
                    left: data.x,
                    text: data.content,
                    currentId: data.currentId,
                    direction: data.direction,
                    current: data.currentStep,
                    total: data.totalSteps,
                    onNext: handleNext,
                    onBack: function(currentId) {
                        data.onBack(currentId, data.subAction);
                    },
                    index: data.index,
                    canBack: data.canBack,
                    isMobile: data.isMobile,
                    category: data.category,
                    image: data.image,
                    handleNext: handleNext,
                    handleKnown: handleKnowIt,
                    fixedTop: data.fixedTop,
                    isArrow: data.isArrow,
                    canKnown: data.canKnown,
                    height: (ref = data.hole) === null || ref === void 0 ? void 0 : ref.height,
                    width: (ref1 = data.hole) === null || ref1 === void 0 ? void 0 : ref1.width
                })
            ]
        })
    });
}
var Tooltip = function(param) {
    var text = param.text, direction = param.direction, top = param.top, left = param.left, currentId = param.currentId, current = param.current, total = param.total, onNext = param.onNext, onBack = param.onBack, index = param.index, canBack = param.canBack, isMobile = param.isMobile, category = param.category, image = param.image, handleNext = param.handleNext, handleKnown = param.handleKnown, fixedTop = param.fixedTop, isArrow = param.isArrow, canKnown = param.canKnown, width = param.width, height = param.height;
    var defaultStyle = isMobile ? {
        zIndex: 9999,
        // position: 'fixed',
        left: "50%",
        transform: "translate(-50%, 0)",
        width: "100vw",
        top: top
    } : {
        top: top || 80,
        left: left || 80,
        display: "flex"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    category === "spotlight" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "tooltip",
                        className: (TourGuidePopover_styles_module_default()).tooltip,
                        style: direction === "bottom" && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultStyle), {
                            top: top + 20,
                            transform: "translate(-50%, ".concat(0, "px)")
                        }) || direction === "top" && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultStyle), {
                            top: top - 20,
                            transform: "translate(-50%, -100%)"
                        }) || direction === "right" && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultStyle), {
                            left: left + 20,
                            top: top,
                            transform: "translate(0, -50%)",
                            alignItems: "center"
                        }) || direction === "left" && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultStyle), {
                            left: left - 20,
                            top: top,
                            transform: "translate(-100%,-50%)",
                            alignItems: "center"
                        }) || defaultStyle,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TourGuidePopover_styles_module_default()).container,
                            children: [
                                isArrow && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        direction === "bottom" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (TourGuidePopover_styles_module_default())["arrow-up"]
                                        }),
                                        direction === "top" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (TourGuidePopover_styles_module_default())["arrow-down"]
                                        }),
                                        direction === "right" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (TourGuidePopover_styles_module_default())["arrow-left"]
                                        }),
                                        direction === "left" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (TourGuidePopover_styles_module_default())["arrow-right"]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (TourGuidePopover_styles_module_default()).wrapper,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (TourGuidePopover_styles_module_default()).contentBox,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (TourGuidePopover_styles_module_default()).content,
                                                children: text
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (TourGuidePopover_styles_module_default()).bottomTip,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        className: (TourGuidePopover_styles_module_default()).step,
                                                        children: index ? "".concat(index, " / ").concat(total) : ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (TourGuidePopover_styles_module_default()).boxButton,
                                                        children: [
                                                            canBack && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                onClick: function() {
                                                                    return onBack(currentId);
                                                                },
                                                                className: (TourGuidePopover_styles_module_default()).buttonBack,
                                                                children: "Quay lại"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                onClick: function() {
                                                                    return onNext(currentId);
                                                                },
                                                                className: (TourGuidePopover_styles_module_default()).buttonNext,
                                                                children: [
                                                                    index !== total && "Tiếp theo",
                                                                    index === total && "T\xf4i đ\xe3 hiểu"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    category === "sheet" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TourGuidePopover_styles_module_default()).imageContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (TourGuidePopover_styles_module_default()).imageTitle,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        alt: "spin_promotion",
                                        src: image,
                                        width: 350,
                                        height: 300,
                                        className: (TourGuidePopover_styles_module_default()).image
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (TourGuidePopover_styles_module_default()).imageContent,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: text
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (TourGuidePopover_styles_module_default()).buttonBox,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: (TourGuidePopover_styles_module_default()).buttonKnown,
                                            onClick: function() {
                                                handleKnown === null || handleKnown === void 0 ? void 0 : handleKnown();
                                            },
                                            children: "T\xf4i đ\xe3 hiểu"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: function() {
                                                onNext(currentId);
                                            },
                                            className: (TourGuidePopover_styles_module_default()).buttonStart,
                                            children: "Bắt đầu"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    category === "sheet" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (TourGuidePopover_styles_module_default()).sheetContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TourGuidePopover_styles_module_default()).sheetBox,
                            children: [
                                image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (TourGuidePopover_styles_module_default()).imageTitle,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (0,ImageUtils/* getLinkCDNImage */.wr)(image.src),
                                        alt: "spin_alt",
                                        width: 200,
                                        height: 150,
                                        className: (TourGuidePopover_styles_module_default()).image
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (TourGuidePopover_styles_module_default()).content,
                                    children: text
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (TourGuidePopover_styles_module_default()).bottomIndicator,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (TourGuidePopover_styles_module_default()).buttonBox,
                                        children: [
                                            canKnown && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: (TourGuidePopover_styles_module_default()).buttonKnown,
                                                onClick: handleKnown,
                                                children: "T\xf4i đ\xe3 hiểu"
                                            }),
                                            handleNext && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: (TourGuidePopover_styles_module_default()).buttonNext,
                                                onClick: function() {
                                                    return handleNext(currentId);
                                                },
                                                children: "Bắt đầu"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    category === "spotlight" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "tooltip",
                        className: (TourGuidePopover_styles_module_default()).tooltip,
                        style: direction === "bottom" && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultStyle), {
                            top: top + 20,
                            transform: "translate(-50%, ".concat(0, "px)")
                        }) || direction === "top" && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultStyle), {
                            top: top - 20,
                            transform: "translate(-50%, -100%)"
                        }) || direction === "right" && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultStyle), {
                            left: left + 20,
                            transform: "translate(100%, -50%)",
                            alignItems: "center"
                        }) || direction === "left" && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultStyle), {
                            left: left - 20,
                            top: top,
                            transform: "translate(-100%,-50%)",
                            alignItems: "center"
                        }) || defaultStyle,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TourGuidePopover_styles_module_default()).container,
                            children: [
                                isArrow && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        direction === "bottom" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (TourGuidePopover_styles_module_default())["arrow-up"]
                                        }),
                                        direction === "top" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (TourGuidePopover_styles_module_default())["arrow-down"]
                                        }),
                                        direction === "right" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (TourGuidePopover_styles_module_default())["arrow-left"]
                                        }),
                                        direction === "left" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (TourGuidePopover_styles_module_default())["arrow-right"]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (TourGuidePopover_styles_module_default()).wrapper,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (TourGuidePopover_styles_module_default()).contentBody,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (TourGuidePopover_styles_module_default()).content,
                                                children: text
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (TourGuidePopover_styles_module_default()).bottomTip,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        className: (TourGuidePopover_styles_module_default()).step,
                                                        children: index ? "".concat(index, " / ").concat(total) : ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (TourGuidePopover_styles_module_default()).boxButton,
                                                        children: [
                                                            canBack && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                onClick: function() {
                                                                    return onBack(currentId);
                                                                },
                                                                className: (TourGuidePopover_styles_module_default()).buttonBack,
                                                                children: "Quay lại"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                onClick: function() {
                                                                    return onNext(currentId);
                                                                },
                                                                className: (TourGuidePopover_styles_module_default()).buttonNext,
                                                                children: [
                                                                    index !== total && "Tiếp theo",
                                                                    index === total && "T\xf4i đ\xe3 hiểu"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TourGuidePopover_TourGuidePopover = (TourGuidePopover);

;// CONCATENATED MODULE: ./src/components-v2/mocules/TourGuidePopover/useGuide.ts

var useGuide = function() {
    return {
        push: function(id, content, currentId, currentStep, totalSteps, onNext, onBack, subAction, image, onClose, index, canBack, isMobile, category, isArrow, canKnown, style, offsetVertical, delay, ignoreRecaculate, placement, isScroll) {
            containerEvents.emit("push", id, content, currentId, currentStep, totalSteps, onNext, onBack, subAction, image, onClose, index, canBack, isMobile, category, isArrow, canKnown, style, offsetVertical, delay, ignoreRecaculate, placement, isScroll);
        },
        open: function() {
            containerEvents.emit("open");
        },
        close: function() {
            containerEvents.emit("close");
        }
    };
};

// EXTERNAL MODULE: ./src/constants/data/guideline/index.tsx + 2 modules
var data_guideline = __webpack_require__(87225);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/services/CustomerService.js
var CustomerService = __webpack_require__(29455);
;// CONCATENATED MODULE: ./src/context/Guide/index.tsx










function GuideContext(param) {
    var isMobile = param.isMobile, children = param.children;
    var guide = useGuide();
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        var guideLine = getGuideLine(router.asPath, isMobile);
        if (!guideLine) return;
        (0,_async_to_generator/* default */.Z)(function() {
            var meGuide, firstId, intervalId;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,CustomerService/* getMeGuide */.iW)(guideLine.feature)
                        ];
                    case 1:
                        meGuide = _state.sent();
                        if (!meGuide.isActive || meGuide.isGuided) return [
                            2
                        ];
                        firstId = handleGuideline(guide, guideLine, isMobile);
                        if (firstId) {
                            intervalId = setInterval(function() {
                                firstId = handleGuideline(guide, guideLine, isMobile);
                                if (!firstId) {
                                    clearInterval(intervalId);
                                }
                            }, 300);
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        router.asPath,
        isMobile
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TourGuidePopover_TourGuidePopover, {}),
            children
        ]
    });
};
function getGuideLine(path, isMobile) {
    switch(path){
        case "/":
            {
                return data_guideline/* allGuideLine.find */.n.find(function(guide) {
                    return guide.page.includes("/") && guide.isMobile === isMobile;
                });
            }
        default:
            {
                if (path.startsWith("/lucky-wheel?wheelCode=")) {
                    return data_guideline/* allGuideLine.0 */.n[0];
                } else {
                    return data_guideline/* allGuideLine.find */.n.find(function(guide) {
                        return guide.page.filter(function(x) {
                            return x !== "/";
                        }).some(function(page) {
                            return path.includes(page) && guide.isMobile === isMobile;
                        });
                    });
                }
            }
    }
}
function handleGuideline(guide, guideline, isMobile) {
    var steps = guideline.data;
    function createGuideStep(index) {
        if (index === -1) {
            guide.close();
            return;
        }
        var step = steps[index];
        var stepElement = document.getElementById(step === null || step === void 0 ? void 0 : step.id);
        var lastElement = document.getElementById(steps[steps.length - 1 >= 0 ? steps.length - 1 : 0].id);
        if (!stepElement || !lastElement) {
            guide.close();
            return;
        }
        if (step.subAction && guideline.feature === data_guideline/* GUIDE_FEATURE.LUCKY_WHEEL */.Z.LUCKY_WHEEL) {
            switch(step.subAction){
                case "misson":
                    {
                        Spinner/* spinContainer.emit */.W.emit("misson");
                        break;
                    }
                case "history":
                    {
                        Spinner/* spinContainer.emit */.W.emit("history");
                        break;
                    }
                case "guideline":
                    {
                        Spinner/* spinContainer.emit */.W.emit("guideline");
                        break;
                    }
                default:
                    {
                        break;
                    }
            }
        }
        guide.push(step.id, step.content, step.id, index + 1, guideline.data.filter(function(x) {
            return Boolean(x.index);
        }).length || 0, function(currentId, subAction) {
            var currentIndex = steps.findIndex(function(x) {
                return x.id === currentId && (subAction ? x.subAction === subAction : true);
            });
            if (currentIndex === -1) return;
            if (currentIndex === steps.length - 1) {
                (0,CustomerService/* updateMeGuide */.VB)({
                    feature: guideline.feature,
                    isViewAll: true
                });
                guide.close();
                return;
            }
            var next = steps[currentIndex + 1];
            var nextIndex = currentIndex + 1;
            if (currentId === next.id) {
                var currentIndex1 = steps.findIndex(function(x) {
                    return x.subAction === subAction;
                });
                if (currentIndex1 === -1) return;
                nextIndex = currentIndex1 + 1;
            }
            if (!next) return;
            createGuideStep(nextIndex);
        }, function(currentId, subAction) {
            var currentIndex = steps.findIndex(function(x) {
                return x.id === currentId && (subAction ? x.subAction === subAction : true);
            });
            if (currentIndex === -1) return;
            var pre = steps[currentIndex - 1];
            var preIndex = currentIndex - 1;
            if (currentId === pre.id) {
                var currentIndex1 = steps.findIndex(function(x) {
                    return x.subAction === subAction;
                });
                if (currentIndex1 === -1) return;
                preIndex = currentIndex1 - 1;
            }
            if (!pre) return;
            createGuideStep(preIndex);
        }, step.subAction, step.image, function() {
            (0,CustomerService/* updateMeGuide */.VB)({
                feature: guideline.feature
            });
        // guide.close();
        }, step.index, step.canBack, isMobile, step.category, step.isArrow, step.canKnown, step.style, step.offsetVertical, step.delay, guideline.ignoreRecaculate, step.placement, step === null || step === void 0 ? void 0 : step.isScroll);
    }
    var initialStep = steps[0];
    var checkFirstElement = document.getElementById(initialStep.id);
    if (!checkFirstElement) {
        return initialStep.id;
    }
    createGuideStep(0);
    guide.open();
}

// EXTERNAL MODULE: ./node_modules/@firebase/app/dist/esm/index.esm2017.js + 1 modules
var index_esm2017 = __webpack_require__(44164);
// EXTERNAL MODULE: ./node_modules/@firebase/messaging/dist/esm/index.esm2017.js + 1 modules
var esm_index_esm2017 = __webpack_require__(30353);
;// CONCATENATED MODULE: ./src/hooks/useFirebase.js





var MARCOM_SERVICE = {
    WEB_REGISTER_TOKEN: "".concat(sysconfig/* MARCOM_API_DOMAIN */.Z3, "/insider/communication/v1/user-token/web-register")
};
var useFirebase = function(user) {
    var firebaseConfig = {
        apiKey: sysconfig/* FIREBASE_API_KEY */.eo,
        authDomain: sysconfig/* FIREBASE_AUTH_DOMAIN */.p7,
        projectId: sysconfig/* FIREBASE_PROJECT_ID */.Fp,
        storageBucket: sysconfig/* FIREBASE_STORAGE_BUCKET */.sj,
        messagingSenderId: sysconfig/* FIREBASE_MESSAGING_SENDER_ID */.i3,
        appId: sysconfig/* FIREBASE_APP_ID */.gF,
        measurementId: sysconfig/* FIREBASE_MEASUREMENT_ID */.qd
    };
    var checkSupportNotification = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var hasFirebaseMessagingSupport, firebaseApp, messaging;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,esm_index_esm2017/* isSupported */.Gb)()
                        ];
                    case 1:
                        hasFirebaseMessagingSupport = _state.sent();
                        if (!hasFirebaseMessagingSupport) return [
                            3,
                            3
                        ];
                        firebaseApp = (0,index_esm2017/* initializeApp */.ZF)(firebaseConfig);
                        messaging = (0,esm_index_esm2017/* getMessaging */.KL)(firebaseApp);
                        return [
                            4,
                            requestPermission(messaging)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function checkSupportNotification() {
            return _ref.apply(this, arguments);
        };
    }();
    var requestPermission = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(messaging) {
            var permission, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if ("serviceWorker" in navigator) {
                            navigator.serviceWorker.ready.then(function(registration) {
                                registration.update();
                            });
                        }
                        if (!("Notification" in window && "permissions" in navigator)) return [
                            3,
                            5
                        ];
                        _tmp = {};
                        return [
                            4,
                            navigator.permissions.query((_tmp.name = "notifications", _tmp))
                        ];
                    case 1:
                        permission = _state.sent();
                        if (!(permission.state === "granted")) return [
                            3,
                            3
                        ];
                        // Permission already granted
                        return [
                            4,
                            registerServiceWorker(messaging)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        if (permission.state === "prompt") {
                            // Permission not granted, show notification prompt
                            Notification.requestPermission().then(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(result) {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!(result === "granted")) return [
                                                    3,
                                                    2
                                                ];
                                                // Permission granted, register service worker and get token
                                                return [
                                                    4,
                                                    registerServiceWorker(messaging)
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    3,
                                                    2
                                                ];
                                            case 2:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(result) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                        } else {
                        // Permission denied
                        // Handle when permission is denied
                        }
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function requestPermission(messaging) {
            return _ref.apply(this, arguments);
        };
    }();
    var registerServiceWorker = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(messaging) {
            var registrations, firebaseMessagingRegistrations, registration, registration1, _tmp, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        if (!("serviceWorker" in navigator)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            navigator.serviceWorker.getRegistrations()
                        ];
                    case 1:
                        registrations = _state.sent();
                        firebaseMessagingRegistrations = registrations.filter(function(registration) {
                            return registration.active && registration.active.scriptURL === sysconfig/* FIREBASE_SW_PATH */._y;
                        });
                        if (!(firebaseMessagingRegistrations.length > 0)) return [
                            3,
                            2
                        ];
                        registration = firebaseMessagingRegistrations[0];
                        registration.update();
                        getTokenUser(messaging, registration);
                        return [
                            3,
                            4
                        ];
                    case 2:
                        _tmp = {};
                        return [
                            4,
                            navigator.serviceWorker.register(sysconfig/* FIREBASE_SW_PATH */._y, (_tmp.updateViaCache = "none", _tmp))
                        ];
                    case 3:
                        registration1 = _state.sent();
                        registration1.onupdatefound = function() {
                            var installingWorker = registration1.installing;
                            if (installingWorker) {
                                installingWorker.onstatechange = function() {
                                    if (installingWorker.state === "activated") {
                                        getTokenUser(messaging, registration1);
                                    }
                                };
                            }
                        };
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        err = _state.sent();
                        console.error("Service worker registration failed: ", err);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function registerServiceWorker(messaging) {
            return _ref.apply(this, arguments);
        };
    }();
    var getTokenUser = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(messaging) {
            var regis, ref, currentToken, _tmp, sessionWRT, response, _tmp1, error;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        regis = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "";
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        if (!("serviceWorker" in navigator && ((ref = navigator.serviceWorker.controller) === null || ref === void 0 ? void 0 : ref.state) === "activated")) return [
                            3,
                            6
                        ];
                        if (!(messaging && user && user.customerID)) return [
                            3,
                            5
                        ];
                        _tmp = {};
                        return [
                            4,
                            (0,esm_index_esm2017/* getToken */.LP)(messaging, (_tmp.serviceWorkerRegistration = regis, _tmp.vapidKey = sysconfig/* FIREBASE_VAPID_KEY */.HB, _tmp))
                        ];
                    case 2:
                        currentToken = _state.sent();
                        sessionWRT = sessionStorage.getItem("WRT");
                        if (!(currentToken && currentToken !== sessionWRT)) return [
                            3,
                            4
                        ];
                        _tmp1 = {};
                        return [
                            4,
                            fetch(MARCOM_SERVICE.WEB_REGISTER_TOKEN, (_tmp1.method = "POST", _tmp1.headers = {
                                "Content-Type": "application/json"
                            }, _tmp1.body = JSON.stringify({
                                projectID: 10001,
                                userUniqueID: user.customerID.toString(),
                                firebaseToken: currentToken,
                                name: user.name,
                                email: user.email,
                                phoneNumber: user.phone
                            }), _tmp1))
                        ];
                    case 3:
                        response = _state.sent();
                        // check response status
                        if (response.status === "OK" || response.status === 200) {
                            // save token to session storage
                            sessionStorage.setItem("WRT", currentToken);
                        } else {
                            console.error("Failed to register token. Status:", response.status);
                        }
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        console.error("User or user.customerID is not defined.");
                        _state.label = 6;
                    case 6:
                        return [
                            3,
                            8
                        ];
                    case 7:
                        error = _state.sent();
                        console.error("An error occurred while processing token:", error);
                        return [
                            3,
                            8
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function getTokenUser(messaging) {
            return _ref.apply(this, arguments);
        };
    }();
    return [
        checkSupportNotification
    ];
};
/* harmony default export */ var hooks_useFirebase = (useFirebase);

// EXTERNAL MODULE: ./src/hooks/useHandleTrial.js
var useHandleTrial = __webpack_require__(59627);
// EXTERNAL MODULE: ./src/hooks/useModal.js
var useModal = __webpack_require__(16028);
// EXTERNAL MODULE: ./src/hooks/useTimeout.ts
var useTimeout = __webpack_require__(46147);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
// EXTERNAL MODULE: ./src/services/AuthService.js + 1 modules
var AuthService = __webpack_require__(23981);
// EXTERNAL MODULE: ./src/utils/CookieParser.js
var CookieParser = __webpack_require__(44777);
// EXTERNAL MODULE: ./src/utils/gtag.js
var gtag = __webpack_require__(57059);
;// CONCATENATED MODULE: ./src/utils/routeHandler.js
/* eslint-disable array-callback-return */ 

// check === sellers?type=all
var isSellerPageTypeAll = function(router) {
    var ref, ref1;
    return Paths/* SELLERS */.UI === router.pathname && ((router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.type) === "all" || (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.type) === "flagship");
};
var isBottomNavigation = function(router) {
    if (isSellerPageTypeAll(router)) return false;
    if (Paths/* BOTTOM_NAVIGATION_PAGES.includes */.xD.includes(router.pathname)) return true;
    return false;
};
var changeParameterUrl = function(router) {
    var query = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, method = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "push", options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        shallow: true
    };
    router[method]({
        pathname: router.route,
        query: (0,_object_spread/* default */.Z)({}, router.query, query),
        options: options
    });
};
// deprecated 22Feb2023 - Dinh Tran
// change parameter without re-render pages (replace)
// export const replaceParams = (query = {}) => {
//   const url = new URL(window.location);
//   if (url) {
//     Object.keys(query).map((q) => {
//       url.searchParams.set(q, query[q]);
//     });
//     window.history.replaceState(null, '', url.toString());
//   }
// };
// change parameter without re-render pages (push)
// export const pushParams = (query = {}) => {
//   const url = new URL(window.location);
//   if (url) {
//     Object.keys(query).map((q) => {
//       url.searchParams.set(q, query[q]);
//     });
//     window.history.pushState(null, '', url.toString());
//   }
// };
/* harmony default export */ var routeHandler = ({
    isBottomNavigation: isBottomNavigation,
    changeParameterUrl: changeParameterUrl
});

// EXTERNAL MODULE: ./src/zustand-lib/storeMobile.js
var storeMobile = __webpack_require__(35810);
// EXTERNAL MODULE: ./src/components/layout/Template/styles.module.css
var Template_styles_module = __webpack_require__(15615);
var Template_styles_module_default = /*#__PURE__*/__webpack_require__.n(Template_styles_module);
;// CONCATENATED MODULE: ./src/components/layout/Template/index.js

































var DELAY_REQUEST_MODAL = 5000;
var Footer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9353), __webpack_require__.e(6719)]).then(__webpack_require__.bind(__webpack_require__, 99353));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99353)
            ];
        }
    },
    ssr: false
});
var CustomModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9542).then(__webpack_require__.bind(__webpack_require__, 39542));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39542)
            ];
        }
    },
    ssr: false
});
var NewRegisterGuestModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1938).then(__webpack_require__.bind(__webpack_require__, 41938));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41938)
            ];
        }
    },
    ssr: false
});
var NewSignInModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6100), __webpack_require__.e(7362), __webpack_require__.e(5094)]).then(__webpack_require__.bind(__webpack_require__, 64924));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64924)
            ];
        }
    },
    ssr: false
});
var NewSignUpModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3998), __webpack_require__.e(1703), __webpack_require__.e(2704), __webpack_require__.e(670)]).then(__webpack_require__.bind(__webpack_require__, 26457));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26457)
            ];
        }
    },
    ssr: false
});
var NewChangePasswordModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(967), __webpack_require__.e(7383)]).then(__webpack_require__.bind(__webpack_require__, 80967));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80967)
            ];
        }
    },
    ssr: false
});
var NewForgetPasswordModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6693), __webpack_require__.e(4629)]).then(__webpack_require__.bind(__webpack_require__, 46693));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46693)
            ];
        }
    },
    ssr: false
});
// modal
var RequestModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2556).then(__webpack_require__.bind(__webpack_require__, 32556));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32556)
            ];
        }
    },
    ssr: false
});
var MobileProdPage = [
    Paths/* PRODUCT_LIST */.ZS,
    "/manufacturers/[slug]",
    "/tag/[slug]"
];
var defaultMV2Options = {
    offHeader: false,
    title: "",
    CustomRightHeader: false,
    offIconRight: false,
    iconRightHeader: {
        // các icon right header muốn hiện (có sắp xếp theo thứ tự)
        chat: true,
        notify: true,
        cart: true,
        userinfo: true,
        toQuickOrder: false,
        home: false
    }
};
// this template is using for PC. mobile v1 and mobile
function Template(param) {
    var _title = param.title, title = _title === void 0 ? "" : _title, children = param.children, pageName = param.pageName, _pageTitle = param.pageTitle, pageTitle = _pageTitle === void 0 ? "" : _pageTitle, _product = param.product, product = _product === void 0 ? "" : _product, _point = param.point, point = _point === void 0 ? 0 : _point, _balance = param.balance, balance = _balance === void 0 ? 0 : _balance, _showTopSearchMV2 = param.showTopSearchMV2, showTopSearchMV2 = _showTopSearchMV2 === void 0 ? false : _showTopSearchMV2, _overrideMV2Options = param.overrideMV2Options, overrideMV2Options = _overrideMV2Options === void 0 ? {} : _overrideMV2Options, _isWebView = param.isWebView, isWebView = _isWebView === void 0 ? false : _isWebView, _isWelcomeBack = param.isWelcomeBack, isWelcomeBack = _isWelcomeBack === void 0 ? false : _isWelcomeBack, _isNewLayout = param.isNewLayout, isNewLayout = _isNewLayout === void 0 ? false : _isNewLayout, _hideFooter = param.hideFooter, hideFooter = _hideFooter === void 0 ? false : _hideFooter, _compactHeader = param.compactHeader, compactHeader = _compactHeader === void 0 ? false : _compactHeader, countdownBarType = param.countdownBarType;
    var ref = (0,Auth/* useAuth */.aC)(), isAuthenticated = ref.isAuthenticated, toggleLogin = ref.toggleLogin, isShowLogin = ref.isShowLogin, handleChangeForget = ref.handleChangeForget, isShowForgetPassword = ref.isShowForgetPassword, toggleForgetPassword = ref.toggleForgetPassword, toggleChangePassword = ref.toggleChangePassword, isShowChangePassword = ref.isShowChangePassword, isShowSignUp = ref.isShowSignUp, toggleSignUp = ref.toggleSignUp, handleChangeSignIn = ref.handleChangeSignIn, handleChangeSignUp = ref.handleChangeSignUp, registerGuest = ref.registerGuest, isShowRegisterGuest = ref.isShowRegisterGuest, toggleRegisterGuest = ref.toggleRegisterGuest, toggleShowGuestExpiredTime = ref.toggleShowGuestExpiredTime, isShowGuestExpiredTime = ref.isShowGuestExpiredTime, isShowForgotPassMess = ref.isShowForgotPassMess, toggleShowForgotPassMess = ref.toggleShowForgotPassMess, toggleShowBlockAccountMess = ref.toggleShowBlockAccountMess, isShowNotFoundAccountMess = ref.isShowNotFoundAccountMess, toggleShowNotFoundAccountMess = ref.toggleShowNotFoundAccountMess, getValShowResponseNotFoundAccountMess = ref.getValShowResponseNotFoundAccountMess, customerInfo = ref.customerInfo, user = ref.user, checkMappingKiotvietIDWithBuymedID = ref.checkMappingKiotvietIDWithBuymedID;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(), 2), openRequestModal = ref1[0], toggleRequestModal = ref1[1];
    var toggleBeta = (0,storeMobile/* default */.Z)(function(state) {
        return state.toggleBeta;
    });
    var canUseMobileV2 = (0,storeGlobal/* useStore */.oR)(function(state) {
        return state.canUseMobileV2;
    });
    var isMobileV2 = (0,storeMobile/* default */.Z)(function(state) {
        return state.isMobileV2();
    });
    var beta = (0,storeMobile/* default */.Z)(function(state) {
        return state.beta;
    });
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(isWelcomeBack), 2), isShowWelcomeBack = ref2[0], toggleShowWelcomeBack = ref2[1];
    var ref3 = (0,CartContext/* useCart */.jD)(), clearCart = ref3.clearCart, isShowModalMax200Item = ref3.isShowModalMax200Item, toggleShowModalMax200Item = ref3.toggleShowModalMax200Item;
    var ref4 = (0,_sliced_to_array/* default */.Z)(hooks_useFirebase(user), 1), checkSupportNotification = ref4[0];
    var _ref = (0,next_router.useRouter)(), push = _ref.push, pathname = _ref.pathname, asPath = _ref.asPath, query = _ref.query, restRouter = (0,_object_without_properties/* default */.Z)(_ref, [
        "push",
        "pathname",
        "asPath",
        "query"
    ]);
    (0,useHandleTrial/* default */.Z)(user, false, toggleBeta, isMobileV2, canUseMobileV2);
    var openModal = function() {
        var IS_SHOW_REQUEST_MODAL = "isShowRequestModal";
        var isShowRequestModal = CookieParser/* default.CookiesParser */.Z.CookiesParser(document.cookie)[IS_SHOW_REQUEST_MODAL];
        // chỉ hiện popup nếu đang ở / hoặc /home , vì các trang /products hiển thị popup thì bot google sẽ lấy content sai
        if (!isAuthenticated && !isShowRequestModal && !isShowLogin && !isShowSignUp && [
            "/",
            "/home"
        ].includes(pathname)) {
            toggleRequestModal();
            document.cookie = "".concat(IS_SHOW_REQUEST_MODAL, "=true;");
        }
    };
    (0,useTimeout/* default */.Z)(openModal, DELAY_REQUEST_MODAL);
    var ref5 = customerInfo || {}, _status = ref5.status, status = _status === void 0 ? "" : _status;
    var mv2Options = {};
    if (beta || pathname === "/conversations") {
        var isBottomNavigation = routeHandler.isBottomNavigation((0,_object_spread/* default */.Z)({
            pathname: pathname,
            asPath: asPath
        }, restRouter));
        if (!overrideMV2Options.iconRightHeader && !isBottomNavigation) {
            mv2Options = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mv2Options), {
                iconRightHeader: {
                    chat: true,
                    cart: true,
                    userinfo: true
                }
            });
        } else {
            mv2Options = (0,_object_spread/* default */.Z)({}, defaultMV2Options, overrideMV2Options);
        }
        mv2Options = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mv2Options), {
            title: (overrideMV2Options === null || overrideMV2Options === void 0 ? void 0 : overrideMV2Options.title) ? overrideMV2Options === null || overrideMV2Options === void 0 ? void 0 : overrideMV2Options.title : pageTitle
        });
    }
    var shouldDisplayAlert = ![
        "conversations",
        "lucky-wheel",
        "dashboard"
    ].includes(pageName);
    (0,react.useEffect)(function() {
        if (!isAuthenticated && isShowGuestExpiredTime) {
            clearCart();
        }
    }, [
        isShowGuestExpiredTime
    ]);
    var notifyWidth = 0;
    if (sysconfig/* NOTIFY_IN_TOP_BAR */.FO) {
        notifyWidth = 0;
    }
    var marginTopForHeader = function() {
        // if (isMobile && beta && MobileProdPage.includes(pathname)) return '48px';
        // if (isMobile && !mv2Options.offHeader) {
        //   if (user?.isCashback) {
        //     return '5px';
        //   }
        //   return '24px';
        // }
        return "0px";
    };
    (0,react.useEffect)(function() {
        if (user) {
            checkSupportNotification();
        }
    }, [
        user
    ]);
    (0,react.useEffect)(function() {
        if ((user === null || user === void 0 ? void 0 : user.customerID) && query.partnerName === ConstantsSignIn/* PARTNER_NAME_KIOTVIET */.yM && query.signature && query.identityId) {
            if (pathname === "/home") {
                AuthService/* default.checkMappingKiotvietIDWithBuymedID */.ZP.checkMappingKiotvietIDWithBuymedID({
                    identityId: query.identityId,
                    partnerName: query.partnerName,
                    signature: query.signature,
                    customerId: user.customerID,
                    accountId: user.accountID
                });
            }
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GuideContext, {
        isMobile: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadPage/* default */.Z, {
                title: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "main",
                className: (0,clsx/* default */.Z)(beta && (Template_styles_module_default()).new_bg_mobile),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                        compact: compactHeader,
                        countdownBarType: countdownBarType
                    }),
                    shouldDisplayAlert && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_AlertSection, {
                        beta: beta,
                        pathname: pathname,
                        isMobile: false,
                        notifyWidth: notifyWidth,
                        marginTopForHeader: function() {
                            return "0px";
                        },
                        isAuthenticated: isAuthenticated,
                        status: status,
                        asPath: asPath,
                        isMobileProdPage: false,
                        isMobileV2: isMobileV2,
                        hasMissingLicenses: !!(user === null || user === void 0 ? void 0 : user.hasMissingLicenses)
                    }),
                    children,
                    !hideFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
                    !isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_google_recaptcha_v3_esm/* GoogleReCaptchaProvider */.pm, {
                                language: "en",
                                reCaptchaKey: sysconfig/* RECAPTCHA_SITE_KEY */.OL,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewSignInModal, {
                                        visible: isShowLogin,
                                        onClose: toggleLogin,
                                        onChangeForget: handleChangeForget,
                                        onChangeSignUp: handleChangeSignUp
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewForgetPasswordModal, {
                                        visible: isShowForgetPassword,
                                        onClose: toggleForgetPassword
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewSignUpModal, {
                                visible: isShowSignUp,
                                onClose: toggleSignUp,
                                onChangeSignIn: handleChangeSignIn,
                                className: "signup-modal"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewRegisterGuestModal, {
                                visible: isShowRegisterGuest,
                                onClose: toggleRegisterGuest,
                                onChangeRegisterGuest: registerGuest
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomModal, {
                                visible: isShowGuestExpiredTime,
                                onClose: toggleShowGuestExpiredTime,
                                content: "Thời gian d\xf9ng thử đ\xe3 hết. Mời bạn vui l\xf2ng tạo t\xe0i khoản để sử dụng hoặc nhắn tin ch\xfang t\xf4i để được hỗ trợ tốt nhất!",
                                btnOkRender: false,
                                btnCloseRender: false,
                                customBtnRender: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Template_styles_module_default()).btngroup,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* ButtonHeader */.X9, {
                                        variant: "contained",
                                        color: "primary",
                                        onClick: toggleSignUp,
                                        children: "Tạo t\xe0i khoản"
                                    })
                                })
                            }),
                            isShowForgotPassMess && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomModal, {
                                visible: isShowForgotPassMess,
                                onClose: toggleShowForgotPassMess,
                                content: "T\xe0i khoản hoặc mật khẩu kh\xf4ng đ\xfang. H\xe3y thử lại hoặc li\xean hệ ".concat(Enums/* BRAND_NAME */.RS, " để được hỗ trợ, xin cảm ơn!"),
                                btnOkRender: false,
                                btnCloseRender: false,
                                customBtnRender: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Template_styles_module_default()).btngroup,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* ButtonHeader */.X9, {
                                        variant: "contained",
                                        color: "primary",
                                        onClick: toggleShowForgotPassMess,
                                        children: "T\xf4i đ\xe3 hiểu"
                                    })
                                })
                            })
                        ]
                    }),
                    isShowNotFoundAccountMess && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomModal, {
                        visible: isShowNotFoundAccountMess,
                        onClose: toggleShowNotFoundAccountMess,
                        content: "Kh\xf4ng t\xecm thấy th\xf4ng tin người d\xf9ng. Li\xean hệ ".concat(Enums/* BRAND_NAME */.RS, " để được hỗ trợ, xin cảm ơn! ").concat(JSON.stringify(getValShowResponseNotFoundAccountMess())),
                        btnOkRender: false,
                        btnCloseRender: false,
                        customBtnRender: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Template_styles_module_default()).btngroup,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* ButtonHeader */.X9, {
                                variant: "contained",
                                color: "primary",
                                onClick: toggleShowBlockAccountMess,
                                children: "T\xf4i đ\xe3 hiểu"
                            })
                        })
                    }),
                    isShowModalMax200Item && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomModal, {
                        visible: isShowModalMax200Item,
                        onClose: toggleShowModalMax200Item,
                        content: "Giỏ h\xe0ng chỉ chứa tối đa 200 mặt h\xe0ng.",
                        btnOkRender: false,
                        btnCloseRender: false,
                        customBtnRender: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Template_styles_module_default()).btngroup,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* ButtonHeader */.X9, {
                                variant: "contained",
                                color: "primary",
                                onClick: toggleShowModalMax200Item,
                                children: "T\xf4i đ\xe3 hiểu"
                            })
                        })
                    }),
                    isWelcomeBack && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomModal, {
                        visible: isShowWelcomeBack,
                        onClose: toggleShowWelcomeBack,
                        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: (0,clsx/* default */.Z)((Template_styles_module_default()).text_modal_welcomeBack),
                                    children: "Ch\xe0o mừng Qu\xfd Kh\xe1ch quay trở lại"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    className: (0,clsx/* default */.Z)((Template_styles_module_default()).text_model_info),
                                    children: [
                                        "Tặng Qu\xfd Kh\xe1ch ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "g\xf3i ưu đ\xe3i 100K"
                                        }),
                                        ", l\xean đơn ngay chỉ trong th\xe1ng n\xe0y!"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: (Template_styles_module_default()).text_model_note,
                                    children: "Lưu \xfd: theo ch\xednh s\xe1ch của thuocsi.vn, t\xe0i khoản sẽ bị kh\xf3a nếu bạn kh\xf4ng đặt đơn h\xe0ng mới trong v\xf2ng 3 th\xe1ng tiếp theo!"
                                })
                            ]
                        }),
                        isWelcomeBack: isWelcomeBack,
                        btnOkRender: false,
                        btnCloseRender: false,
                        customBtnRender: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* ButtonHeader */.X9, {
                                variant: "contained",
                                color: "primary",
                                onClick: function() {
                                    push({
                                        pathname: "/quick-order"
                                    });
                                    toggleShowWelcomeBack();
                                    gtag/* default.clickBtnChurnPopupWeb */.ZP.clickBtnChurnPopupWeb();
                                },
                                children: "Mua ngay"
                            })
                        })
                    }),
                    isAuthenticated && isShowChangePassword && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewChangePasswordModal, {
                        visible: isShowChangePassword,
                        onClose: toggleChangePassword
                    })
                ]
            }),
            !beta && openRequestModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestModal, {
                visible: openRequestModal,
                onClose: toggleRequestModal
            })
        ]
    });
};


/***/ }),

/***/ 87225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GUIDE_FEATURE; },
  "n": function() { return /* binding */ allGuideLine; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/assets/images/promotion/spin_1.png
/* harmony default export */ var spin_1 = ({"src":"https://cdn-web-next-stg.thuocsi.vn/_next/static/media/spin_1.9c1afbe9.png","height":536,"width":1200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAg0lEQVR42g3BMQ4BURQF0Pv+e38mymkkOhKJTmMZYhM2YgV2gFqrsBFRi0RoSSbIfN6/M+cIOv/7YQW+pyJ2gpOUMILFM4C1oSOfavPlcJGplSoayekR3BM69rpcd0/HnCH0ARwzMRbkiUUgCGfWuPTSz/csdJtUb17XFq0YlKbLMipb+c0yEm0d5yYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./src/assets/images/promotion/index.tsx


;// CONCATENATED MODULE: ./src/constants/data/guideline/index.tsx


var GUIDE_FEATURE = {
    COLLECTION_VOUCHER_GUIDE: "COLLECTION_VOUCHER_GUIDE",
    NOTI_RESET_POINT: "NOTI_RESET_POINT",
    PROMO_CODES_GUIDE_SUB_MENU: "PROMO_CODES_GUIDE_SUB_MENU",
    PROMO_CODES_GUIDE_VOUCHER_ME: "PROMO_CODES_GUIDE_VOUCHER_ME",
    PROMO_CODES_GUIDE_VOUCHER_PRODUCT: "PROMO_CODES_GUIDE_VOUCHER_PRODUCT",
    PROMO_CODES_GUIDE_VOUCHER_SELLER: "PROMO_CODES_GUIDE_VOUCHER_SELLER",
    LUCKY_WHEEL: "LUCKY_WHEEL",
    DAILY_CHECKIN: "DAILY_CHECKIN",
    PRODUCT_DETAIL: "PRODUCT_DETAIL",
    SUBSTITUTE_SKU_LIST: "SUBSTITUTE_SKU_LIST",
    SUBSTITUTE_SKU_OTHERS: "SUBSTITUTE_SKU_OTHERS",
    CUSTOMER_CATALOG: "CUSTOMER_CATALOG",
    CART_OPTIMIZE: "CART_OPTIMIZE"
};
var allGuideLine = [
    //   {
    //     page: ['/', '/home'],
    //     localStorageKey: 'home_guide_line',
    //     total: 3,
    //     data: [
    //       {
    //         id: 'step_1',
    //         index: 1,
    //         content: 'Hình ảnh sản phẩm, nút mua hàng được thay đổi vị trí để quý khách hàng có trải nghiệm mua sắm thuận tiện hơn!',
    //         canBack: false
    //       },
    //       {
    //         id: 'step_2',
    //         index: 2,
    //         content: 'Tham gia ngay để có cơ hội trúng hàng ngàn mã giảm giá, điểm tích lũy và quà tặng có giá trị khác!',
    //         canBack: true
    //       },
    //       {
    //         id: 'step_3',
    //         index: 3,
    //         content: 'Bạn có thể nhận được lượt quay miễn phí sau một khoảng thời gian nhất định.',
    //         canBack: true
    //       },
    //     ],
    //   },
    {
        page: [
            "/khuyenmai"
        ],
        localStorageKey: "promotion_guide_line",
        feature: GUIDE_FEATURE.LUCKY_WHEEL,
        isMobile: false,
        data: [
            {
                id: "spin_1",
                image: spin_1,
                category: "sheet",
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "Một minigame ho\xe0n to\xe0n mới tr\xean ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                color: "var(--primary-color)"
                            },
                            children: "thuocsi.vn"
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "Tham gia ngay để c\xf3 cơ hội tr\xfang h\xe0ng ng\xe0n m\xe3 giảm gi\xe1, điểm t\xedch lũy v\xe0 qu\xe0 tặng c\xf3 gi\xe1 trị kh\xe1c. ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "Nhấn ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                color: "#E88438"
                            },
                            children: "bắt đầu"
                        }),
                        " để t\xecm hiểu ngay!"
                    ]
                }),
                delay: 4000,
                canBack: false,
                isArrow: true,
                isScroll: true
            },
            {
                id: "spin_2",
                index: 1,
                category: "spotlight",
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "Để tiến h\xe0nh quay thưởng, bạn c\xf3 thể nhấn v\xe0o n\xfat ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            style: {
                                color: "#000"
                            },
                            children: "QUAY"
                        }),
                        ", số lượt c\xf2n lại sẽ được hiển thị ngay b\xean dưới v\xf2ng quay.",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "Khi hết lượt, n\xfat sẽ đổi th\xe0nh ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            style: {
                                color: "#000"
                            },
                            children: "TH\xcaM LƯỢT"
                        }),
                        " bạn c\xf3 thể bấm v\xe0o để t\xecm kiếm th\xeam lượt."
                    ]
                }),
                canBack: false,
                isArrow: true,
                isScroll: true
            },
            // {
            //   id: 'spin_3',
            //   index: 2,
            //   content: <span>
            //     Bạn có thể nhận được lượt quay miễn phí sau một khoảng thời gian nhất định. Tùy vào chương trình, khoảng thời gian này có thể thay đổi.
            //   </span>,
            //   canBack: true
            // },
            {
                id: "spin_4",
                index: 2,
                subAction: "misson",
                category: "spotlight",
                offsetVertical: 125,
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            style: {
                                color: "#000"
                            },
                            children: "Nhiệm vụ"
                        }),
                        " l\xe0 nơi bạn c\xf3 thể nhận được lượt quay. Ho\xe0n th\xe0nh nhiệm vụ v\xe0 bạn sẽ nhận được những phần thưởng tương ứng."
                    ]
                }),
                canBack: true,
                isScroll: true
            },
            {
                id: "spin_4",
                index: 3,
                subAction: "history",
                category: "spotlight",
                offsetVertical: 125,
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "Bạn c\xf3 thể xem lại c\xe1c phần thưởng đ\xe3 nhận được từ v\xf2ng quay may mắn với ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            style: {
                                color: "#000"
                            },
                            children: "Lịch sử."
                        })
                    ]
                }),
                canBack: true,
                isScroll: false
            },
            {
                id: "spin_4",
                index: 4,
                subAction: "guideline",
                category: "spotlight",
                offsetVertical: 125,
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "Để biết th\xeam th\xf4ng tin chi tiết cũng như thể lệ, quy định trả thưởng của chương tr\xecnh, vui l\xf2ng bấm v\xe0o mục",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            style: {
                                color: "#000"
                            },
                            children: "Hướng dẫn."
                        })
                    ]
                }),
                canBack: true,
                isArrow: true,
                isScroll: false
            }, 
        ]
    },
    {
        page: [
            "/khuyenmai"
        ],
        localStorageKey: "promotion_guide_line",
        feature: GUIDE_FEATURE.LUCKY_WHEEL,
        isMobile: true,
        data: [
            {
                id: "mobile_spin_1",
                image: spin_1,
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "Một minigame ho\xe0n to\xe0n mới tr\xean ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        color: "var(--primary-color)"
                                    },
                                    children: "thuocsi.vn"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Tham gia ngay để c\xf3 cơ hội tr\xfang h\xe0ng ng\xe0n m\xe3 giảm gi\xe1, điểm t\xedch lũy v\xe0 qu\xe0 tặng c\xf3 gi\xe1 trị kh\xe1c."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "Ấn ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        color: "#E88438"
                                    },
                                    children: "Bắt đầu"
                                }),
                                " để t\xecm hiểu ngay!"
                            ]
                        })
                    ]
                }),
                category: "sheet",
                isArrow: true,
                canKnown: true,
                isScroll: true
            },
            {
                id: "mobile_spin_2",
                index: 1,
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        "Để tiến h\xe0nh quay thưởng, bạn c\xf3 thể nhấn v\xe0o n\xfat ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            style: {
                                color: "#000"
                            },
                            children: "QUAY"
                        }),
                        ", số lượt c\xf2n lại sẽ được hiển thị ngay b\xean dưới v\xf2ng quay.",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "Khi hết lượt, n\xfat sẽ đổi th\xe0nh ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            style: {
                                color: "#000"
                            },
                            children: "TH\xcaM LƯỢT"
                        }),
                        " bạn c\xf3 thể bấm v\xe0o để t\xecm kiếm th\xeam lượt."
                    ]
                }),
                category: "spotlight",
                isArrow: true,
                style: {
                    borderRadius: "100%"
                },
                isScroll: true
            },
            // {
            //   id: 'mobile_spin_3',
            //   index: 1,
            //   content:
            //     'Bạn có thể nhận được lượt quay miễn phí sau một khoảng thời gian nhất định. Tùy vào chương trình, khoảng thời gian này có thể thay đổi.',
            //   floaterProps: {
            //     disableAnimation: true,
            //   },
            //   disableBeacon: true,
            //   styles: {
            //     spotlight: {
            //       borderRadius: 12,
            //       padding: 0,
            //     },
            //   },
            //   placement: 'top',
            // },
            {
                id: "mobile_spin_4",
                index: 2,
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                color: "black",
                                fontWeight: 600
                            },
                            children: "Nhiệm vụ"
                        }),
                        " l\xe0 nơi bạn c\xf3 thể nhận được lượt quay. Ho\xe0n th\xe0nh nhiệm vụ v\xe0 bạn sẽ nhận được những phần thưởng tương ứng."
                    ]
                }),
                placement: "top",
                category: "spotlight",
                isArrow: false,
                canBack: true,
                style: {
                    borderColor: "white",
                    borderWidth: 1
                },
                isScroll: true
            },
            {
                id: "mobile_spin_5",
                index: 3,
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        "Bạn c\xf3 thể xem lại c\xe1c phần thưởng đ\xe3 nhận được từ v\xf2ng quay may mắn với ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                color: "black",
                                fontWeight: 600
                            },
                            children: "Lịch sử."
                        })
                    ]
                }),
                placement: "top",
                category: "spotlight",
                isArrow: false,
                canBack: true,
                style: {
                    borderColor: "white",
                    borderWidth: 1
                },
                isScroll: false
            },
            {
                id: "mobile_spin_6",
                index: 4,
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        "Để biết th\xeam th\xf4ng tin chi tiết cũng như thể lệ, quy định trả thưởng của chương tr\xecnh, vui l\xf2ng bấm v\xe0o mục",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                color: "black",
                                fontWeight: 600
                            },
                            children: "Hướng dẫn."
                        })
                    ]
                }),
                placement: "top",
                subAction: "guideline",
                category: "spotlight",
                isArrow: false,
                canBack: true,
                style: {
                    borderColor: "white",
                    borderWidth: 1
                },
                isScroll: false
            }, 
        ]
    },
    {
        page: [
            "/lucky-wheel?source=mobile_app"
        ],
        localStorageKey: "promotion_guide_line_app",
        feature: GUIDE_FEATURE.LUCKY_WHEEL,
        ignoreRecaculate: true,
        isMobile: true,
        data: [
            {
                id: "mobile_spin_1",
                image: spin_1,
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "Một minigame ho\xe0n to\xe0n mới tr\xean ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        color: "var(--primary-color)"
                                    },
                                    children: "thuocsi.vn"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Tham gia ngay để c\xf3 cơ hội tr\xfang h\xe0ng ng\xe0n m\xe3 giảm gi\xe1, điểm t\xedch lũy v\xe0 qu\xe0 tặng c\xf3 gi\xe1 trị kh\xe1c."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "Ấn ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        color: "#E88438"
                                    },
                                    children: "Bắt đầu"
                                }),
                                " để t\xecm hiểu ngay!"
                            ]
                        })
                    ]
                }),
                category: "sheet",
                isArrow: true,
                canKnown: true,
                isScroll: false
            },
            {
                id: "mobile_spin_2",
                index: 1,
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        "Để tiến h\xe0nh quay thưởng, bạn c\xf3 thể nhấn v\xe0o n\xfat ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            style: {
                                color: "#000"
                            },
                            children: "QUAY"
                        }),
                        ", số lượt c\xf2n lại sẽ được hiển thị ngay b\xean dưới v\xf2ng quay.",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "Khi hết lượt, n\xfat sẽ đổi th\xe0nh ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            style: {
                                color: "#000"
                            },
                            children: "TH\xcaM LƯỢT"
                        }),
                        " bạn c\xf3 thể bấm v\xe0o để t\xecm kiếm th\xeam lượt."
                    ]
                }),
                category: "spotlight",
                isArrow: true,
                style: {
                    borderRadius: "100%"
                },
                isScroll: false
            },
            // {
            //   id: 'mobile_spin_3',
            //   index: 1,
            //   content:
            //     'Bạn có thể nhận được lượt quay miễn phí sau một khoảng thời gian nhất định. Tùy vào chương trình, khoảng thời gian này có thể thay đổi.',
            //   floaterProps: {
            //     disableAnimation: true,
            //   },
            //   disableBeacon: true,
            //   styles: {
            //     spotlight: {
            //       borderRadius: 12,
            //       padding: 0,
            //     },
            //   },
            //   placement: 'top',
            // },
            {
                id: "mobile_spin_4",
                index: 2,
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                color: "black",
                                fontWeight: 600
                            },
                            children: "Nhiệm vụ"
                        }),
                        " l\xe0 nơi bạn c\xf3 thể nhận được lượt quay. Ho\xe0n th\xe0nh nhiệm vụ v\xe0 bạn sẽ nhận được những phần thưởng tương ứng."
                    ]
                }),
                placement: "top",
                category: "spotlight",
                isArrow: false,
                canBack: true,
                style: {
                    borderColor: "white",
                    borderWidth: 1
                },
                isScroll: false
            },
            {
                id: "mobile_spin_5",
                index: 3,
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        "Bạn c\xf3 thể xem lại c\xe1c phần thưởng đ\xe3 nhận được từ v\xf2ng quay may mắn với ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                color: "black",
                                fontWeight: 600
                            },
                            children: "Lịch sử."
                        })
                    ]
                }),
                placement: "top",
                category: "spotlight",
                isArrow: false,
                canBack: true,
                style: {
                    borderColor: "white",
                    borderWidth: 1
                },
                isScroll: false
            },
            {
                id: "mobile_spin_6",
                index: 4,
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        "Để biết th\xeam th\xf4ng tin chi tiết cũng như thể lệ, quy định trả thưởng của chương tr\xecnh, vui l\xf2ng bấm v\xe0o mục",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                color: "black",
                                fontWeight: 600
                            },
                            children: "Hướng dẫn."
                        })
                    ]
                }),
                placement: "top",
                subAction: "guideline",
                category: "spotlight",
                isArrow: false,
                canBack: true,
                style: {
                    borderColor: "white",
                    borderWidth: 1
                },
                isScroll: false
            }, 
        ]
    }, 
];


/***/ }),

/***/ 59627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

// const COOKIE_KEY = 'trial_v2';
var useHandleTrial = function(user) {
    var _isMobile = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, toggleBeta = arguments.length > 2 ? arguments[2] : void 0, isMobileV2 = arguments.length > 3 ? arguments[3] : void 0, canUseMobileV2 = arguments.length > 4 ? arguments[4] : void 0;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        (function() {
            if (!user) return;
            if (isMobileV2) return;
            if (canUseMobileV2()) toggleBeta();
        // if (checkNewUser(user?.account?.createdTime)) {
        //   toggleBeta();
        //   return;
        // }
        // chỉ force v2 lần đầu còn các lần sau render theo setting của user
        // const isTrialSelected = checkTrialSelected(user);
        // const isForceV2 = Cookies.get(COOKIE_KEY);
        // if (isTrialSelected && !isForceV2 && isMobile) {
        //   toggleBeta();
        //   Cookies.set(COOKIE_KEY, true, {
        //     domain: GENERAL_DOMAIN,
        //     expires: 180,
        //     sameSite: 'Lax',
        //   });
        // }
        })();
    }, [
        user === null || user === void 0 ? void 0 : user.accountID
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useHandleTrial);


/***/ }),

/***/ 46147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29320);

// See: https://usehooks-ts.com/react-hook/use-isomorphic-layout-effect

function useTimeout(callback, delay) {
    var savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(callback);
    // Remember the latest callback if it changes.
    (0,_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // Set up the timeout.
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // Don't schedule if no delay is specified.
        // Note: 0 is a valid value for delay.
        if (!delay && delay !== 0) {
            return;
        }
        var id = setTimeout(function() {
            return savedCallback.current();
        }, delay);
        // eslint-disable-next-line consistent-return
        return function() {
            return clearTimeout(id);
        };
    }, [
        delay
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useTimeout);


/***/ }),

/***/ 84378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_u": function() { return /* binding */ getWardOptionsByDistrict; },
/* harmony export */   "bI": function() { return /* binding */ getWardsOptionByDistrictNoAuth; },
/* harmony export */   "qL": function() { return /* binding */ getDistrictsOptionsByProvinceNoAuth; },
/* harmony export */   "sJ": function() { return /* binding */ getDistrictOptionsByProvince; }
/* harmony export */ });
/* unused harmony exports getProvinces, getCountriesOption, getMasterAddressString, getMasterAddressObject */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var clients_AddressClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79836);
/* harmony import */ var clients_Clients__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38307);





function getProvinces() {
    return _getProvinces.apply(this, arguments);
}
function _getProvinces() {
    _getProvinces = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var ctx, provincesRes, _tmp, provinces;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : null;
                    _tmp = {};
                    return [
                        4,
                        (0,clients_AddressClient__WEBPACK_IMPORTED_MODULE_0__/* .getAllProvinces */ .lv)((_tmp.ctx = ctx, _tmp))
                    ];
                case 1:
                    provincesRes = _state.sent();
                    if (!(0,clients_Clients__WEBPACK_IMPORTED_MODULE_1__/* .isValid */ .JY)(provincesRes)) {
                        return [
                            2,
                            []
                        ];
                    }
                    provinces = provincesRes.data.map(function(param) {
                        var label = param.name, value = param.code, regionCode = param.regionCode;
                        return {
                            label: label,
                            value: value,
                            regionCode: regionCode
                        };
                    }).sort(function(a, b) {
                        return a.label.localeCompare(b.label);
                    });
                    return [
                        2,
                        provinces
                    ];
            }
        });
    });
    return _getProvinces.apply(this, arguments);
}
function getCountriesOption() {
    return _getCountriesOption.apply(this, arguments);
}
function _getCountriesOption() {
    _getCountriesOption = _async_to_generator(function() {
        var ctx, _tmp, countryRes, _tmp1, countries;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    ctx = (_arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : _tmp).ctx;
                    _tmp1 = {};
                    return [
                        4,
                        getAllCountries((_tmp1.ctx = ctx, _tmp1))
                    ];
                case 1:
                    countryRes = _state.sent();
                    if (!isValid(countryRes)) {
                        return [
                            2,
                            []
                        ];
                    }
                    countries = countryRes.data.map(function(param) {
                        var label = param.name, value = param.code;
                        return {
                            label: label,
                            value: value
                        };
                    }).sort(function(a, b) {
                        return a.label.localeCompare(b.label);
                    });
                    return [
                        2,
                        countries
                    ];
            }
        });
    });
    return _getCountriesOption.apply(this, arguments);
}
function getDistrictsOptionsByProvinceNoAuth(provinceCode, isAuth, isBasic) {
    return _getDistrictsOptionsByProvinceNoAuth.apply(this, arguments);
}
function _getDistrictsOptionsByProvinceNoAuth() {
    _getDistrictsOptionsByProvinceNoAuth = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(provinceCode, isAuth, isBasic) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,clients_AddressClient__WEBPACK_IMPORTED_MODULE_0__/* .getDistrictsByProvince */ .eO)(provinceCode, isAuth, isBasic)
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,clients_Clients__WEBPACK_IMPORTED_MODULE_1__/* .isValid */ .JY)(res)) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        2,
                        res.data.map(function(param) {
                            var label = param.name, value = param.code;
                            return {
                                label: label,
                                value: value
                            };
                        }).sort(function(a, b) {
                            return a.label.localeCompare(b.label);
                        })
                    ];
            }
        });
    });
    return _getDistrictsOptionsByProvinceNoAuth.apply(this, arguments);
}
function getWardsOptionByDistrictNoAuth(districtCode, isAuth, isBasic) {
    return _getWardsOptionByDistrictNoAuth.apply(this, arguments);
}
function _getWardsOptionByDistrictNoAuth() {
    _getWardsOptionByDistrictNoAuth = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(districtCode, isAuth, isBasic) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,clients_AddressClient__WEBPACK_IMPORTED_MODULE_0__/* .getWardsByDistrict */ .yV)(districtCode, isAuth, isBasic)
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,clients_Clients__WEBPACK_IMPORTED_MODULE_1__/* .isValid */ .JY)(res)) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        2,
                        res.data.map(function(param) {
                            var label = param.name, value = param.code;
                            return {
                                label: label,
                                value: value
                            };
                        }).sort(function(a, b) {
                            return a.label.localeCompare(b.label);
                        })
                    ];
            }
        });
    });
    return _getWardsOptionByDistrictNoAuth.apply(this, arguments);
}
function getDistrictOptionsByProvince(provinceCode) {
    return _getDistrictOptionsByProvince.apply(this, arguments);
}
function _getDistrictOptionsByProvince() {
    _getDistrictOptionsByProvince = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(provinceCode) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,clients_AddressClient__WEBPACK_IMPORTED_MODULE_0__/* .getDistrictsByProvince */ .eO)(provinceCode)
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,clients_Clients__WEBPACK_IMPORTED_MODULE_1__/* .isValid */ .JY)(res)) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        2,
                        res.data.map(function(param) {
                            var label = param.name, value = param.code;
                            return {
                                label: label,
                                value: value
                            };
                        }).sort(function(a, b) {
                            return a.label.localeCompare(b.label);
                        })
                    ];
            }
        });
    });
    return _getDistrictOptionsByProvince.apply(this, arguments);
}
function getWardOptionsByDistrict(districtCode) {
    return _getWardOptionsByDistrict.apply(this, arguments);
}
function _getWardOptionsByDistrict() {
    _getWardOptionsByDistrict = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(districtCode) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,clients_AddressClient__WEBPACK_IMPORTED_MODULE_0__/* .getWardsByDistrict */ .yV)(districtCode)
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,clients_Clients__WEBPACK_IMPORTED_MODULE_1__/* .isValid */ .JY)(res)) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        2,
                        res.data.map(function(param) {
                            var label = param.name, value = param.code;
                            return {
                                label: label,
                                value: value
                            };
                        }).sort(function(a, b) {
                            return a.label.localeCompare(b.label);
                        })
                    ];
            }
        });
    });
    return _getWardOptionsByDistrict.apply(this, arguments);
}
function getMasterAddressString(_) {
    return _getMasterAddressString.apply(this, arguments);
}
function _getMasterAddressString() {
    _getMasterAddressString = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param) {
        var ctx, provinceCode, districtCode, wardCode, ref, wardRes, districtRes, provinceRes, _tmp, _tmp1, _tmp2, masterAddress;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, provinceCode = param.provinceCode, districtCode = param.districtCode, wardCode = param.wardCode;
                    _tmp = {};
                    _tmp1 = {};
                    _tmp2 = {};
                    return [
                        4,
                        Promise.all([
                            wardCode && (0,clients_AddressClient__WEBPACK_IMPORTED_MODULE_0__/* .getWardByCode */ .be)((_tmp.ctx = ctx, _tmp.wardCode = wardCode, _tmp)),
                            (0,clients_AddressClient__WEBPACK_IMPORTED_MODULE_0__/* .getDistrictByCode */ .SE)((_tmp1.ctx = ctx, _tmp1.code = districtCode, _tmp1)),
                            (0,clients_AddressClient__WEBPACK_IMPORTED_MODULE_0__/* .getProvinceByCode */ .jw)((_tmp2.ctx = ctx, _tmp2.code = provinceCode, _tmp2))
                        ])
                    ];
                case 1:
                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        3
                    ]), wardRes = ref[0], districtRes = ref[1], provinceRes = ref[2];
                    masterAddress = "";
                    if ((0,clients_Clients__WEBPACK_IMPORTED_MODULE_1__/* .isValid */ .JY)(wardRes)) masterAddress += "".concat((0,clients_Clients__WEBPACK_IMPORTED_MODULE_1__/* .getFirst */ .Xi)(wardRes).name, ", ");
                    if ((0,clients_Clients__WEBPACK_IMPORTED_MODULE_1__/* .isValid */ .JY)(districtRes)) masterAddress += "".concat((0,clients_Clients__WEBPACK_IMPORTED_MODULE_1__/* .getFirst */ .Xi)(districtRes).name, ", ");
                    if ((0,clients_Clients__WEBPACK_IMPORTED_MODULE_1__/* .isValid */ .JY)(provinceRes)) masterAddress += (0,clients_Clients__WEBPACK_IMPORTED_MODULE_1__/* .getFirst */ .Xi)(provinceRes).name;
                    return [
                        2,
                        masterAddress
                    ];
            }
        });
    });
    return _getMasterAddressString.apply(this, arguments);
}
function getMasterAddressObject(_) {
    return _getMasterAddressObject.apply(this, arguments);
}
function _getMasterAddressObject() {
    _getMasterAddressObject = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param) {
        var ctx, provinceCode, districtCode, wardCode, ref, ref1, ref2, ref3, wardRes, districtRes, provinceRes, _tmp, _tmp1, _tmp2, masterAddressObj, _tmp3;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, provinceCode = param.provinceCode, districtCode = param.districtCode, wardCode = param.wardCode;
                    _tmp = {};
                    _tmp1 = {};
                    _tmp2 = {};
                    return [
                        4,
                        Promise.all([
                            wardCode && (0,clients_AddressClient__WEBPACK_IMPORTED_MODULE_0__/* .getWardByCode */ .be)((_tmp.ctx = ctx, _tmp.wardCode = wardCode, _tmp)),
                            (0,clients_AddressClient__WEBPACK_IMPORTED_MODULE_0__/* .getDistrictByCode */ .SE)((_tmp1.ctx = ctx, _tmp1.code = districtCode, _tmp1)),
                            (0,clients_AddressClient__WEBPACK_IMPORTED_MODULE_0__/* .getProvinceByCode */ .jw)((_tmp2.ctx = ctx, _tmp2.code = provinceCode, _tmp2))
                        ])
                    ];
                case 1:
                    ref3 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        3
                    ]), wardRes = ref3[0], districtRes = ref3[1], provinceRes = ref3[2];
                    _tmp3 = {};
                    masterAddressObj = _tmp3;
                    if ((0,clients_Clients__WEBPACK_IMPORTED_MODULE_1__/* .isValid */ .JY)(wardRes)) masterAddressObj.ward = ((ref = (0,clients_Clients__WEBPACK_IMPORTED_MODULE_1__/* .getFirst */ .Xi)(wardRes)) === null || ref === void 0 ? void 0 : ref.name) || "";
                    if ((0,clients_Clients__WEBPACK_IMPORTED_MODULE_1__/* .isValid */ .JY)(districtRes)) masterAddressObj.district = ((ref1 = (0,clients_Clients__WEBPACK_IMPORTED_MODULE_1__/* .getFirst */ .Xi)(districtRes)) === null || ref1 === void 0 ? void 0 : ref1.name) || "";
                    if ((0,clients_Clients__WEBPACK_IMPORTED_MODULE_1__/* .isValid */ .JY)(provinceRes)) masterAddressObj.province = ((ref2 = (0,clients_Clients__WEBPACK_IMPORTED_MODULE_1__/* .getFirst */ .Xi)(provinceRes)) === null || ref2 === void 0 ? void 0 : ref2.name) || "";
                    return [
                        2,
                        masterAddressObj
                    ];
            }
        });
    });
    return _getMasterAddressObject.apply(this, arguments);
}
/* harmony default export */ __webpack_exports__["ZP"] = ({
    getProvinces: getProvinces,
    getMasterAddressString: getMasterAddressString,
    getMasterAddressObject: getMasterAddressObject
});


/***/ }),

/***/ 29455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VB": function() { return /* binding */ updateMeGuide; },
/* harmony export */   "VF": function() { return /* binding */ getListLoyalty; },
/* harmony export */   "iW": function() { return /* binding */ getMeGuide; }
/* harmony export */ });
/* unused harmony exports getReferralList, sendSms, getListAddressLite, getListAddress */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97582);
/* harmony import */ var clients_Clients__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38307);
/* harmony import */ var clients_CustomerClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59261);
/* harmony import */ var clients_PromoClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46128);
/* harmony import */ var constants_Enums_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53208);
/* harmony import */ var utils_DateTimeUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33213);
/* harmony import */ var utils_ValidateUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70220);
/* harmony import */ var _AddressService__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84378);











var getReferralList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(param) {
        var _offset, offset, _limit, limit, params, _tmp, res, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _offset = param.offset, offset = _offset === void 0 ? clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .OFFSET_DEFAULT */ .M6 : _offset, _limit = param.limit, limit = _limit === void 0 ? clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .LIMIT_DEFAULT */ .J0 : _limit;
                    _tmp = {};
                    params = (_tmp.offset = offset, _tmp.limit = limit, _tmp);
                    _tmp1 = {};
                    return [
                        4,
                        (0,clients_CustomerClient__WEBPACK_IMPORTED_MODULE_1__/* .getReferral */ .IF)((_tmp1.params = params, _tmp1))
                    ];
                case 1:
                    res = _state.sent();
                    if ((0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(res)) {
                        res.data = res.data.map(function(referral) {
                            var _lastTimeSendSMS = referral.lastTimeSendSMS, lastTimeSendSMS = _lastTimeSendSMS === void 0 ? null : _lastTimeSendSMS, _smsTotalSent = referral.smsTotalSent, smsTotalSent = _smsTotalSent === void 0 ? 0 : _smsTotalSent, expireTime = referral.expireTime;
                            // check expired
                            if (utils_DateTimeUtils__WEBPACK_IMPORTED_MODULE_4__/* ["default"].compareTime */ .ZP.compareTime(expireTime, Date.now()) < 0) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, referral), {
                                    canResendSMS: false,
                                    message: "Kh\xf4ng thể gửi. Bạn đ\xe3 qu\xe1 thời hạn gửi đến số điện thoại n\xe0y!"
                                });
                            }
                            // check send total
                            if (smsTotalSent >= 5) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, referral), {
                                    canResendSMS: false,
                                    message: "Kh\xf4ng thể gửi. Bạn kh\xf4ng thể gửi qu\xe1 5 lần!"
                                });
                            }
                            // check > 3h
                            var dateLastSend = new Date(lastTimeSendSMS).getTime();
                            var curTime = new Date().getTime();
                            if (curTime - dateLastSend <= 10800000) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, referral), {
                                    canResendSMS: false,
                                    message: "Chưa thể gửi lại. Trong v\xf2ng 3 giờ, bạn chỉ c\xf3 thể gửi 1 tin SMS!"
                                });
                            }
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, referral), {
                                canResendSMS: true
                            });
                        });
                    }
                    return [
                        2,
                        res
                    ];
            }
        });
    });
    return function getReferralList(_) {
        return _ref.apply(this, arguments);
    };
}();
var sendSms = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(param) {
        var phoneNumber, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            phoneNumber = param.phoneNumber;
            _tmp = {};
            if ((0,utils_ValidateUtils__WEBPACK_IMPORTED_MODULE_5__/* .isEmpty */ .xb)(phoneNumber)) {
                return [
                    2,
                    (_tmp.status = constants_Enums_http__WEBPACK_IMPORTED_MODULE_3__/* .HTTP_STATUS.invalid */ .M.invalid, _tmp.msg = "Số điện thoại kh\xf4ng đ\xfang định dạng", _tmp)
                ];
            }
            _tmp1 = {};
            return [
                2,
                (0,clients_CustomerClient__WEBPACK_IMPORTED_MODULE_1__/* .sendSmsToPhone */ .hx)((_tmp1.phoneNumber = phoneNumber, _tmp1))
            ];
        });
    });
    return function sendSms(_) {
        return _ref.apply(this, arguments);
    };
}();
var getListAddressLite = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(param) {
        var ctx, params, res, _tmp, data, addressInfoList;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, params = param.params;
                    _tmp = {};
                    return [
                        4,
                        (0,clients_CustomerClient__WEBPACK_IMPORTED_MODULE_1__/* .getAddressList */ .mZ)((_tmp.ctx = ctx, _tmp.params = params, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(res)) return [
                        2,
                        []
                    ];
                    data = (0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .getData */ .Yu)(res);
                    addressInfoList = data.sort(function(a, b) {
                        return utils_DateTimeUtils__WEBPACK_IMPORTED_MODULE_4__/* ["default"].compareTime */ .ZP.compareTime(a.createdTime, b.createdTime);
                    });
                    return [
                        2,
                        addressInfoList
                    ];
            }
        });
    });
    return function getListAddressLite(_) {
        return _ref.apply(this, arguments);
    };
}();
var getListAddress = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(param) {
        var ctx, params, res, _tmp, data, addressInfoList;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, params = param.params;
                    _tmp = {};
                    return [
                        4,
                        (0,clients_CustomerClient__WEBPACK_IMPORTED_MODULE_1__/* .getAddressList */ .mZ)((_tmp.ctx = ctx, _tmp.params = params, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(res)) return [
                        2,
                        []
                    ];
                    data = (0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .getData */ .Yu)(res);
                    return [
                        4,
                        Promise.all(data.map(function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(info) {
                                var masterAddress, _tmp, _tmp1, _tmp2;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _tmp = {};
                                            return [
                                                4,
                                                _AddressService__WEBPACK_IMPORTED_MODULE_6__/* ["default"].getMasterAddressString */ .ZP.getMasterAddressString((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((_tmp.ctx = ctx, _tmp), info))
                                            ];
                                        case 1:
                                            masterAddress = _state.sent();
                                            _tmp1 = {};
                                            _tmp2 = {};
                                            return [
                                                2,
                                                (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_tmp1, info), (_tmp2.masterAddress = "".concat(info.address, ", ").concat(masterAddress), _tmp2))
                                            ];
                                    }
                                });
                            });
                            return function(info) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 2:
                    addressInfoList = _state.sent();
                    addressInfoList = addressInfoList.sort(function(a, b) {
                        return utils_DateTimeUtils__WEBPACK_IMPORTED_MODULE_4__/* ["default"].compareTime */ .ZP.compareTime(a.createdTime, b.createdTime);
                    });
                    return [
                        2,
                        addressInfoList
                    ];
            }
        });
    });
    return function getListAddress(_) {
        return _ref.apply(this, arguments);
    };
}();
function getListLoyalty() {
    return _getListLoyalty.apply(this, arguments);
}
function _getListLoyalty() {
    _getListLoyalty = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
        var ctx, _tmp, res, loyaltys, promotionIDs, promosResp, _tmp1, promoMap, _tmp2, promos;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    ctx = (_arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : _tmp).ctx;
                    return [
                        4,
                        (0,clients_CustomerClient__WEBPACK_IMPORTED_MODULE_1__/* .getLoyaltyList */ .ff)(ctx)
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(res)) return [
                        2,
                        []
                    ];
                    loyaltys = (0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .getData */ .Yu)(res);
                    promotionIDs = loyaltys.map(function(loyalty) {
                        return loyalty.promotionId;
                    });
                    _tmp1 = {};
                    return [
                        4,
                        (0,clients_PromoClient__WEBPACK_IMPORTED_MODULE_2__/* .getPromotionListByIDs */ .yT)((_tmp1.ctx = ctx, _tmp1.promotionIDs = promotionIDs, _tmp1))
                    ];
                case 2:
                    promosResp = _state.sent();
                    _tmp2 = {};
                    if ((0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(promosResp)) {
                        promoMap = _tmp2;
                        promos = (0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .getData */ .Yu)(promosResp);
                        promos.forEach(function(promo) {
                            promoMap[promo.promotionId] = promo;
                        });
                        loyaltys = loyaltys.map(function(loyalty) {
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, loyalty), {
                                promotion: promoMap[loyalty.promotionId]
                            });
                        }).filter(function(loyalty) {
                            var ref;
                            return utils_DateTimeUtils__WEBPACK_IMPORTED_MODULE_4__/* ["default"].compareTime */ .ZP.compareTime(loyalty === null || loyalty === void 0 ? void 0 : (ref = loyalty.promotion) === null || ref === void 0 ? void 0 : ref.endTime, Date.now()) > 0;
                        }).sort(function(a, b) {
                            return a.point - b.point;
                        });
                    }
                    return [
                        2,
                        loyaltys
                    ];
            }
        });
    });
    return _getListLoyalty.apply(this, arguments);
}
/**
 *
 * @param {string} feature
 * @returns
 */ function getMeGuide(feature) {
    return _getMeGuide.apply(this, arguments);
}
function _getMeGuide() {
    _getMeGuide = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(feature) {
        var ref, res, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        (0,clients_CustomerClient__WEBPACK_IMPORTED_MODULE_1__/* .getUserLogGuide */ .Xd)((_tmp.q = {
                            feature: feature
                        }, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    _tmp1 = {};
                    if (res.status !== "OK") {
                        console.error("[ERROR] Get guide", res);
                        return [
                            2,
                            _tmp1
                        ];
                    }
                    return [
                        2,
                        (ref = res.data) === null || ref === void 0 ? void 0 : ref[0]
                    ];
            }
        });
    });
    return _getMeGuide.apply(this, arguments);
}
/**
 *
 * @param {object} param0
 * @param {string} param0.feature
 * @param {string=} param0.featureName
 * @param {boolean=} param0.isViewAll - true = user have clicked through all the guide
 * @returns
 */ function updateMeGuide(_) {
    return _updateMeGuide.apply(this, arguments);
}
function _updateMeGuide() {
    _updateMeGuide = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(param) {
        var feature, featureName, isViewAll, res, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    feature = param.feature, featureName = param.featureName, isViewAll = param.isViewAll;
                    _tmp = {};
                    return [
                        4,
                        (0,clients_CustomerClient__WEBPACK_IMPORTED_MODULE_1__/* .postUserLogGuide */ .n)((_tmp.feature = feature, _tmp.featureName = featureName, _tmp.isViewAll = isViewAll, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    if (res.status !== "OK") {
                        console.error("[ERROR] update guide", res);
                    }
                    return [
                        2,
                        res
                    ];
            }
        });
    });
    return _updateMeGuide.apply(this, arguments);
}
/* harmony default export */ __webpack_exports__["ZP"] = ({
    getReferralList: getReferralList,
    sendSms: sendSms,
    getListAddress: getListAddress,
    getListAddressLite: getListAddressLite
});


/***/ }),

/***/ 33665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$9": function() { return /* binding */ initFBSharing; },
/* harmony export */   "Eq": function() { return /* binding */ cleanup; },
/* harmony export */   "S1": function() { return /* binding */ init; }
/* harmony export */ });
/* unused harmony exports FBSharePost, FBCheckLogin */
/* harmony import */ var clients_PromoClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46128);
/* harmony import */ var components_v2_mocules_Spinner_interface__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92022);
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66225);
/* harmony import */ var _NotifyUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25872);
/* eslint-disable prefer-arrow-callback */ /* eslint-disable func-names */ /* eslint-disable prefer-const */ /* eslint-disable no-undef */ /**
 *
 * @param {*} noInsertScript
 */ 





var ENUM_LOGIN_STATUS = {
    CONNECTED: "connected",
    NOT_AUTHORIZED: "not_authorized"
};
function init() {
    var chatbox = document.getElementById("fb-customer-chat");
    chatbox.setAttribute("page_id", sysconfig__WEBPACK_IMPORTED_MODULE_2__/* .FACEBOOK_MESSENGER_ID */ .$K); // TODO: move to args
    chatbox.setAttribute("attribution", "biz_inbox");
    window.fbAsyncInit = function() {
        if (FB) FB.init({
            xfbml: true,
            version: "v14.0"
        });
    };
    (function(d, s, id) {
        var js;
        var fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/vi_VN/sdk/xfbml.customerchat.js";
        fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
}
function initFBSharing() {
    var buttonShare = document === null || document === void 0 ? void 0 : document.getElementById("fb-button-share");
    buttonShare === null || buttonShare === void 0 ? void 0 : buttonShare.setAttribute("app_id", sysconfig__WEBPACK_IMPORTED_MODULE_2__/* .FACEBOOK_APP_ID */ .lZ);
    // FB JS SDK config and setup
    window.fbAsyncInit = function() {
        if (FB) {
            FB.init({
                appId: sysconfig__WEBPACK_IMPORTED_MODULE_2__/* .FACEBOOK_APP_ID */ .lZ,
                status: true,
                xfbml: true,
                version: "v3.2"
            });
        }
    };
    (function(d, s, id) {
        var js;
        var fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_GB/all.js#xfbml=1&appId=".concat(sysconfig__WEBPACK_IMPORTED_MODULE_2__/* .FACEBOOK_APP_ID */ .lZ);
        fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
}
function FBSharePost(param) {
    var postInfo = param.postInfo, user = param.user, luckyWheelCode = param.luckyWheelCode, gamificationDetailID = param.gamificationDetailID, reRenderMission = param.reRenderMission;
    var method = postInfo.method, link = postInfo.link;
    var ref = user || {}, accountID = ref.accountID, customerID = ref.customerID;
    function callBackSharing(response) {
        return _callBackSharing.apply(this, arguments);
    }
    function _callBackSharing() {
        _callBackSharing = _async_to_generator(function(response) {
            var _tmp;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(response && !response.error_message)) return [
                            3,
                            3
                        ];
                        if (!(typeof response !== "undefined")) return [
                            3,
                            2
                        ];
                        _tmp = {};
                        return [
                            4,
                            postGamificationScore((_tmp.type = ENUM_CONDITION_TYPE.SHARE, _tmp.customerID = customerID, _tmp.accountID = accountID, _tmp.action = "share facebook post", _tmp.luckyWheelCode = luckyWheelCode, _tmp.gamificationDetailID = gamificationDetailID, _tmp.socialNetwork = ENUM_POPUP_SHARING_ITEM.FACEBOOK, _tmp))
                        ];
                    case 1:
                        _state.sent();
                        NotifyUtils.success("Chia sẻ b\xe0i viết facebook th\xe0nh c\xf4ng!");
                        // re-render list mission
                        reRenderMission();
                        _state.label = 2;
                    case 2:
                        return [
                            3,
                            4
                        ];
                    case 3:
                        NotifyUtils.error("Hệ thống chưa ghi nhận chia sẻ b\xe0i viết! Nếu chưa đăng nhập h\xe3y đăng nhập v\xe0 thử lại");
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _callBackSharing.apply(this, arguments);
    }
    if (FB) {
        FB.ui({
            display: "popup",
            method: method,
            link: link
        }, function() {
            var _ref = // callback
            _async_to_generator(function(response) {
                return _ts_generator(this, function(_state) {
                    callBackSharing(response);
                    return [
                        2
                    ];
                });
            });
            return function(response) {
                return _ref.apply(this, arguments);
            };
        }());
    }
}
function FBCheckLogin(param) {
    var postInfo = param.postInfo, user = param.user, luckyWheelCode = param.luckyWheelCode, gamificationDetailID = param.gamificationDetailID, setOpenConfirmSharing = param.setOpenConfirmSharing, reRenderMission = param.reRenderMission;
    function statusChangeCallback(response) {
        return _statusChangeCallback.apply(this, arguments);
    }
    function _statusChangeCallback() {
        _statusChangeCallback = _async_to_generator(function(response) {
            var _tmp, _tmp1, _tmp2;
            return _ts_generator(this, function(_state) {
                _tmp = {};
                _tmp1 = {};
                _tmp2 = {};
                if (response.status === ENUM_LOGIN_STATUS.CONNECTED) {
                    // user had logged before, show popup sharing post
                    FBSharePost((_tmp.postInfo = postInfo, _tmp.user = user, _tmp.luckyWheelCode = luckyWheelCode, _tmp.gamificationDetailID = gamificationDetailID, _tmp.reRenderMission = reRenderMission, _tmp));
                } else if (response.status === ENUM_LOGIN_STATUS.NOT_AUTHORIZED) {
                    // not authorized, request access permission for user
                    NotifyUtils.info("Vui l\xf2ng cấp quyền chia sẽ b\xe0i viết cho thuocsi.vn !");
                    FB.login(function(response) {
                        if (response.authResponse) {
                            // user have allow access permission
                            setOpenConfirmSharing(true);
                        } else {
                            // user is not logged in
                            NotifyUtils.error("Đăng nhập thất bại! Vui l\xf2ng thử lại.");
                        }
                    }, (_tmp1.scope = "email", _tmp1));
                } else {
                    FB.login(function(response) {
                        if (response.authResponse) {
                            // user have allow access permission
                            setOpenConfirmSharing(true);
                        } else {
                            // user close or not allow
                            NotifyUtils.error("Đăng nhập thất bại! Vui l\xf2ng thử lại.");
                        }
                    }, (_tmp2.scope = "email", _tmp2)); // which data to access from user profile
                }
                return [
                    2
                ];
            });
        });
        return _statusChangeCallback.apply(this, arguments);
    }
    FB.getLoginStatus(function() {
        var _ref = _async_to_generator(function(response) {
            return _ts_generator(this, function(_state) {
                statusChangeCallback(response);
                return [
                    2
                ];
            });
        });
        return function(response) {
            return _ref.apply(this, arguments);
        };
    }(), true);
}
/**
 *
 */ function cleanup() {
    (function(d, id) {
        var target = d.getElementById(id);
        if (target) {
            target.parentNode.removeChild(target);
        }
    })(document, "facebook-jssdk");
    delete window.FB;
}


/***/ }),

/***/ 97504:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"containerToast":"styles_containerToast__V5Z0b","textError":"styles_textError__CBK6A","fullWidth":"styles_fullWidth__M4Zp3","MuiAlert-message":"styles_MuiAlert-message__RXdb0","content":"styles_content__83Z_7"};

/***/ }),

/***/ 14337:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__3IFmZ"};

/***/ }),

/***/ 24908:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sharingContent_wrapper":"styles_sharingContent_wrapper__wEBOD","sharingContent_leftArrow":"styles_sharingContent_leftArrow__5_Nu0","sharingContent_rightArrow":"styles_sharingContent_rightArrow__Yd0W9","sharingItem_container":"styles_sharingItem_container__i986S","sharingContent_listContainer":"styles_sharingContent_listContainer__iDYEv","sharingContent_formControl":"styles_sharingContent_formControl__uzYZy","sharingContent_input":"styles_sharingContent_input__bPY8j","sharingContent_inputFocused":"styles_sharingContent_inputFocused__j5dfD","shareItem_wrapper":"styles_shareItem_wrapper__RGOX4","sharingOpts_removeSlide":"styles_sharingOpts_removeSlide__z5KVx"};

/***/ }),

/***/ 51055:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"itemSharing_wrapper":"styles_itemSharing_wrapper__a9Xtn","itemSharing_block":"styles_itemSharing_block__GPeiL"};

/***/ }),

/***/ 34124:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"drawArrow":"styles_drawArrow__fH4d1","draw":"styles_draw__FnMIF"};

/***/ }),

/***/ 98174:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"canvasContainer":"styles_canvasContainer__yKRUk","luckyWheel_container":"styles_luckyWheel_container__npNTV","mobileSpinner_container":"styles_mobileSpinner_container__dQCi9","mobileSectionWheelTitle_container":"styles_mobileSectionWheelTitle_container__Rcaza","webviewSpinner_container":"styles_webviewSpinner_container__M6_N4","sectionWheelTitle_container":"styles_sectionWheelTitle_container__Vs8Mi","selector_container":"styles_selector_container__ohFIh","result_container":"styles_result_container__x_bGT","borderWheel":"styles_borderWheel__Gkzjk","centerWheel":"styles_centerWheel__59Vqk","fireWork_effect":"styles_fireWork_effect__ooF9B","firework":"styles_firework__vMa1M","btnSpin_container":"styles_btnSpin_container__X34Jp","btnSpin_head":"styles_btnSpin_head__IrKSe","btnSpin_active":"styles_btnSpin_active__OeOXC","btnSpin_bottom":"styles_btnSpin_bottom__s8m1j","btnSpin_containerDisabled":"styles_btnSpin_containerDisabled__P1uyb","iconClose":"styles_iconClose__jgwRw","popupWarning_subTitle":"styles_popupWarning_subTitle__aiSC9","btnClosePopup":"styles_btnClosePopup__yqXqj","btnPopupReset":"styles_btnPopupReset__NPBRV","btnPopupUsing":"styles_btnPopupUsing__pf0VG","drawCanvas_container":"styles_drawCanvas_container__sCx88","popupGotPrize_subTitle":"styles_popupGotPrize_subTitle__Ypyse","mobilePopupGotPrize_subTitle":"styles_mobilePopupGotPrize_subTitle__0w38u","historyBoard":"styles_historyBoard__yR42m","boardContainer":"styles_boardContainer__zIawv","boardGuildLine":"styles_boardGuildLine__uRheO","historyBoard_guildContainer":"styles_historyBoard_guildContainer__ANc_e","historyBoard_guildLineText":"styles_historyBoard_guildLineText__S6u7U","notHasMore":"styles_notHasMore__7nMPH","historyRewardScroll_container":"styles_historyRewardScroll_container__EV1zN","historyReward_loading":"styles_historyReward_loading__Hqd7i","boardContainer_childList":"styles_boardContainer_childList__z_dSB","boardItem_container":"styles_boardItem_container__hETSC","boardMissionItem_container":"styles_boardMissionItem_container__gGIlh","boardItem_imageWrapper":"styles_boardItem_imageWrapper__SaS3p","boardItem_itemName":"styles_boardItem_itemName__UoYXH","boardMissionItem_itemName":"styles_boardMissionItem_itemName__oqy_I","boardItem_created":"styles_boardItem_created__NrbgY","boardMissinItem_btn":"styles_boardMissinItem_btn__DRytF","historyReward":"styles_historyReward___OJAR","active":"styles_active__SEsnH","boxHistoryReward":"styles_boxHistoryReward__J1fDD","guildLine":"styles_guildLine__sc5AW","missionTab":"styles_missionTab__tNym8","wheelTitle_imageWrapper":"styles_wheelTitle_imageWrapper__AaxTp","mobileWheelTitle_imageWrapper":"styles_mobileWheelTitle_imageWrapper___69YR","webViewWheelTitle_imageWrapper":"styles_webViewWheelTitle_imageWrapper__N4I5W","luckyUser_container":"styles_luckyUser_container__S8EP5","mobileLuckyUser_container":"styles_mobileLuckyUser_container__Pv7ju","historyReward_endMessage":"styles_historyReward_endMessage__LYRkt","historyReward_loadingHidden":"styles_historyReward_loadingHidden__2lf_3","countDownTime_container":"styles_countDownTime_container___wJFk","mobileCountDownTime_container":"styles_mobileCountDownTime_container__eMs1s","mobileMenuSection_container":"styles_mobileMenuSection_container__Daw7I","mobileDialogContainer":"styles_mobileDialogContainer__cmPDB","mobilePopupPrize_container":"styles_mobilePopupPrize_container__OIHkx","mobilePopupPrize_wrapper":"styles_mobilePopupPrize_wrapper__GoroH","countDownUser_container":"styles_countDownUser_container__z1mqQ","luckyUser_messageContent":"styles_luckyUser_messageContent__OauNZ","mobileLuckyUser_messageContent":"styles_mobileLuckyUser_messageContent__f4zaJ","luckyUser_containerHidden":"styles_luckyUser_containerHidden__6EKz9","luckyWheel_central":"styles_luckyWheel_central__IDEIo","luckyWheel_borderWheel":"styles_luckyWheel_borderWheel__7OgAG","luckyWheel_selector":"styles_luckyWheel_selector__qG0ne","webViewLuckyWheel_selector":"styles_webViewLuckyWheel_selector__L9iNk","mobileLuckyWheel_central":"styles_mobileLuckyWheel_central__h_2Mu","mobileGroupButton_container":"styles_mobileGroupButton_container__z1J2N","mobileMoreTurn_btn":"styles_mobileMoreTurn_btn__ruudy","mobileNextSpin_btn":"styles_mobileNextSpin_btn__UWiEa","mobileGroupBtn":"styles_mobileGroupBtn__B5BTC","mobileUseNow_btn":"styles_mobileUseNow_btn__eZxRX","processBar_container":"styles_processBar_container__TJWQe","boardItemMission_content":"styles_boardItemMission_content___MS_E","textFixedTurn":"styles_textFixedTurn__Yk_Eg","textFixedTurn_hide":"styles_textFixedTurn_hide__31WbX","webViewLuckyUser_container":"styles_webViewLuckyUser_container__XhR3_","positionArrowEffect":"styles_positionArrowEffect__My69A","glowOnEffect":"styles_glowOnEffect__ZCRhv","glowing":"styles_glowing___k9a2","boardMission_disablesBtn":"styles_boardMission_disablesBtn__GMy1t","fbShareButton_wrapper":"styles_fbShareButton_wrapper__OFObo","fbShareButton_container":"styles_fbShareButton_container__iR3tE","sharingContainer":"styles_sharingContainer__DboSn","sharingPost_button":"styles_sharingPost_button__6ibRM","webViewSharingPost_button":"styles_webViewSharingPost_button__0Q1Gk","btnSharingNow":"styles_btnSharingNow__Ti64z","popupIconClose_container":"styles_popupIconClose_container__UmSkj","hide":"styles_hide__VnXCp","fadeinout":"styles_fadeinout__N3H88","show":"styles_show__gmV3M","display":"styles_display__u_C17","spinnerReward_wrapper":"styles_spinnerReward_wrapper__JFqKZ","guidelineMarker":"styles_guidelineMarker__tYMlb","mobileCountDownTime_content":"styles_mobileCountDownTime_content__YPLSp","wrapGuidelineBox":"styles_wrapGuidelineBox__SCgcp","tempPrizePosition":"styles_tempPrizePosition__zUAZB","tooltipPrizeWrapper":"styles_tooltipPrizeWrapper__24HrG","tooltipImageWrapper":"styles_tooltipImageWrapper__OJ_dE","tooltipPrizeText":"styles_tooltipPrizeText__NXaEr"};

/***/ }),

/***/ 97159:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__9_WC8","btn_next":"styles_btn_next__orSvN","bottom_content":"styles_bottom_content__8grsX","tooltip":"styles_tooltip__1O3jh","arrow-up":"styles_arrow-up__gIa9T","arrow-down":"styles_arrow-down__9KbKX","arrow-right":"styles_arrow-right__KK81b","arrow-left":"styles_arrow-left__dgO5T","content":"styles_content__Y_XEt","wrapper":"styles_wrapper__7wpiV","contentBox":"styles_contentBox__BsDhG","step":"styles_step__HU7i2","bottomTip":"styles_bottomTip__4Dqwr","buttonBack":"styles_buttonBack__IifVN","buttonNext":"styles_buttonNext__zzYI4","boxButton":"styles_boxButton__OCcq1","imageContainer":"styles_imageContainer__wJo1M","imageTitle":"styles_imageTitle__e730y","image":"styles_image__7Sqhp","imageContent":"styles_imageContent__Gq2dt","buttonBox":"styles_buttonBox__XkyjJ","buttonKnown":"styles_buttonKnown__iZ_Us","buttonStart":"styles_buttonStart__qKH7n","buttonClose":"styles_buttonClose__pNVAp","disableLayout":"styles_disableLayout__tBGXG","sheetContainer":"styles_sheetContainer__oeDw2","slideAnimation":"styles_slideAnimation__T1pub","sheetBox":"styles_sheetBox__O3YHy","bottomIndicator":"styles_bottomIndicator__R2UlP","hole":"styles_hole__IVwsp","overlay":"styles_overlay__B1uvQ","progressBar":"styles_progressBar__vQqeY","contentBody":"styles_contentBody__J4lGt","bar":"styles_bar__m0QjM","overlayAnimation":"styles_overlayAnimation__qt7ys"};

/***/ }),

/***/ 15615:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bg_mobile":"styles_bg_mobile__0fHqn","new_bg_mobile":"styles_new_bg_mobile__pah2X","btngroup":"styles_btngroup__x0ZkC","custombtn":"styles_custombtn__BJ8nr","text_modal":"styles_text_modal__U3_8c","appBar":"styles_appBar__Ltgsd","text_modal_welcomeBack":"styles_text_modal_welcomeBack__FM3Ht","text_modal_welcomeBackMobile":"styles_text_modal_welcomeBackMobile__R8iB9","text_model_info":"styles_text_model_info___inUx","text_model_infoMobile":"styles_text_model_infoMobile__r07LA","text_model_note":"styles_text_model_note___vEla"};

/***/ }),

/***/ 55920:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"butonShare_container":"styles_butonShare_container__A7xA_"};

/***/ })

}]);